/* eslint-disable */
// @ts-nocheck
import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
export const AccountBrandPayloadFragmentDoc = gql `
  fragment AccountBrandPayload on AccountBrand {
    primaryColor
    avatar
    logo
    altLogo
  }
`;
export const AccountBasicPayloadFragmentDoc = gql `
  fragment AccountBasicPayload on Account {
    id
    name
    brand {
      ...AccountBrandPayload
    }
    active
  }
  ${AccountBrandPayloadFragmentDoc}
`;
export const AccountExtendedPayloadFragmentDoc = gql `
  fragment AccountExtendedPayload on Account {
    ...AccountBasicPayload
    tos
    permissions
    role
    admin
  }
  ${AccountBasicPayloadFragmentDoc}
`;
export const AccountContactPayloadFragmentDoc = gql `
  fragment AccountContactPayload on AccountContact {
    primary
    billing
    technical
  }
`;
export const AccountSettingsPayloadFragmentDoc = gql `
  fragment AccountSettingsPayload on AccountSettings {
    repositoryViewAllDocs
    documentShareExternalAccountMembers
    refBuilder
    refModification
    refCounter
    createTags
    hiddenCategories
    autoApproveDocPolicy
  }
`;
export const AccountFullPayloadFragmentDoc = gql `
  fragment AccountFullPayload on Account {
    ...AccountExtendedPayload
    metadata
    capabilities
    integrations
    notificationIdentity {
      defaultEmail
      dns
      domain
      verified
    }
    contact {
      ...AccountContactPayload
    }
    createdAt
    settings {
      ...AccountSettingsPayload
    }
    limits
  }
  ${AccountExtendedPayloadFragmentDoc}
  ${AccountContactPayloadFragmentDoc}
  ${AccountSettingsPayloadFragmentDoc}
`;
export const AccountDataStoreBasicPayloadFragmentDoc = gql `
  fragment AccountDataStoreBasicPayload on AccountDataStore {
    variables
  }
`;
export const AccountDataStoreExtendedPayloadFragmentDoc = gql `
  fragment AccountDataStoreExtendedPayload on AccountDataStore {
    ...AccountDataStoreBasicPayload
    updatedAt
  }
  ${AccountDataStoreBasicPayloadFragmentDoc}
`;
export const AccountDataStoreFullPayloadFragmentDoc = gql `
  fragment AccountDataStoreFullPayload on AccountDataStore {
    ...AccountDataStoreExtendedPayload
    metadata
    createdAt
  }
  ${AccountDataStoreExtendedPayloadFragmentDoc}
`;
export const UserPayloadLiteFragmentDoc = gql `
  fragment UserPayloadLite on User {
    avatar
    id
    name
    firstName
    lastName
  }
`;
export const AccountPolicyPayloadLiteFragmentDoc = gql `
  fragment AccountPolicyPayloadLite on AccountPolicy {
    id
    user {
      ...UserPayloadLite
      email
    }
  }
  ${UserPayloadLiteFragmentDoc}
`;
export const AccountRolePayloadLiteFragmentDoc = gql `
  fragment AccountRolePayloadLite on AccountRole {
    id
    name
    global
  }
`;
export const AccountRoleExtendedPayloadFragmentDoc = gql `
  fragment AccountRoleExtendedPayload on AccountRole {
    ...AccountRolePayloadLite
    permissions
  }
  ${AccountRolePayloadLiteFragmentDoc}
`;
export const AccountPolicyExtendedPayloadFragmentDoc = gql `
  fragment AccountPolicyExtendedPayload on AccountPolicy {
    ...AccountPolicyPayloadLite
    role {
      ...AccountRoleExtendedPayload
    }
  }
  ${AccountPolicyPayloadLiteFragmentDoc}
  ${AccountRoleExtendedPayloadFragmentDoc}
`;
export const AccountPolicyPayloadFullFragmentDoc = gql `
  fragment AccountPolicyPayloadFull on AccountPolicy {
    ...AccountPolicyExtendedPayload
    createdAt
    status
    accessedAt
    metadata
  }
  ${AccountPolicyExtendedPayloadFragmentDoc}
`;
export const AccountRolePayloadFullFragmentDoc = gql `
  fragment AccountRolePayloadFull on AccountRole {
    ...AccountRoleExtendedPayload
    object
    metadata
  }
  ${AccountRoleExtendedPayloadFragmentDoc}
`;
export const AccountTokenBasicPayloadFragmentDoc = gql `
  fragment AccountTokenBasicPayload on AccountToken {
    id
    name
    active
  }
`;
export const AccountTokenExtendedPayloadFragmentDoc = gql `
  fragment AccountTokenExtendedPayload on AccountToken {
    ...AccountTokenBasicPayload
    key
  }
  ${AccountTokenBasicPayloadFragmentDoc}
`;
export const AccountTokenFullPayloadFragmentDoc = gql `
  fragment AccountTokenFullPayload on AccountToken {
    ...AccountTokenExtendedPayload
    metadata
    used
    usedAt
    createdAt
  }
  ${AccountTokenExtendedPayloadFragmentDoc}
`;
export const ApprovalSettingsPayloadFragmentDoc = gql `
  fragment ApprovalSettingsPayload on ApprovalSettings {
    allowComment
    allowModification
    allowDownload
  }
`;
export const ApprovalPayloadLiteFragmentDoc = gql `
  fragment ApprovalPayloadLite on Approval {
    id
    firstName
    lastName
    email
    createdAt
    requestedAt
    approvedAt
    rejectedAt
    order
    settings {
      ...ApprovalSettingsPayload
    }
  }
  ${ApprovalSettingsPayloadFragmentDoc}
`;
export const SecureNotificationPayloadStatusFragmentDoc = gql `
  fragment SecureNotificationPayloadStatus on SecureNotification {
    deliveredAt
    failedAt
    openedAt
    sentAt
    status
  }
`;
export const SecureNotificationPayloadLiteFragmentDoc = gql `
  fragment SecureNotificationPayloadLite on SecureNotification {
    id
    name
    lastName
    email
    ...SecureNotificationPayloadStatus
  }
  ${SecureNotificationPayloadStatusFragmentDoc}
`;
export const ApprovalPayloadExtendedFragmentDoc = gql `
  fragment ApprovalPayloadExtended on Approval {
    ...ApprovalPayloadLite
    phone
    message
    notification {
      ...SecureNotificationPayloadLite
    }
  }
  ${ApprovalPayloadLiteFragmentDoc}
  ${SecureNotificationPayloadLiteFragmentDoc}
`;
export const ApprovalPayloadFullFragmentDoc = gql `
  fragment ApprovalPayloadFull on Approval {
    ...ApprovalPayloadExtended
    metadata
  }
  ${ApprovalPayloadExtendedFragmentDoc}
`;
export const ApprovalMessagePayloadLiteFragmentDoc = gql `
  fragment ApprovalMessagePayloadLite on ApprovalMessage {
    id
    message
    type
    createdAt
  }
`;
export const UserExtendedPayloadFragmentDoc = gql `
  fragment UserExtendedPayload on User {
    ...UserPayloadLite
    email
    language
  }
  ${UserPayloadLiteFragmentDoc}
`;
export const ApprovalMessagePayloadExtendedFragmentDoc = gql `
  fragment ApprovalMessagePayloadExtended on ApprovalMessage {
    ...ApprovalMessagePayloadLite
    author {
      ...UserExtendedPayload
    }
    authorEmail
  }
  ${ApprovalMessagePayloadLiteFragmentDoc}
  ${UserExtendedPayloadFragmentDoc}
`;
export const ApprovalMessagePayloadFullFragmentDoc = gql `
  fragment ApprovalMessagePayloadFull on ApprovalMessage {
    ...ApprovalMessagePayloadExtended
    metadata
    updatedAt
  }
  ${ApprovalMessagePayloadExtendedFragmentDoc}
`;
export const AuditPayloadLiteFragmentDoc = gql `
  fragment AuditPayloadLite on Audit {
    createdAt
    eventType
    id
  }
`;
export const AuditAsObjectPayloadFragmentDoc = gql `
  fragment AuditASObjectPayload on AuditASObject {
    context
    id
    type
  }
`;
export const AuditPayloadExtendedFragmentDoc = gql `
  fragment AuditPayloadExtended on Audit {
    ...AuditPayloadLite
    target {
      ...AuditASObjectPayload
    }
    toUser {
      ...UserPayloadLite
    }
    user {
      ...UserPayloadLite
    }
  }
  ${AuditPayloadLiteFragmentDoc}
  ${AuditAsObjectPayloadFragmentDoc}
  ${UserPayloadLiteFragmentDoc}
`;
export const AuditPayloadFullFragmentDoc = gql `
  fragment AuditPayloadFull on Audit {
    ...AuditPayloadExtended
    payload
    document {
      id
      permissions
      role
      access
    }
  }
  ${AuditPayloadExtendedFragmentDoc}
`;
export const CategoryPayloadLiteFragmentDoc = gql `
  fragment CategoryPayloadLite on Category {
    id
    name
    slug
    group
    hidden
  }
`;
export const CategoryExtendedPayloadFragmentDoc = gql `
  fragment CategoryExtendedPayload on Category {
    ...CategoryPayloadLite
    createdAt
    global
  }
  ${CategoryPayloadLiteFragmentDoc}
`;
export const CategoryPayloadFullFragmentDoc = gql `
  fragment CategoryPayloadFull on Category {
    ...CategoryExtendedPayload
    metadata
  }
  ${CategoryExtendedPayloadFragmentDoc}
`;
export const ContactPayloadLiteFragmentDoc = gql `
  fragment ContactPayloadLite on Contact {
    id
    avatar
    name
    email
    createdAt
  }
`;
export const ContactExtendedPayloadFragmentDoc = gql `
  fragment ContactExtendedPayload on Contact {
    ...ContactPayloadLite
    updatedAt
    plainAttributes
    firstName
    lastName
  }
  ${ContactPayloadLiteFragmentDoc}
`;
export const ContactPayloadFullFragmentDoc = gql `
  fragment ContactPayloadFull on Contact {
    ...ContactExtendedPayload
    attributes
  }
  ${ContactExtendedPayloadFragmentDoc}
`;
export const TagPayloadLiteFragmentDoc = gql `
  fragment TagPayloadLite on Tag {
    id
    name
    color
  }
`;
export const DocumentPayloadLiteFragmentDoc = gql `
  fragment DocumentPayloadLite on Document {
    id
    name
    status
    statusChecker
    ragStatus
    approved
    signed
    language
    category {
      ...CategoryPayloadLite
    }
    tags {
      ...TagPayloadLite
    }
  }
  ${CategoryPayloadLiteFragmentDoc}
  ${TagPayloadLiteFragmentDoc}
`;
export const FolderPayloadLiteFragmentDoc = gql `
  fragment FolderPayloadLite on Folder {
    id
    name
    group
  }
`;
export const FolderFieldsPayloadFragmentDoc = gql `
  fragment FolderFieldsPayload on Folder {
    ...FolderPayloadLite
    parent {
      id
    }
  }
  ${FolderPayloadLiteFragmentDoc}
`;
export const FolderExtendedPayloadFragmentDoc = gql `
  fragment FolderExtendedPayload on Folder {
    ...FolderFieldsPayload
    children {
      id
      name
    }
    ancestors {
      root {
        ...FolderPayloadLite
      }
      path {
        ...FolderPayloadLite
      }
      parent {
        ...FolderPayloadLite
      }
    }
  }
  ${FolderFieldsPayloadFragmentDoc}
  ${FolderPayloadLiteFragmentDoc}
`;
export const DocumentExtendedPayloadFragmentDoc = gql `
  fragment DocumentExtendedPayload on Document {
    ...DocumentPayloadLite
    createdAt
    updatedAt
    cancelledAt
    startedAt
    endedAt
    renewal
    ref
    risk
    complexity
    priority
    value
    currency
    archived
    jurisdiction
    variables
    folder {
      ...FolderExtendedPayload
    }
    content {
      pathMerge
      path
      preview
      delimiters
    }
    permissions
    role
    access
  }
  ${DocumentPayloadLiteFragmentDoc}
  ${FolderExtendedPayloadFragmentDoc}
`;
export const DocumentContentPayloadLiteFragmentDoc = gql `
  fragment DocumentContentPayloadLite on DocumentContent {
    id
    thumbnail
    mimetype
    readOnly
    version
    status
  }
`;
export const DocumentSettingsPayloadFragmentDoc = gql `
  fragment DocumentSettingsPayload on DocumentSettings {
    signProcess
    approvalProcess
  }
`;
export const DocumentPayloadFullFragmentDoc = gql `
  fragment DocumentPayloadFull on Document {
    ...DocumentExtendedPayload
    description
    object
    metadata
    content {
      ...DocumentContentPayloadLite
    }
    author {
      ...UserPayloadLite
    }
    account {
      ...AccountExtendedPayload
    }
    settings {
      ...DocumentSettingsPayload
    }
  }
  ${DocumentExtendedPayloadFragmentDoc}
  ${DocumentContentPayloadLiteFragmentDoc}
  ${UserPayloadLiteFragmentDoc}
  ${AccountExtendedPayloadFragmentDoc}
  ${DocumentSettingsPayloadFragmentDoc}
`;
export const DocumentContentExtendedPayloadFragmentDoc = gql `
  fragment DocumentContentExtendedPayload on DocumentContent {
    ...DocumentContentPayloadLite
    name
    createdAt
    updatedAt
    pathMerge
    path
    preview
    signed
    delimiters
  }
  ${DocumentContentPayloadLiteFragmentDoc}
`;
export const VariablePayloadFragmentDoc = gql `
  fragment VariablePayload on Variable {
    id
    name
    val
    key
    options
    deprecated
    type
    auto
    options
    metadata
    required
    approved
  }
`;
export const DocumentContentPayloadFullFragmentDoc = gql `
  fragment DocumentContentPayloadFull on DocumentContent {
    ...DocumentContentExtendedPayload
    variables {
      ...VariablePayload
    }
    metadata
  }
  ${DocumentContentExtendedPayloadFragmentDoc}
  ${VariablePayloadFragmentDoc}
`;
export const DocumentLockedPayloadFullFragmentDoc = gql `
  fragment DocumentLockedPayloadFull on DocumentLocked {
    user {
      ...UserPayloadLite
    }
    lockedAt
    locked
  }
  ${UserPayloadLiteFragmentDoc}
`;
export const DocumentLinkSecurePayloadFragmentDoc = gql `
  fragment DocumentLinkSecurePayload on PublicDocumentLink {
    id
    isExpired
    isSecure
    document {
      id
      name
    }
  }
`;
export const DocumentRolePayloadLiteFragmentDoc = gql `
  fragment DocumentRolePayloadLite on DocumentRole {
    id
    name
    global
  }
`;
export const DocumentLinkPayloadExtendedFragmentDoc = gql `
  fragment DocumentLinkPayloadExtended on DocumentLink {
    id
    name
    expiredAt
    isExpired
    accessedAt
    permissions
    isSecure
    createdAt
    updatedAt
    role {
      ...DocumentRolePayloadLite
    }
  }
  ${DocumentRolePayloadLiteFragmentDoc}
`;
export const DocumentLinkPayloadFullFragmentDoc = gql `
  fragment DocumentLinkPayloadFull on DocumentLink {
    ...DocumentLinkPayloadExtended
    metadata
    document {
      ...DocumentPayloadLite
    }
    denyList
    allowList
  }
  ${DocumentLinkPayloadExtendedFragmentDoc}
  ${DocumentPayloadLiteFragmentDoc}
`;
export const ValidateDocumentLinkPayloadFragmentDoc = gql `
  fragment ValidateDocumentLinkPayload on ValidateAccessDocumentLink {
    accessToken
    refreshToken
  }
`;
export const DocumentPolicyPayloadLiteFragmentDoc = gql `
  fragment DocumentPolicyPayloadLite on DocumentPolicy {
    id
    user {
      ...UserPayloadLite
      email
    }
  }
  ${UserPayloadLiteFragmentDoc}
`;
export const DocumentRoleExtendedPayloadFragmentDoc = gql `
  fragment DocumentRoleExtendedPayload on DocumentRole {
    ...DocumentRolePayloadLite
    permissions
  }
  ${DocumentRolePayloadLiteFragmentDoc}
`;
export const DocumentPolicyExtendedPayloadFragmentDoc = gql `
  fragment DocumentPolicyExtendedPayload on DocumentPolicy {
    ...DocumentPolicyPayloadLite
    role {
      ...DocumentRoleExtendedPayload
    }
    important
    inAccount
  }
  ${DocumentPolicyPayloadLiteFragmentDoc}
  ${DocumentRoleExtendedPayloadFragmentDoc}
`;
export const DocumentPolicyPayloadFullFragmentDoc = gql `
  fragment DocumentPolicyPayloadFull on DocumentPolicy {
    ...DocumentPolicyExtendedPayload
    createdAt
    status
    accessedAt
    metadata
    document {
      id
      permissions
    }
  }
  ${DocumentPolicyExtendedPayloadFragmentDoc}
`;
export const DocumentPolicyPayloadFullSingleFragmentDoc = gql `
  fragment DocumentPolicyPayloadFullSingle on DocumentPolicy {
    ...DocumentPolicyPayloadFull
    subscribe
    note
  }
  ${DocumentPolicyPayloadFullFragmentDoc}
`;
export const TemplatePayloadLiteFragmentDoc = gql `
  fragment TemplatePayloadLite on Template {
    id
    name
    published
    language
    category {
      ...CategoryPayloadLite
    }
    tags {
      ...TagPayloadLite
    }
  }
  ${CategoryPayloadLiteFragmentDoc}
  ${TagPayloadLiteFragmentDoc}
`;
export const DocumentRelationPayloadLiteFragmentDoc = gql `
  fragment DocumentRelationPayloadLite on DocumentRelation {
    id
    from {
      ... on Template {
        ...TemplatePayloadLite
        object
        permissions
        access
      }
      ... on Document {
        ...DocumentPayloadLite
        object
        permissions
        access
        content {
          preview
          signed
        }
      }
    }
    to {
      ... on Template {
        ...TemplatePayloadLite
        object
        permissions
        access
      }
      ... on Document {
        ...DocumentPayloadLite
        object
        permissions
        access
        content {
          preview
          signed
        }
      }
    }
    type
  }
  ${TemplatePayloadLiteFragmentDoc}
  ${DocumentPayloadLiteFragmentDoc}
`;
export const DocumentRelationExtendedPayloadFragmentDoc = gql `
  fragment DocumentRelationExtendedPayload on DocumentRelation {
    ...DocumentRelationPayloadLite
    updatedAt
    createdAt
  }
  ${DocumentRelationPayloadLiteFragmentDoc}
`;
export const DocumentRelationPayloadFullFragmentDoc = gql `
  fragment DocumentRelationPayloadFull on DocumentRelation {
    ...DocumentRelationExtendedPayload
    metadata
  }
  ${DocumentRelationExtendedPayloadFragmentDoc}
`;
export const DocumentRolePayloadFullFragmentDoc = gql `
  fragment DocumentRolePayloadFull on DocumentRole {
    ...DocumentRoleExtendedPayload
    object
    metadata
  }
  ${DocumentRoleExtendedPayloadFragmentDoc}
`;
export const FolderPayloadFullFragmentDoc = gql `
  fragment FolderPayloadFull on Folder {
    ...FolderExtendedPayload
  }
  ${FolderExtendedPayloadFragmentDoc}
`;
export const FormFlowOptionPayloadFragmentDoc = gql `
  fragment FormFlowOptionPayload on FormFlowOption {
    bgColor
    bgImage
    mainTextColor
    secondaryTextColor
    tertiaryTextColor
    mainAccentColor
    redirectUrl
    allowDownload
    hideBranding
    hideLogo
    progressBar
    navigationArrows
  }
`;
export const FormFlowPayloadLiteFragmentDoc = gql `
  fragment FormFlowPayloadLite on FormFlow {
    id
    name
    slug
    description
    default
    active
    options {
      ...FormFlowOptionPayload
    }
    activeQuestions
  }
  ${FormFlowOptionPayloadFragmentDoc}
`;
export const FormFlowPayloadFullFragmentDoc = gql `
  fragment FormFlowPayloadFull on FormFlow {
    ...FormFlowPayloadLite
    questions
    maxQuestions
    metadata
  }
  ${FormFlowPayloadLiteFragmentDoc}
`;
export const FormFlowShareSecurePayloadFragmentDoc = gql `
  fragment FormFlowShareSecurePayload on FormFlowShareSecure {
    id
    secured
    public
    code
    name
    description
    account
  }
`;
export const FormFlowShareOptionPayloadFragmentDoc = gql `
  fragment FormFlowShareOptionPayload on FormFlowShareOption {
    sendCopyCompletedDocument
    customMessage
  }
`;
export const FormFlowSharePayloadExtendedFragmentDoc = gql `
  fragment FormFlowSharePayloadExtended on FormFlowShare {
    id
    secured
    public
    createdAt
    updatedAt
    active
    expiredAt
    email
    options {
      ...FormFlowShareOptionPayload
    }
  }
  ${FormFlowShareOptionPayloadFragmentDoc}
`;
export const FormFlowPayloadViewerFragmentDoc = gql `
  fragment FormFlowPayloadViewer on FormFlow {
    id
    active
    options {
      ...FormFlowOptionPayload
    }
    activeQuestions
  }
  ${FormFlowOptionPayloadFragmentDoc}
`;
export const FormFlowSharePayloadFullFragmentDoc = gql `
  fragment FormFlowSharePayloadFull on FormFlowShare {
    ...FormFlowSharePayloadExtended
    metadata
    formFlow {
      ...FormFlowPayloadViewer
    }
  }
  ${FormFlowSharePayloadExtendedFragmentDoc}
  ${FormFlowPayloadViewerFragmentDoc}
`;
export const IntakeOptionPayloadFragmentDoc = gql `
  fragment IntakeOptionPayload on IntakeOption {
    actions
  }
`;
export const IntakePayloadLiteFragmentDoc = gql `
  fragment IntakePayloadLite on Intake {
    id
    name
    slug
    description
    default
    active
    activeQuestions
    activeTheme
    options {
      ...IntakeOptionPayload
    }
  }
  ${IntakeOptionPayloadFragmentDoc}
`;
export const IntakePayloadFullFragmentDoc = gql `
  fragment IntakePayloadFull on Intake {
    ...IntakePayloadLite
    questions
    theme
    metadata
  }
  ${IntakePayloadLiteFragmentDoc}
`;
export const IntakeResponsePayloadLiteFragmentDoc = gql `
  fragment IntakeResponsePayloadLite on IntakeResponse {
    id
    result
    createdAt
  }
`;
export const IntakeResponsePayloadExtendedFragmentDoc = gql `
  fragment IntakeResponsePayloadExtended on IntakeResponse {
    ...IntakeResponsePayloadLite
    updatedAt
    contact {
      ...ContactPayloadLite
    }
  }
  ${IntakeResponsePayloadLiteFragmentDoc}
  ${ContactPayloadLiteFragmentDoc}
`;
export const IntakeResponsePayloadFullFragmentDoc = gql `
  fragment IntakeResponsePayloadFull on IntakeResponse {
    ...IntakeResponsePayloadExtended
    metadata
    intake {
      ...IntakePayloadLite
    }
  }
  ${IntakeResponsePayloadExtendedFragmentDoc}
  ${IntakePayloadLiteFragmentDoc}
`;
export const IntakeShareSecurePayloadFragmentDoc = gql `
  fragment IntakeShareSecurePayload on IntakeShareSecure {
    id
    slug
    secured
    public
    code
    name
    description
    account
  }
`;
export const IntakeShareOptionPayloadFragmentDoc = gql `
  fragment IntakeShareOptionPayload on IntakeShareOption {
    sendCopyCompletedDocument
    customMessage
  }
`;
export const IntakeSharePayloadExtendedFragmentDoc = gql `
  fragment IntakeSharePayloadExtended on IntakeShare {
    id
    slug
    secured
    public
    createdAt
    updatedAt
    active
    expiredAt
    email
    options {
      ...IntakeShareOptionPayload
    }
  }
  ${IntakeShareOptionPayloadFragmentDoc}
`;
export const IntakePayloadViewerFragmentDoc = gql `
  fragment IntakePayloadViewer on Intake {
    id
    active
    activeQuestions
    activeTheme
  }
`;
export const IntakeSharePayloadFullFragmentDoc = gql `
  fragment IntakeSharePayloadFull on IntakeShare {
    ...IntakeSharePayloadExtended
    metadata
    intake {
      ...IntakePayloadViewer
    }
  }
  ${IntakeSharePayloadExtendedFragmentDoc}
  ${IntakePayloadViewerFragmentDoc}
`;
export const AccountIntegrationPayloadLiteFragmentDoc = gql `
  fragment AccountIntegrationPayloadLite on AccountIntegration {
    id
    active
    integration {
      id
    }
  }
`;
export const AccountIntegrationPayloadExtendedFragmentDoc = gql `
  fragment AccountIntegrationPayloadExtended on AccountIntegration {
    ...AccountIntegrationPayloadLite
    apiKey
  }
  ${AccountIntegrationPayloadLiteFragmentDoc}
`;
export const AccountIntegrationPayloadFullFragmentDoc = gql `
  fragment AccountIntegrationPayloadFull on AccountIntegration {
    ...AccountIntegrationPayloadExtended
    metadata
    options
    integration {
      id
      config {
        credentials
        properties
      }
    }
  }
  ${AccountIntegrationPayloadExtendedFragmentDoc}
`;
export const IntegrationPayloadLiteFragmentDoc = gql `
  fragment IntegrationPayloadLite on Integration {
    id
    name
    key
    avatar
  }
`;
export const IntegrationPayloadExtendedFragmentDoc = gql `
  fragment IntegrationPayloadExtended on Integration {
    ...IntegrationPayloadLite
    categories
    groups
  }
  ${IntegrationPayloadLiteFragmentDoc}
`;
export const IntegrationPayloadFullFragmentDoc = gql `
  fragment IntegrationPayloadFull on Integration {
    ...IntegrationPayloadExtended
    subtitle
    title
    config {
      beta
      properties
      credentials
      credentialsOptions
    }
  }
  ${IntegrationPayloadExtendedFragmentDoc}
`;
export const MarketplaceItemPayloadLiteFragmentDoc = gql `
  fragment MarketplaceItemPayloadLite on MarketplaceItem {
    id
    title
    cover
    description
  }
`;
export const MarketplaceItemExtendedPayloadFragmentDoc = gql `
  fragment MarketplaceItemExtendedPayload on MarketplaceItem {
    ...MarketplaceItemPayloadLite
    createdAt
    updatedAt
    tags
  }
  ${MarketplaceItemPayloadLiteFragmentDoc}
`;
export const MarketplaceItemPayloadFullFragmentDoc = gql `
  fragment MarketplaceItemPayloadFull on MarketplaceItem {
    ...MarketplaceItemExtendedPayload
    metadata
    counter
    value
    currency
    approve
    account {
      ...AccountBasicPayload
    }
  }
  ${MarketplaceItemExtendedPayloadFragmentDoc}
  ${AccountBasicPayloadFragmentDoc}
`;
export const OrganizationPayloadLiteFragmentDoc = gql `
  fragment OrganizationPayloadLite on Organization {
    id
    avatar
    name
    createdAt
  }
`;
export const OrganizationExtendedPayloadFragmentDoc = gql `
  fragment OrganizationExtendedPayload on Organization {
    ...OrganizationPayloadLite
    updatedAt
    plainAttributes
    registrationId
    alias
  }
  ${OrganizationPayloadLiteFragmentDoc}
`;
export const OrganizationPayloadFullFragmentDoc = gql `
  fragment OrganizationPayloadFull on Organization {
    ...OrganizationExtendedPayload
    attributes
  }
  ${OrganizationExtendedPayloadFragmentDoc}
`;
export const PartyPayloadLiteFragmentDoc = gql `
  fragment PartyPayloadLite on Party {
    id
    name
    type
  }
`;
export const PartyPayloadExtendedFragmentDoc = gql `
  fragment PartyPayloadExtended on Party {
    ...PartyPayloadLite
    order
  }
  ${PartyPayloadLiteFragmentDoc}
`;
export const PartyPayloadFullFragmentDoc = gql `
  fragment PartyPayloadFull on Party {
    ...PartyPayloadExtended
    metadata
  }
  ${PartyPayloadExtendedFragmentDoc}
`;
export const ProductPayloadLiteFragmentDoc = gql `
  fragment ProductPayloadLite on Product {
    id
    name
    slug
    position
    active
  }
`;
export const ProductPayloadExtendedFragmentDoc = gql `
  fragment ProductPayloadExtended on Product {
    ...ProductPayloadLite
    limits
    capabilities
    metadata
    upgradeProduct {
      ...ProductPayloadLite
    }
  }
  ${ProductPayloadLiteFragmentDoc}
`;
export const ProductPayloadFullFragmentDoc = gql `
  fragment ProductPayloadFull on Product {
    ...ProductPayloadExtended
    description
    createdAt
    default
    updatedAt
  }
  ${ProductPayloadExtendedFragmentDoc}
`;
export const ProfileRelationPayloadLiteFragmentDoc = gql `
  fragment ProfileRelationPayloadLite on ProfileRelation {
    id
    from {
      ... on Contact {
        ...ContactPayloadLite
        object
      }
      ... on Organization {
        ...OrganizationPayloadLite
        object
      }
    }
    to {
      ... on Contact {
        ...ContactPayloadLite
        object
      }
      ... on Organization {
        ...OrganizationPayloadLite
        object
      }
    }
    type
  }
  ${ContactPayloadLiteFragmentDoc}
  ${OrganizationPayloadLiteFragmentDoc}
`;
export const ProfileRelationExtendedPayloadFragmentDoc = gql `
  fragment ProfileRelationExtendedPayload on ProfileRelation {
    ...ProfileRelationPayloadLite
    document {
      ...DocumentPayloadLite
      permissions
      access
    }
    updatedAt
    createdAt
  }
  ${ProfileRelationPayloadLiteFragmentDoc}
  ${DocumentPayloadLiteFragmentDoc}
`;
export const ProfileRelationPayloadFullFragmentDoc = gql `
  fragment ProfileRelationPayloadFull on ProfileRelation {
    ...ProfileRelationExtendedPayload
    metadata
  }
  ${ProfileRelationExtendedPayloadFragmentDoc}
`;
export const ReminderContactPayloadFragmentDoc = gql `
  fragment ReminderContactPayload on ReminderContact {
    id
    name
    firstName
    lastName
    email
    phone
    avatar
    notification {
      ...SecureNotificationPayloadStatus
    }
  }
  ${SecureNotificationPayloadStatusFragmentDoc}
`;
export const ReminderPayloadLiteFragmentDoc = gql `
  fragment ReminderPayloadLite on Reminder {
    id
    notifyAt
    notifiedAt
    name
    contacts {
      ...ReminderContactPayload
    }
  }
  ${ReminderContactPayloadFragmentDoc}
`;
export const ReminderPayloadExtendedFragmentDoc = gql `
  fragment ReminderPayloadExtended on Reminder {
    ...ReminderPayloadLite
    description
  }
  ${ReminderPayloadLiteFragmentDoc}
`;
export const ReminderPayloadFullFragmentDoc = gql `
  fragment ReminderPayloadFull on Reminder {
    ...ReminderPayloadExtended
    metadata
  }
  ${ReminderPayloadExtendedFragmentDoc}
`;
export const ActionNodeRulePayloadFragmentDoc = gql `
  fragment ActionNodeRulePayload on ActionNodeRule {
    id
    domain
    icon
    name
    schema
    capabilities
    config
  }
`;
export const RulePayloadLiteFragmentDoc = gql `
  fragment RulePayloadLite on Rule {
    id
    name
    tags
    active
    description
    createdAt
  }
`;
export const RuleExtendedPayloadFragmentDoc = gql `
  fragment RuleExtendedPayload on Rule {
    ...RulePayloadLite
    updatedAt
    cron
  }
  ${RulePayloadLiteFragmentDoc}
`;
export const ActionRulePayloadFragmentDoc = gql `
  fragment ActionRulePayload on ActionRule {
    id
    node
    cb
    params
    config
  }
`;
export const RulePayloadFullFragmentDoc = gql `
  fragment RulePayloadFull on Rule {
    ...RuleExtendedPayload
    events
    actions {
      ...ActionRulePayload
    }
    trigger
    metadata
  }
  ${RuleExtendedPayloadFragmentDoc}
  ${ActionRulePayloadFragmentDoc}
`;
export const SecureNotificationPayloadExtendedFragmentDoc = gql `
  fragment SecureNotificationPayloadExtended on SecureNotification {
    ...SecureNotificationPayloadLite
  }
  ${SecureNotificationPayloadLiteFragmentDoc}
`;
export const SecureNotificationPayloadFullFragmentDoc = gql `
  fragment SecureNotificationPayloadFull on SecureNotification {
    ...SecureNotificationPayloadExtended
    history
    metadata
  }
  ${SecureNotificationPayloadExtendedFragmentDoc}
`;
export const SignatureSettingsPayloadFragmentDoc = gql `
  fragment SignatureSettingsPayload on SignatureSettings {
    allowBiometric
    allowCertificate
    allowDownload
    rubricAllPages
    sendReminders
    allowApprovals
  }
`;
export const SignaturePayloadLiteFragmentDoc = gql `
  fragment SignaturePayloadLite on Signature {
    id
    firstName
    lastName
    email
    createdAt
    requestedAt
    signedAt
    order
    settings {
      ...SignatureSettingsPayload
    }
  }
  ${SignatureSettingsPayloadFragmentDoc}
`;
export const SignaturePayloadExtendedFragmentDoc = gql `
  fragment SignaturePayloadExtended on Signature {
    ...SignaturePayloadLite
    idNumber
    phone
    message
    image
    notification {
      ...SecureNotificationPayloadLite
    }
  }
  ${SignaturePayloadLiteFragmentDoc}
  ${SecureNotificationPayloadLiteFragmentDoc}
`;
export const SignaturePayloadFullFragmentDoc = gql `
  fragment SignaturePayloadFull on Signature {
    ...SignaturePayloadExtended
    metadata
  }
  ${SignaturePayloadExtendedFragmentDoc}
`;
export const SignaturePlaceholderPayloadFullFragmentDoc = gql `
  fragment SignaturePlaceholderPayloadFull on SignaturePlaceholder {
    id
    keyName
    createdAt
    message
    metadata
    order
    settings {
      ...SignatureSettingsPayload
    }
  }
  ${SignatureSettingsPayloadFragmentDoc}
`;
export const SubscriptionProductPayloadLiteFragmentDoc = gql `
  fragment SubscriptionProductPayloadLite on SubscriptionProduct {
    id
    status
  }
`;
export const SubscriptionProductPayloadExtendedFragmentDoc = gql `
  fragment SubscriptionProductPayloadExtended on SubscriptionProduct {
    ...SubscriptionProductPayloadLite
    endsAt
    quantity
  }
  ${SubscriptionProductPayloadLiteFragmentDoc}
`;
export const SubscriptionProductPayloadFullFragmentDoc = gql `
  fragment SubscriptionProductPayloadFull on SubscriptionProduct {
    ...SubscriptionProductPayloadExtended
    cancelAtPeriodEnds
    startedAt
    cancelledAt
    capabilities
    limits
  }
  ${SubscriptionProductPayloadExtendedFragmentDoc}
`;
export const TagExtendedPayloadFragmentDoc = gql `
  fragment TagExtendedPayload on Tag {
    ...TagPayloadLite
    createdAt
    updatedAt
    count
  }
  ${TagPayloadLiteFragmentDoc}
`;
export const TagPayloadFullFragmentDoc = gql `
  fragment TagPayloadFull on Tag {
    ...TagExtendedPayload
    metadata
  }
  ${TagExtendedPayloadFragmentDoc}
`;
export const TemplateExtendedPayloadFragmentDoc = gql `
  fragment TemplateExtendedPayload on Template {
    ...TemplatePayloadLite
    updatedAt
    folder {
      ...FolderExtendedPayload
    }
    status
    content {
      pathMerge
      path
      preview
      delimiters
    }
    permissions
    role
    access
  }
  ${TemplatePayloadLiteFragmentDoc}
  ${FolderExtendedPayloadFragmentDoc}
`;
export const TemplatePayloadFullFragmentDoc = gql `
  fragment TemplatePayloadFull on Template {
    ...TemplateExtendedPayload
    createdAt
    jurisdiction
    description
    metadata
    value
    currency
    content {
      ...DocumentContentPayloadLite
    }
    account {
      ...AccountExtendedPayload
    }
    author {
      ...UserPayloadLite
    }
    settings {
      ...DocumentSettingsPayload
    }
  }
  ${TemplateExtendedPayloadFragmentDoc}
  ${DocumentContentPayloadLiteFragmentDoc}
  ${AccountExtendedPayloadFragmentDoc}
  ${UserPayloadLiteFragmentDoc}
  ${DocumentSettingsPayloadFragmentDoc}
`;
export const TicketPayloadLiteFragmentDoc = gql `
  fragment TicketPayloadLite on Ticket {
    id
    name
    status
    statusChecker
    ragStatus
    language
    category {
      ...CategoryPayloadLite
    }
    tags {
      ...TagPayloadLite
    }
    requester
  }
  ${CategoryPayloadLiteFragmentDoc}
  ${TagPayloadLiteFragmentDoc}
`;
export const TicketExtendedPayloadFragmentDoc = gql `
  fragment TicketExtendedPayload on Ticket {
    ...TicketPayloadLite
    createdAt
    updatedAt
    dueDateAt
    ref
    description
    complexity
    priority
    archived
    variables
    assignee {
      ...UserExtendedPayload
    }
  }
  ${TicketPayloadLiteFragmentDoc}
  ${UserExtendedPayloadFragmentDoc}
`;
export const TicketSettingsPayloadFragmentDoc = gql `
  fragment TicketSettingsPayload on TicketSettings {
    autoClosure
  }
`;
export const TicketPayloadFullFragmentDoc = gql `
  fragment TicketPayloadFull on Ticket {
    ...TicketExtendedPayload
    object
    metadata
    account {
      ...AccountExtendedPayload
    }
    settings {
      ...TicketSettingsPayload
    }
  }
  ${TicketExtendedPayloadFragmentDoc}
  ${AccountExtendedPayloadFragmentDoc}
  ${TicketSettingsPayloadFragmentDoc}
`;
export const EmailPreferencesPayloadFragmentDoc = gql `
  fragment EmailPreferencesPayload on UserEmailPreferences {
    successApprovals
    docSigned
    signs
    tips
  }
`;
export const UserPayloadFullFragmentDoc = gql `
  fragment UserPayloadFull on User {
    ...UserExtendedPayload
    createdAt
    emailVerified
    emailPreferences {
      ...EmailPreferencesPayload
    }
    timezone
    metadata
    tos
    hasPassword
    signatureEmail
    internal
  }
  ${UserExtendedPayloadFragmentDoc}
  ${EmailPreferencesPayloadFragmentDoc}
`;
export const MetadataInputFragmentDoc = gql `
  fragment MetadataInput on User {
    metadata
  }
`;
export const WebhookPayloadFullFragmentDoc = gql `
  fragment WebhookPayloadFull on Webhook {
    url
    eventTypes
    headers
    id
    metadata
  }
`;
export const RetrieveAccountDocument = gql `
  query retrieveAccount {
    retrieveAccount {
      ...AccountFullPayload
    }
  }
  ${AccountFullPayloadFragmentDoc}
`;
/**
 * __useRetrieveAccountQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAccountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAccountQuery();
 */
export function useRetrieveAccountQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveAccountDocument, {}, options);
}
export function useRetrieveAccountLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAccountDocument, {}, options);
}
export const RetrieveAccountIdDocument = gql `
  query retrieveAccountId($name: String!) {
    retrieveAccountId(name: $name)
  }
`;
/**
 * __useRetrieveAccountIdQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAccountIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAccountIdQuery({
 *   name: // value for 'name'
 * });
 */
export function useRetrieveAccountIdQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveAccountIdDocument, variables, options);
}
export function useRetrieveAccountIdLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAccountIdDocument, variables, options);
}
export const UpdateAccountDocument = gql `
  mutation updateAccount($data: UpdateAccountInput!) {
    updateAccount(data: $data) {
      ...AccountFullPayload
    }
  }
  ${AccountFullPayloadFragmentDoc}
`;
/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAccountMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateAccountDocument, options);
}
export const CreateAccountDocument = gql `
  mutation createAccount($data: CreateAccountInput!) {
    createAccount(data: $data) {
      id
    }
  }
`;
/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAccountMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateAccountMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateAccountDocument, options);
}
export const EnableNotificationIdentityDocument = gql `
  mutation enableNotificationIdentity($domain: String!, $defaultEmail: String) {
    enableNotificationIdentity(domain: $domain, defaultEmail: $defaultEmail) {
      ...AccountFullPayload
    }
  }
  ${AccountFullPayloadFragmentDoc}
`;
/**
 * __useEnableNotificationIdentityMutation__
 *
 * To run a mutation, you first call `useEnableNotificationIdentityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableNotificationIdentityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableNotificationIdentityMutation({
 *   variables: {
 *     domain: // value for 'domain'
 *     defaultEmail: // value for 'defaultEmail'
 *   },
 * });
 */
export function useEnableNotificationIdentityMutation(options = {}) {
    return VueApolloComposable.useMutation(EnableNotificationIdentityDocument, options);
}
export const DisableNotificationIdentityDocument = gql `
  mutation disableNotificationIdentity {
    disableNotificationIdentity {
      ...AccountFullPayload
    }
  }
  ${AccountFullPayloadFragmentDoc}
`;
/**
 * __useDisableNotificationIdentityMutation__
 *
 * To run a mutation, you first call `useDisableNotificationIdentityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableNotificationIdentityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableNotificationIdentityMutation();
 */
export function useDisableNotificationIdentityMutation(options = {}) {
    return VueApolloComposable.useMutation(DisableNotificationIdentityDocument, options);
}
export const VerifyNotificationIdentityDocument = gql `
  mutation verifyNotificationIdentity {
    verifyNotificationIdentity {
      ...AccountFullPayload
    }
  }
  ${AccountFullPayloadFragmentDoc}
`;
/**
 * __useVerifyNotificationIdentityMutation__
 *
 * To run a mutation, you first call `useVerifyNotificationIdentityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useVerifyNotificationIdentityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useVerifyNotificationIdentityMutation();
 */
export function useVerifyNotificationIdentityMutation(options = {}) {
    return VueApolloComposable.useMutation(VerifyNotificationIdentityDocument, options);
}
export const MyAccountDocument = gql `
  subscription myAccount {
    myAccount {
      ...AccountFullPayload
    }
  }
  ${AccountFullPayloadFragmentDoc}
`;
/**
 * __useMyAccountSubscription__
 *
 * To run a query within a Vue component, call `useMyAccountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMyAccountSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useMyAccountSubscription();
 */
export function useMyAccountSubscription(options = {}) {
    return VueApolloComposable.useSubscription(MyAccountDocument, {}, options);
}
export const RetrieveAccountDataStoreDocument = gql `
  query retrieveAccountDataStore {
    retrieveAccountDataStore {
      ...AccountDataStoreFullPayload
    }
  }
  ${AccountDataStoreFullPayloadFragmentDoc}
`;
/**
 * __useRetrieveAccountDataStoreQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAccountDataStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAccountDataStoreQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAccountDataStoreQuery();
 */
export function useRetrieveAccountDataStoreQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveAccountDataStoreDocument, {}, options);
}
export function useRetrieveAccountDataStoreLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAccountDataStoreDocument, {}, options);
}
export const UpdateAccountDataStoreDocument = gql `
  mutation updateAccountDataStore($variables: [JSON!]!) {
    updateAccountDataStore(variables: $variables) {
      ...AccountDataStoreFullPayload
    }
  }
  ${AccountDataStoreFullPayloadFragmentDoc}
`;
/**
 * __useUpdateAccountDataStoreMutation__
 *
 * To run a mutation, you first call `useUpdateAccountDataStoreMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountDataStoreMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountDataStoreMutation({
 *   variables: {
 *     variables: // value for 'variables'
 *   },
 * });
 */
export function useUpdateAccountDataStoreMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateAccountDataStoreDocument, options);
}
export const UploadDataStoreFilesDocument = gql `
  mutation uploadDataStoreFiles($files: [Upload!]) {
    uploadDataStoreFiles(files: $files)
  }
`;
/**
 * __useUploadDataStoreFilesMutation__
 *
 * To run a mutation, you first call `useUploadDataStoreFilesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadDataStoreFilesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadDataStoreFilesMutation({
 *   variables: {
 *     files: // value for 'files'
 *   },
 * });
 */
export function useUploadDataStoreFilesMutation(options = {}) {
    return VueApolloComposable.useMutation(UploadDataStoreFilesDocument, options);
}
export const AccountDataStoreDocument = gql `
  subscription accountDataStore {
    accountDataStore {
      ...AccountDataStoreFullPayload
    }
  }
  ${AccountDataStoreFullPayloadFragmentDoc}
`;
/**
 * __useAccountDataStoreSubscription__
 *
 * To run a query within a Vue component, call `useAccountDataStoreSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAccountDataStoreSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useAccountDataStoreSubscription();
 */
export function useAccountDataStoreSubscription(options = {}) {
    return VueApolloComposable.useSubscription(AccountDataStoreDocument, {}, options);
}
export const LastActiveUserAccountDocument = gql `
  query lastActiveUserAccount {
    retrieveAccountPoliciesByUser(size: 1) {
      items {
        account {
          id
        }
      }
    }
  }
`;
/**
 * __useLastActiveUserAccountQuery__
 *
 * To run a query within a Vue component, call `useLastActiveUserAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastActiveUserAccountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLastActiveUserAccountQuery();
 */
export function useLastActiveUserAccountQuery(options = {}) {
    return VueApolloComposable.useQuery(LastActiveUserAccountDocument, {}, options);
}
export function useLastActiveUserAccountLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(LastActiveUserAccountDocument, {}, options);
}
export const MyAccountsDocument = gql `
  query myAccounts($size: Float) {
    retrieveAccountPoliciesByUser(size: $size) {
      total
      items {
        account {
          ...AccountBasicPayload
        }
      }
    }
  }
  ${AccountBasicPayloadFragmentDoc}
`;
/**
 * __useMyAccountsQuery__
 *
 * To run a query within a Vue component, call `useMyAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyAccountsQuery({
 *   size: // value for 'size'
 * });
 */
export function useMyAccountsQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(MyAccountsDocument, variables, options);
}
export function useMyAccountsLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(MyAccountsDocument, variables, options);
}
export const RetrieveAccountPoliciesDocument = gql `
  query retrieveAccountPolicies(
    $page: Float
    $size: Float
    $orderBy: [AccountPolicyOrderByInput!]
    $where: AccountPolicyWhereInput
  ) {
    retrieveAccountPolicies(
      page: $page
      size: $size
      orderBy: $orderBy
      where: $where
    ) {
      items {
        ...AccountPolicyPayloadFull
      }
      page
      perPage
      pages
      total
    }
  }
  ${AccountPolicyPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveAccountPoliciesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAccountPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAccountPoliciesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAccountPoliciesQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveAccountPoliciesQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveAccountPoliciesDocument, variables, options);
}
export function useRetrieveAccountPoliciesLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAccountPoliciesDocument, variables, options);
}
export const RegisterAccountAccessDocument = gql `
  mutation registerAccountAccess {
    registerAccessAccountPolicy {
      id
    }
  }
`;
/**
 * __useRegisterAccountAccessMutation__
 *
 * To run a mutation, you first call `useRegisterAccountAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAccountAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterAccountAccessMutation();
 */
export function useRegisterAccountAccessMutation(options = {}) {
    return VueApolloComposable.useMutation(RegisterAccountAccessDocument, options);
}
export const CreateAccountPolicyDocument = gql `
  mutation createAccountPolicy($data: CreateAccountPolicyInput!) {
    createAccountPolicy(data: $data) {
      ...AccountPolicyPayloadFull
    }
  }
  ${AccountPolicyPayloadFullFragmentDoc}
`;
/**
 * __useCreateAccountPolicyMutation__
 *
 * To run a mutation, you first call `useCreateAccountPolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountPolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAccountPolicyMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateAccountPolicyMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateAccountPolicyDocument, options);
}
export const CreateAccountPoliciesDocument = gql `
  mutation createAccountPolicies($data: [CreateAccountPolicyInput!]!) {
    createAccountPolicies(data: $data) {
      ...AccountPolicyPayloadFull
    }
  }
  ${AccountPolicyPayloadFullFragmentDoc}
`;
/**
 * __useCreateAccountPoliciesMutation__
 *
 * To run a mutation, you first call `useCreateAccountPoliciesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountPoliciesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAccountPoliciesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateAccountPoliciesMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateAccountPoliciesDocument, options);
}
export const SendAccountPolicyInvitationDocument = gql `
  mutation sendAccountPolicyInvitation($id: ID!) {
    sendAccountPolicyInvitation(id: $id) {
      ...AccountPolicyPayloadFull
    }
  }
  ${AccountPolicyPayloadFullFragmentDoc}
`;
/**
 * __useSendAccountPolicyInvitationMutation__
 *
 * To run a mutation, you first call `useSendAccountPolicyInvitationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendAccountPolicyInvitationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendAccountPolicyInvitationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSendAccountPolicyInvitationMutation(options = {}) {
    return VueApolloComposable.useMutation(SendAccountPolicyInvitationDocument, options);
}
export const UpdateAccountPolicyDocument = gql `
  mutation updateAccountPolicy($id: ID!, $data: UpdateAccountPolicyInput!) {
    updateAccountPolicy(id: $id, data: $data) {
      ...AccountPolicyPayloadFull
    }
  }
  ${AccountPolicyPayloadFullFragmentDoc}
`;
/**
 * __useUpdateAccountPolicyMutation__
 *
 * To run a mutation, you first call `useUpdateAccountPolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountPolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountPolicyMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAccountPolicyMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateAccountPolicyDocument, options);
}
export const DeleteAccountPolicyDocument = gql `
  mutation deleteAccountPolicy($id: ID!) {
    deleteAccountPolicy(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteAccountPolicyMutation__
 *
 * To run a mutation, you first call `useDeleteAccountPolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountPolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAccountPolicyMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountPolicyMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteAccountPolicyDocument, options);
}
export const DeleteAccountPoliciesDocument = gql `
  mutation deleteAccountPolicies($ids: [ID!]!) {
    deleteAccountPolicies(ids: $ids) {
      deleted
    }
  }
`;
/**
 * __useDeleteAccountPoliciesMutation__
 *
 * To run a mutation, you first call `useDeleteAccountPoliciesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountPoliciesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAccountPoliciesMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteAccountPoliciesMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteAccountPoliciesDocument, options);
}
export const AccountPoliciesSubscriptionDocument = gql `
  subscription accountPoliciesSubscription {
    accountPolicies {
      item {
        ...AccountPolicyPayloadFull
      }
      action
    }
  }
  ${AccountPolicyPayloadFullFragmentDoc}
`;
/**
 * __useAccountPoliciesSubscriptionSubscription__
 *
 * To run a query within a Vue component, call `useAccountPoliciesSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAccountPoliciesSubscriptionSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useAccountPoliciesSubscriptionSubscription();
 */
export function useAccountPoliciesSubscriptionSubscription(options = {}) {
    return VueApolloComposable.useSubscription(AccountPoliciesSubscriptionDocument, {}, options);
}
export const RetrieveAccountRolesDocument = gql `
  query retrieveAccountRoles {
    retrieveAccountRoles {
      ...AccountRoleExtendedPayload
    }
  }
  ${AccountRoleExtendedPayloadFragmentDoc}
`;
/**
 * __useRetrieveAccountRolesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAccountRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAccountRolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAccountRolesQuery();
 */
export function useRetrieveAccountRolesQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveAccountRolesDocument, {}, options);
}
export function useRetrieveAccountRolesLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAccountRolesDocument, {}, options);
}
export const RetrieveAccountTokensDocument = gql `
  query retrieveAccountTokens {
    retrieveAccountTokens {
      ...AccountTokenFullPayload
    }
  }
  ${AccountTokenFullPayloadFragmentDoc}
`;
/**
 * __useRetrieveAccountTokensQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAccountTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAccountTokensQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAccountTokensQuery();
 */
export function useRetrieveAccountTokensQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveAccountTokensDocument, {}, options);
}
export function useRetrieveAccountTokensLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAccountTokensDocument, {}, options);
}
export const CreateAccountTokenDocument = gql `
  mutation createAccountToken($name: String) {
    createAccountToken(name: $name) {
      ...AccountTokenFullPayload
    }
  }
  ${AccountTokenFullPayloadFragmentDoc}
`;
/**
 * __useCreateAccountTokenMutation__
 *
 * To run a mutation, you first call `useCreateAccountTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAccountTokenMutation({
 *   variables: {
 *     name: // value for 'name'
 *   },
 * });
 */
export function useCreateAccountTokenMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateAccountTokenDocument, options);
}
export const DeleteAccountTokenDocument = gql `
  mutation deleteAccountToken($id: String!) {
    deleteAccountToken(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteAccountTokenMutation__
 *
 * To run a mutation, you first call `useDeleteAccountTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAccountTokenMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountTokenMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteAccountTokenDocument, options);
}
export const QueryAccountAnalyticDocument = gql `
  query queryAccountAnalytic($options: JSON!, $type: AccountAnalytics!) {
    queryAccountAnalytic(options: $options, type: $type)
  }
`;
/**
 * __useQueryAccountAnalyticQuery__
 *
 * To run a query within a Vue component, call `useQueryAccountAnalyticQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAccountAnalyticQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQueryAccountAnalyticQuery({
 *   options: // value for 'options'
 *   type: // value for 'type'
 * });
 */
export function useQueryAccountAnalyticQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(QueryAccountAnalyticDocument, variables, options);
}
export function useQueryAccountAnalyticLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(QueryAccountAnalyticDocument, variables, options);
}
export const RetrieveApprovalsDocument = gql `
  query retrieveApprovals($documentId: ID!) {
    retrieveApprovals(documentId: $documentId) {
      items {
        ...ApprovalPayloadFull
      }
    }
  }
  ${ApprovalPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveApprovalsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveApprovalsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveApprovalsQuery({
 *   documentId: // value for 'documentId'
 * });
 */
export function useRetrieveApprovalsQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveApprovalsDocument, variables, options);
}
export function useRetrieveApprovalsLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveApprovalsDocument, variables, options);
}
export const CountApprovalsDocument = gql `
  query countApprovals($documentId: ID!) {
    countApprovals(documentId: $documentId)
  }
`;
/**
 * __useCountApprovalsQuery__
 *
 * To run a query within a Vue component, call `useCountApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountApprovalsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountApprovalsQuery({
 *   documentId: // value for 'documentId'
 * });
 */
export function useCountApprovalsQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(CountApprovalsDocument, variables, options);
}
export function useCountApprovalsLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(CountApprovalsDocument, variables, options);
}
export const FetchValidApprovalDocument = gql `
  query fetchValidApproval {
    fetchValidApproval {
      content
      approval {
        ...ApprovalPayloadLite
        metadata
      }
      author {
        email
      }
      account {
        ...AccountBasicPayload
        capabilities
      }
    }
  }
  ${ApprovalPayloadLiteFragmentDoc}
  ${AccountBasicPayloadFragmentDoc}
`;
/**
 * __useFetchValidApprovalQuery__
 *
 * To run a query within a Vue component, call `useFetchValidApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchValidApprovalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchValidApprovalQuery();
 */
export function useFetchValidApprovalQuery(options = {}) {
    return VueApolloComposable.useQuery(FetchValidApprovalDocument, {}, options);
}
export function useFetchValidApprovalLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(FetchValidApprovalDocument, {}, options);
}
export const RetrieveApprovalMessagesDocument = gql `
  query retrieveApprovalMessages(
    $approvalId: ID!
    $cursorId: String
    $size: Float
  ) {
    retrieveApprovalMessages(
      approvalId: $approvalId
      cursorId: $cursorId
      size: $size
    ) {
      items {
        ...ApprovalMessagePayloadFull
      }
      currentCursor
      nextCursor
      perPage
      total
    }
  }
  ${ApprovalMessagePayloadFullFragmentDoc}
`;
/**
 * __useRetrieveApprovalMessagesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveApprovalMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveApprovalMessagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveApprovalMessagesQuery({
 *   approvalId: // value for 'approvalId'
 *   cursorId: // value for 'cursorId'
 *   size: // value for 'size'
 * });
 */
export function useRetrieveApprovalMessagesQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveApprovalMessagesDocument, variables, options);
}
export function useRetrieveApprovalMessagesLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveApprovalMessagesDocument, variables, options);
}
export const FetchApprovalMessagesDocument = gql `
  query fetchApprovalMessages($cursorId: String, $size: Float) {
    fetchApprovalMessages(cursorId: $cursorId, size: $size) {
      items {
        ...ApprovalMessagePayloadFull
      }
      currentCursor
      nextCursor
      perPage
      total
    }
  }
  ${ApprovalMessagePayloadFullFragmentDoc}
`;
/**
 * __useFetchApprovalMessagesQuery__
 *
 * To run a query within a Vue component, call `useFetchApprovalMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchApprovalMessagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchApprovalMessagesQuery({
 *   cursorId: // value for 'cursorId'
 *   size: // value for 'size'
 * });
 */
export function useFetchApprovalMessagesQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(FetchApprovalMessagesDocument, variables, options);
}
export function useFetchApprovalMessagesLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(FetchApprovalMessagesDocument, variables, options);
}
export const CreateApprovalDocument = gql `
  mutation createApproval($data: CreateApprovalInput!, $documentId: ID!) {
    createApproval(data: $data, documentId: $documentId) {
      ...ApprovalPayloadFull
    }
  }
  ${ApprovalPayloadFullFragmentDoc}
`;
/**
 * __useCreateApprovalMutation__
 *
 * To run a mutation, you first call `useCreateApprovalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateApprovalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateApprovalMutation({
 *   variables: {
 *     data: // value for 'data'
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useCreateApprovalMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateApprovalDocument, options);
}
export const UpdateApprovalDocument = gql `
  mutation updateApproval($id: ID!, $data: UpdateApprovalInput!) {
    updateApproval(data: $data, id: $id) {
      ...ApprovalPayloadFull
    }
  }
  ${ApprovalPayloadFullFragmentDoc}
`;
/**
 * __useUpdateApprovalMutation__
 *
 * To run a mutation, you first call `useUpdateApprovalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApprovalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateApprovalMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateApprovalMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateApprovalDocument, options);
}
export const DeleteApprovalDocument = gql `
  mutation deleteApproval($id: ID!) {
    deleteApproval(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteApprovalMutation__
 *
 * To run a mutation, you first call `useDeleteApprovalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApprovalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteApprovalMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteApprovalMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteApprovalDocument, options);
}
export const RequestApprovalsDocument = gql `
  mutation requestApprovals($documentId: ID!) {
    requestApprovals(documentId: $documentId) {
      id
    }
  }
`;
/**
 * __useRequestApprovalsMutation__
 *
 * To run a mutation, you first call `useRequestApprovalsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestApprovalsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestApprovalsMutation({
 *   variables: {
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRequestApprovalsMutation(options = {}) {
    return VueApolloComposable.useMutation(RequestApprovalsDocument, options);
}
export const RequestApprovalDocument = gql `
  mutation requestApproval($id: ID!) {
    requestApproval(id: $id) {
      id
    }
  }
`;
/**
 * __useRequestApprovalMutation__
 *
 * To run a mutation, you first call `useRequestApprovalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestApprovalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestApprovalMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRequestApprovalMutation(options = {}) {
    return VueApolloComposable.useMutation(RequestApprovalDocument, options);
}
export const ReviewDocumentDocument = gql `
  mutation reviewDocument($id: ID!, $isApproved: Boolean!) {
    reviewDocument(id: $id, isApproved: $isApproved) {
      ...ApprovalPayloadFull
    }
  }
  ${ApprovalPayloadFullFragmentDoc}
`;
/**
 * __useReviewDocumentMutation__
 *
 * To run a mutation, you first call `useReviewDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReviewDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReviewDocumentMutation({
 *   variables: {
 *     id: // value for 'id'
 *     isApproved: // value for 'isApproved'
 *   },
 * });
 */
export function useReviewDocumentMutation(options = {}) {
    return VueApolloComposable.useMutation(ReviewDocumentDocument, options);
}
export const CreateApprovalMessageDocument = gql `
  mutation createApprovalMessage(
    $approvalId: ID!
    $data: CreateApprovalMessageInput!
  ) {
    createApprovalMessage(approvalId: $approvalId, data: $data) {
      ...ApprovalMessagePayloadFull
    }
  }
  ${ApprovalMessagePayloadFullFragmentDoc}
`;
/**
 * __useCreateApprovalMessageMutation__
 *
 * To run a mutation, you first call `useCreateApprovalMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateApprovalMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateApprovalMessageMutation({
 *   variables: {
 *     approvalId: // value for 'approvalId'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateApprovalMessageMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateApprovalMessageDocument, options);
}
export const SendApprovalMessageDocument = gql `
  mutation sendApprovalMessage($data: CreateApprovalMessageInput!) {
    sendApprovalMessage(data: $data) {
      ...ApprovalMessagePayloadFull
    }
  }
  ${ApprovalMessagePayloadFullFragmentDoc}
`;
/**
 * __useSendApprovalMessageMutation__
 *
 * To run a mutation, you first call `useSendApprovalMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendApprovalMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendApprovalMessageMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSendApprovalMessageMutation(options = {}) {
    return VueApolloComposable.useMutation(SendApprovalMessageDocument, options);
}
export const ApprovalDocument = gql `
  subscription approval($id: ID!) {
    approval(id: $id) {
      ...ApprovalPayloadFull
    }
  }
  ${ApprovalPayloadFullFragmentDoc}
`;
/**
 * __useApprovalSubscription__
 *
 * To run a query within a Vue component, call `useApprovalSubscription` and pass it any options that fit your needs.
 * When your component renders, `useApprovalSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useApprovalSubscription({
 *   id: // value for 'id'
 * });
 */
export function useApprovalSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(ApprovalDocument, variables, options);
}
export const ApprovalMessagesSubscriptionDocument = gql `
  subscription approvalMessagesSubscription($approvalId: ID!) {
    approvalMessages(approvalId: $approvalId) {
      action
      item {
        ...ApprovalMessagePayloadFull
      }
    }
  }
  ${ApprovalMessagePayloadFullFragmentDoc}
`;
/**
 * __useApprovalMessagesSubscriptionSubscription__
 *
 * To run a query within a Vue component, call `useApprovalMessagesSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useApprovalMessagesSubscriptionSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useApprovalMessagesSubscriptionSubscription({
 *   approvalId: // value for 'approvalId'
 * });
 */
export function useApprovalMessagesSubscriptionSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(ApprovalMessagesSubscriptionDocument, variables, options);
}
export const ApprovalMessagesPublicDocument = gql `
  subscription approvalMessagesPublic($signed: String!) {
    approvalMessagesPublic(signed: $signed) {
      action
      item {
        ...ApprovalMessagePayloadFull
      }
    }
  }
  ${ApprovalMessagePayloadFullFragmentDoc}
`;
/**
 * __useApprovalMessagesPublicSubscription__
 *
 * To run a query within a Vue component, call `useApprovalMessagesPublicSubscription` and pass it any options that fit your needs.
 * When your component renders, `useApprovalMessagesPublicSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useApprovalMessagesPublicSubscription({
 *   signed: // value for 'signed'
 * });
 */
export function useApprovalMessagesPublicSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(ApprovalMessagesPublicDocument, variables, options);
}
export const ActivityByDocumentDocument = gql `
  query activityByDocument($cursorId: String, $documentId: ID!, $size: Float) {
    activityByDocument(
      cursorId: $cursorId
      documentId: $documentId
      size: $size
    ) {
      items {
        ...AuditPayloadFull
      }
      currentCursor
      nextCursor
      perPage
      total
    }
  }
  ${AuditPayloadFullFragmentDoc}
`;
/**
 * __useActivityByDocumentQuery__
 *
 * To run a query within a Vue component, call `useActivityByDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityByDocumentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActivityByDocumentQuery({
 *   cursorId: // value for 'cursorId'
 *   documentId: // value for 'documentId'
 *   size: // value for 'size'
 * });
 */
export function useActivityByDocumentQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(ActivityByDocumentDocument, variables, options);
}
export function useActivityByDocumentLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(ActivityByDocumentDocument, variables, options);
}
export const ActivityByEmailDocument = gql `
  query activityByEmail($cursorId: String, $email: String!, $size: Float) {
    activityByEmail(cursorId: $cursorId, email: $email, size: $size) {
      items {
        ...AuditPayloadFull
      }
      currentCursor
      nextCursor
      perPage
      total
    }
  }
  ${AuditPayloadFullFragmentDoc}
`;
/**
 * __useActivityByEmailQuery__
 *
 * To run a query within a Vue component, call `useActivityByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityByEmailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActivityByEmailQuery({
 *   cursorId: // value for 'cursorId'
 *   email: // value for 'email'
 *   size: // value for 'size'
 * });
 */
export function useActivityByEmailQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(ActivityByEmailDocument, variables, options);
}
export function useActivityByEmailLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(ActivityByEmailDocument, variables, options);
}
export const RetrieveCategoryDocument = gql `
  query retrieveCategory($id: ID!) {
    retrieveCategory(id: $id) {
      ...CategoryPayloadFull
    }
  }
  ${CategoryPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveCategoryQuery__
 *
 * To run a query within a Vue component, call `useRetrieveCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveCategoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveCategoryQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveCategoryQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveCategoryDocument, variables, options);
}
export function useRetrieveCategoryLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveCategoryDocument, variables, options);
}
export const RetrieveCategoriesDocument = gql `
  query retrieveCategories(
    $page: Float
    $size: Float
    $orderBy: [CategoryOrderByInput!]
    $where: CategoryWhereInput
  ) {
    retrieveCategories(
      page: $page
      size: $size
      orderBy: $orderBy
      where: $where
    ) {
      items {
        ...CategoryExtendedPayload
      }
      page
      perPage
      pages
      total
    }
  }
  ${CategoryExtendedPayloadFragmentDoc}
`;
/**
 * __useRetrieveCategoriesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveCategoriesQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveCategoriesQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveCategoriesDocument, variables, options);
}
export function useRetrieveCategoriesLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveCategoriesDocument, variables, options);
}
export const RetrieveAllCategoriesDocument = gql `
  query retrieveAllCategories($size: Float, $where: CategoryWhereInput) {
    retrieveCategories(size: $size, where: $where) {
      items {
        id
      }
    }
  }
`;
/**
 * __useRetrieveAllCategoriesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAllCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAllCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAllCategoriesQuery({
 *   size: // value for 'size'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveAllCategoriesQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveAllCategoriesDocument, variables, options);
}
export function useRetrieveAllCategoriesLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAllCategoriesDocument, variables, options);
}
export const CountCategoriesDocument = gql `
  query countCategories {
    countCategories
  }
`;
/**
 * __useCountCategoriesQuery__
 *
 * To run a query within a Vue component, call `useCountCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountCategoriesQuery();
 */
export function useCountCategoriesQuery(options = {}) {
    return VueApolloComposable.useQuery(CountCategoriesDocument, {}, options);
}
export function useCountCategoriesLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(CountCategoriesDocument, {}, options);
}
export const UpsertCategoryDocument = gql `
  mutation upsertCategory($data: UpdateOrCreateCategoryInput!) {
    upsertCategory(data: $data) {
      ...CategoryPayloadFull
    }
  }
  ${CategoryPayloadFullFragmentDoc}
`;
/**
 * __useUpsertCategoryMutation__
 *
 * To run a mutation, you first call `useUpsertCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertCategoryMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpsertCategoryMutation(options = {}) {
    return VueApolloComposable.useMutation(UpsertCategoryDocument, options);
}
export const UpsertCategoriesDocument = gql `
  mutation upsertCategories($data: [UpdateOrCreateCategoryInput!]!) {
    upsertCategories(data: $data) {
      ...CategoryPayloadFull
    }
  }
  ${CategoryPayloadFullFragmentDoc}
`;
/**
 * __useUpsertCategoriesMutation__
 *
 * To run a mutation, you first call `useUpsertCategoriesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCategoriesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertCategoriesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpsertCategoriesMutation(options = {}) {
    return VueApolloComposable.useMutation(UpsertCategoriesDocument, options);
}
export const DeleteCategoryDocument = gql `
  mutation deleteCategory($id: ID!) {
    deleteCategory(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCategoryMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCategoryMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteCategoryDocument, options);
}
export const DeleteCategoriesDocument = gql `
  mutation deleteCategories($ids: [ID!]!) {
    deleteCategories(ids: $ids) {
      deleted
    }
  }
`;
/**
 * __useDeleteCategoriesMutation__
 *
 * To run a mutation, you first call `useDeleteCategoriesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoriesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCategoriesMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteCategoriesMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteCategoriesDocument, options);
}
export const HideCategoryDocument = gql `
  mutation hideCategory($id: ID!, $hide: Boolean!) {
    hideCategory(id: $id, hide: $hide) {
      ...CategoryPayloadFull
    }
  }
  ${CategoryPayloadFullFragmentDoc}
`;
/**
 * __useHideCategoryMutation__
 *
 * To run a mutation, you first call `useHideCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useHideCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useHideCategoryMutation({
 *   variables: {
 *     id: // value for 'id'
 *     hide: // value for 'hide'
 *   },
 * });
 */
export function useHideCategoryMutation(options = {}) {
    return VueApolloComposable.useMutation(HideCategoryDocument, options);
}
export const CategoryDocument = gql `
  subscription category($id: ID!) {
    category(id: $id) {
      ...CategoryPayloadFull
    }
  }
  ${CategoryPayloadFullFragmentDoc}
`;
/**
 * __useCategorySubscription__
 *
 * To run a query within a Vue component, call `useCategorySubscription` and pass it any options that fit your needs.
 * When your component renders, `useCategorySubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useCategorySubscription({
 *   id: // value for 'id'
 * });
 */
export function useCategorySubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(CategoryDocument, variables, options);
}
export const CategoriesDocument = gql `
  subscription categories {
    categories {
      item {
        ...CategoryPayloadFull
      }
      action
    }
  }
  ${CategoryPayloadFullFragmentDoc}
`;
/**
 * __useCategoriesSubscription__
 *
 * To run a query within a Vue component, call `useCategoriesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useCategoriesSubscription();
 */
export function useCategoriesSubscription(options = {}) {
    return VueApolloComposable.useSubscription(CategoriesDocument, {}, options);
}
export const RetrieveContactDocument = gql `
  query retrieveContact($id: ID!) {
    retrieveContact(id: $id) {
      ...ContactPayloadFull
    }
  }
  ${ContactPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveContactQuery__
 *
 * To run a query within a Vue component, call `useRetrieveContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveContactQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveContactQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveContactQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveContactDocument, variables, options);
}
export function useRetrieveContactLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveContactDocument, variables, options);
}
export const RetrieveContactsDocument = gql `
  query retrieveContacts(
    $page: Float
    $size: Float
    $orderBy: [ContactOrderByInput!]
    $where: ContactWhereInput
  ) {
    retrieveContacts(
      page: $page
      size: $size
      orderBy: $orderBy
      where: $where
    ) {
      items {
        ...ContactExtendedPayload
      }
      page
      perPage
      pages
      total
    }
  }
  ${ContactExtendedPayloadFragmentDoc}
`;
/**
 * __useRetrieveContactsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveContactsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveContactsQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveContactsQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveContactsDocument, variables, options);
}
export function useRetrieveContactsLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveContactsDocument, variables, options);
}
export const RetrieveAllContactsDocument = gql `
  query retrieveAllContacts($size: Float, $where: ContactWhereInput) {
    retrieveContacts(size: $size, where: $where) {
      items {
        ...ContactPayloadLite
      }
    }
  }
  ${ContactPayloadLiteFragmentDoc}
`;
/**
 * __useRetrieveAllContactsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAllContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAllContactsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAllContactsQuery({
 *   size: // value for 'size'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveAllContactsQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveAllContactsDocument, variables, options);
}
export function useRetrieveAllContactsLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAllContactsDocument, variables, options);
}
export const CountContactsDocument = gql `
  query countContacts {
    countContacts
  }
`;
/**
 * __useCountContactsQuery__
 *
 * To run a query within a Vue component, call `useCountContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountContactsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountContactsQuery();
 */
export function useCountContactsQuery(options = {}) {
    return VueApolloComposable.useQuery(CountContactsDocument, {}, options);
}
export function useCountContactsLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(CountContactsDocument, {}, options);
}
export const UpsertContactDocument = gql `
  mutation upsertContact($data: UpdateOrCreateContactInput!) {
    upsertContact(data: $data) {
      ...ContactPayloadFull
    }
  }
  ${ContactPayloadFullFragmentDoc}
`;
/**
 * __useUpsertContactMutation__
 *
 * To run a mutation, you first call `useUpsertContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertContactMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpsertContactMutation(options = {}) {
    return VueApolloComposable.useMutation(UpsertContactDocument, options);
}
export const UpsertContactsDocument = gql `
  mutation upsertContacts($data: [UpdateOrCreateContactInput!]!) {
    upsertContacts(data: $data) {
      ...ContactPayloadFull
    }
  }
  ${ContactPayloadFullFragmentDoc}
`;
/**
 * __useUpsertContactsMutation__
 *
 * To run a mutation, you first call `useUpsertContactsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContactsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertContactsMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpsertContactsMutation(options = {}) {
    return VueApolloComposable.useMutation(UpsertContactsDocument, options);
}
export const DeleteContactDocument = gql `
  mutation deleteContact($id: ID!) {
    deleteContact(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteContactMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteContactDocument, options);
}
export const DeleteContactsDocument = gql `
  mutation deleteContacts($ids: [ID!]!) {
    deleteContacts(ids: $ids) {
      deleted
    }
  }
`;
/**
 * __useDeleteContactsMutation__
 *
 * To run a mutation, you first call `useDeleteContactsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteContactsMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteContactsMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteContactsDocument, options);
}
export const UploadContactFileDocument = gql `
  mutation uploadContactFile($id: String!, $key: String!, $file: Upload!) {
    uploadContactFile(id: $id, key: $key, file: $file)
  }
`;
/**
 * __useUploadContactFileMutation__
 *
 * To run a mutation, you first call `useUploadContactFileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadContactFileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadContactFileMutation({
 *   variables: {
 *     id: // value for 'id'
 *     key: // value for 'key'
 *     file: // value for 'file'
 *   },
 * });
 */
export function useUploadContactFileMutation(options = {}) {
    return VueApolloComposable.useMutation(UploadContactFileDocument, options);
}
export const ContactDocument = gql `
  subscription contact($id: ID!) {
    contact(id: $id) {
      ...ContactPayloadFull
    }
  }
  ${ContactPayloadFullFragmentDoc}
`;
/**
 * __useContactSubscription__
 *
 * To run a query within a Vue component, call `useContactSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContactSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useContactSubscription({
 *   id: // value for 'id'
 * });
 */
export function useContactSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(ContactDocument, variables, options);
}
export const ContactsSubscriptionDocument = gql `
  subscription contactsSubscription {
    contacts {
      item {
        ...ContactPayloadFull
      }
      action
    }
  }
  ${ContactPayloadFullFragmentDoc}
`;
/**
 * __useContactsSubscriptionSubscription__
 *
 * To run a query within a Vue component, call `useContactsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContactsSubscriptionSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useContactsSubscriptionSubscription();
 */
export function useContactsSubscriptionSubscription(options = {}) {
    return VueApolloComposable.useSubscription(ContactsSubscriptionDocument, {}, options);
}
export const RetrieveDocumentDocument = gql `
  query retrieveDocument($id: ID!) {
    retrieveDocument(id: $id) {
      ...DocumentPayloadFull
    }
  }
  ${DocumentPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveDocumentQuery__
 *
 * To run a query within a Vue component, call `useRetrieveDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDocumentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveDocumentQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveDocumentQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveDocumentDocument, variables, options);
}
export function useRetrieveDocumentLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveDocumentDocument, variables, options);
}
export const RetrieveDocumentAccountIdDocument = gql `
  query retrieveDocumentAccountId($id: ID!) {
    retrieveDocumentAccountId(id: $id)
  }
`;
/**
 * __useRetrieveDocumentAccountIdQuery__
 *
 * To run a query within a Vue component, call `useRetrieveDocumentAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDocumentAccountIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveDocumentAccountIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveDocumentAccountIdQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveDocumentAccountIdDocument, variables, options);
}
export function useRetrieveDocumentAccountIdLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveDocumentAccountIdDocument, variables, options);
}
export const RetrieveDocumentTypeDocument = gql `
  query retrieveDocumentType($id: ID!) {
    retrieveDocumentType(id: $id)
  }
`;
/**
 * __useRetrieveDocumentTypeQuery__
 *
 * To run a query within a Vue component, call `useRetrieveDocumentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDocumentTypeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveDocumentTypeQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveDocumentTypeQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveDocumentTypeDocument, variables, options);
}
export function useRetrieveDocumentTypeLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveDocumentTypeDocument, variables, options);
}
export const RetrieveDocumentWithAccountDocument = gql `
  query retrieveDocumentWithAccount($id: ID!) {
    retrieveDocument(id: $id) {
      ...DocumentExtendedPayload
      content {
        id
        pathMerge
        path
        preview
        delimiters
        mimetype
        readOnly
        version
      }
      account {
        ...AccountBasicPayload
        capabilities
      }
    }
  }
  ${DocumentExtendedPayloadFragmentDoc}
  ${AccountBasicPayloadFragmentDoc}
`;
/**
 * __useRetrieveDocumentWithAccountQuery__
 *
 * To run a query within a Vue component, call `useRetrieveDocumentWithAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDocumentWithAccountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveDocumentWithAccountQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveDocumentWithAccountQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveDocumentWithAccountDocument, variables, options);
}
export function useRetrieveDocumentWithAccountLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveDocumentWithAccountDocument, variables, options);
}
export const RetrieveDocumentsDocument = gql `
  query retrieveDocuments(
    $page: Float
    $size: Float
    $orderBy: [DocumentOrderByInput!]
    $where: DocumentWhereInput
  ) {
    retrieveDocuments(
      page: $page
      size: $size
      orderBy: $orderBy
      where: $where
    ) {
      items {
        ...DocumentExtendedPayload
      }
      page
      perPage
      pages
      total
    }
  }
  ${DocumentExtendedPayloadFragmentDoc}
`;
/**
 * __useRetrieveDocumentsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDocumentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveDocumentsQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveDocumentsQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveDocumentsDocument, variables, options);
}
export function useRetrieveDocumentsLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveDocumentsDocument, variables, options);
}
export const RetrieveHotDocumentsDocument = gql `
  query retrieveHotDocuments {
    retrieveHotDocuments {
      items {
        ...DocumentPayloadLite
        createdAt
        updatedAt
        cancelledAt
        startedAt
        endedAt
        renewal
        ref
        permissions
        role
        access
        object
        metadata
      }
      page
      perPage
      pages
      total
    }
  }
  ${DocumentPayloadLiteFragmentDoc}
`;
/**
 * __useRetrieveHotDocumentsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveHotDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveHotDocumentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveHotDocumentsQuery();
 */
export function useRetrieveHotDocumentsQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveHotDocumentsDocument, {}, options);
}
export function useRetrieveHotDocumentsLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveHotDocumentsDocument, {}, options);
}
export const RetrieveAllDocumentsDocument = gql `
  query retrieveAllDocuments($size: Float, $where: DocumentWhereInput) {
    retrieveDocuments(size: $size, where: $where) {
      items {
        id
        name
      }
    }
  }
`;
/**
 * __useRetrieveAllDocumentsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAllDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAllDocumentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAllDocumentsQuery({
 *   size: // value for 'size'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveAllDocumentsQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveAllDocumentsDocument, variables, options);
}
export function useRetrieveAllDocumentsLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAllDocumentsDocument, variables, options);
}
export const RetrieveDocumentStatusListDocument = gql `
  query retrieveDocumentStatusList {
    retrieveDocumentStatusList {
      key
      value
    }
  }
`;
/**
 * __useRetrieveDocumentStatusListQuery__
 *
 * To run a query within a Vue component, call `useRetrieveDocumentStatusListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDocumentStatusListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveDocumentStatusListQuery();
 */
export function useRetrieveDocumentStatusListQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveDocumentStatusListDocument, {}, options);
}
export function useRetrieveDocumentStatusListLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveDocumentStatusListDocument, {}, options);
}
export const CountDocumentsDocument = gql `
  query countDocuments {
    countDocuments
  }
`;
/**
 * __useCountDocumentsQuery__
 *
 * To run a query within a Vue component, call `useCountDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDocumentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountDocumentsQuery();
 */
export function useCountDocumentsQuery(options = {}) {
    return VueApolloComposable.useQuery(CountDocumentsDocument, {}, options);
}
export function useCountDocumentsLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(CountDocumentsDocument, {}, options);
}
export const QnaDocumentDocument = gql `
  query qnaDocument($id: ID!, $question: String!) {
    qnaDocument(id: $id, question: $question) {
      page
      document {
        id
        name
      }
      result
    }
  }
`;
/**
 * __useQnaDocumentQuery__
 *
 * To run a query within a Vue component, call `useQnaDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useQnaDocumentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQnaDocumentQuery({
 *   id: // value for 'id'
 *   question: // value for 'question'
 * });
 */
export function useQnaDocumentQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(QnaDocumentDocument, variables, options);
}
export function useQnaDocumentLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(QnaDocumentDocument, variables, options);
}
export const RetrieveQueryBuilderOptionsDocument = gql `
  query retrieveQueryBuilderOptions {
    retrieveQueryBuilderOptions {
      operators
      rules
    }
  }
`;
/**
 * __useRetrieveQueryBuilderOptionsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveQueryBuilderOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveQueryBuilderOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveQueryBuilderOptionsQuery();
 */
export function useRetrieveQueryBuilderOptionsQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveQueryBuilderOptionsDocument, {}, options);
}
export function useRetrieveQueryBuilderOptionsLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveQueryBuilderOptionsDocument, {}, options);
}
export const CreateDocumentDocument = gql `
  mutation createDocument($data: CreateDocumentInput!, $file: Upload) {
    createDocument(data: $data, file: $file) {
      ...DocumentPayloadFull
    }
  }
  ${DocumentPayloadFullFragmentDoc}
`;
/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDocumentMutation({
 *   variables: {
 *     data: // value for 'data'
 *     file: // value for 'file'
 *   },
 * });
 */
export function useCreateDocumentMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateDocumentDocument, options);
}
export const UpdateDocumentDocument = gql `
  mutation updateDocument($id: ID!, $data: UpdateDocumentInput!) {
    updateDocument(data: $data, id: $id) {
      ...DocumentPayloadFull
    }
  }
  ${DocumentPayloadFullFragmentDoc}
`;
/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDocumentMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDocumentMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateDocumentDocument, options);
}
export const CloneDocumentDocument = gql `
  mutation cloneDocument($id: ID!) {
    cloneDocument(id: $id) {
      ...DocumentPayloadFull
    }
  }
  ${DocumentPayloadFullFragmentDoc}
`;
/**
 * __useCloneDocumentMutation__
 *
 * To run a mutation, you first call `useCloneDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCloneDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCloneDocumentMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCloneDocumentMutation(options = {}) {
    return VueApolloComposable.useMutation(CloneDocumentDocument, options);
}
export const UpdateDocumentStatusDocument = gql `
  mutation updateDocumentStatus($id: ID!, $newStatus: DocumentStatus!) {
    updateDocumentStatus(id: $id, newStatus: $newStatus) {
      id
    }
  }
`;
/**
 * __useUpdateDocumentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDocumentStatusMutation({
 *   variables: {
 *     id: // value for 'id'
 *     newStatus: // value for 'newStatus'
 *   },
 * });
 */
export function useUpdateDocumentStatusMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateDocumentStatusDocument, options);
}
export const SummarizeDocumentDocument = gql `
  mutation summarizeDocument($id: ID!) {
    summarizeDocument(id: $id) {
      id
    }
  }
`;
/**
 * __useSummarizeDocumentMutation__
 *
 * To run a mutation, you first call `useSummarizeDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSummarizeDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSummarizeDocumentMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSummarizeDocumentMutation(options = {}) {
    return VueApolloComposable.useMutation(SummarizeDocumentDocument, options);
}
export const UpdateDocumentDestinationFolderDocument = gql `
  mutation updateDocumentDestinationFolder($destinationId: ID, $id: ID!) {
    updateDocumentDestinationFolder(destinationId: $destinationId, id: $id) {
      id
    }
  }
`;
/**
 * __useUpdateDocumentDestinationFolderMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentDestinationFolderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentDestinationFolderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDocumentDestinationFolderMutation({
 *   variables: {
 *     destinationId: // value for 'destinationId'
 *     id: // value for 'id'
 *   },
 * });
 */
export function useUpdateDocumentDestinationFolderMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateDocumentDestinationFolderDocument, options);
}
export const UpdateDocumentVersionDocument = gql `
  mutation updateDocumentVersion(
    $delimiter: DocumentDelimiter
    $id: ID!
    $file: Upload!
    $redlines: Boolean
  ) {
    updateDocumentVersion(
      delimiter: $delimiter
      id: $id
      file: $file
      redlines: $redlines
    ) {
      ...DocumentPayloadFull
    }
  }
  ${DocumentPayloadFullFragmentDoc}
`;
/**
 * __useUpdateDocumentVersionMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDocumentVersionMutation({
 *   variables: {
 *     delimiter: // value for 'delimiter'
 *     id: // value for 'id'
 *     file: // value for 'file'
 *     redlines: // value for 'redlines'
 *   },
 * });
 */
export function useUpdateDocumentVersionMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateDocumentVersionDocument, options);
}
export const DeleteDocumentDocument = gql `
  mutation deleteDocument($id: ID!) {
    deleteDocument(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDocumentMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteDocumentDocument, options);
}
export const DeleteDocumentsDocument = gql `
  mutation deleteDocuments($ids: [ID!]!) {
    deleteDocuments(ids: $ids) {
      deleted
    }
  }
`;
/**
 * __useDeleteDocumentsMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDocumentsMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteDocumentsMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteDocumentsDocument, options);
}
export const ImportDocumentsDocument = gql `
  mutation importDocuments($data: ImportDocumentsInput!, $files: [Upload!]) {
    importDocuments(data: $data, files: $files)
  }
`;
/**
 * __useImportDocumentsMutation__
 *
 * To run a mutation, you first call `useImportDocumentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportDocumentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportDocumentsMutation({
 *   variables: {
 *     data: // value for 'data'
 *     files: // value for 'files'
 *   },
 * });
 */
export function useImportDocumentsMutation(options = {}) {
    return VueApolloComposable.useMutation(ImportDocumentsDocument, options);
}
export const DocumentDocument = gql `
  subscription document($id: ID!) {
    document(id: $id) {
      ...DocumentPayloadFull
    }
  }
  ${DocumentPayloadFullFragmentDoc}
`;
/**
 * __useDocumentSubscription__
 *
 * To run a query within a Vue component, call `useDocumentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDocumentSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useDocumentSubscription({
 *   id: // value for 'id'
 * });
 */
export function useDocumentSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(DocumentDocument, variables, options);
}
export const RetrieveDocumentContentDocument = gql `
  query retrieveDocumentContent($id: ID!) {
    retrieveDocumentContent(id: $id) {
      ...DocumentContentPayloadFull
    }
  }
  ${DocumentContentPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveDocumentContentQuery__
 *
 * To run a query within a Vue component, call `useRetrieveDocumentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDocumentContentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveDocumentContentQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveDocumentContentQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveDocumentContentDocument, variables, options);
}
export function useRetrieveDocumentContentLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveDocumentContentDocument, variables, options);
}
export const RetrieveEditorDocumentContentDocument = gql `
  query retrieveEditorDocumentContent($id: ID!) {
    retrieveEditorDocumentContent(id: $id)
  }
`;
/**
 * __useRetrieveEditorDocumentContentQuery__
 *
 * To run a query within a Vue component, call `useRetrieveEditorDocumentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveEditorDocumentContentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveEditorDocumentContentQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveEditorDocumentContentQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveEditorDocumentContentDocument, variables, options);
}
export function useRetrieveEditorDocumentContentLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveEditorDocumentContentDocument, variables, options);
}
export const RetrieveUsersEditorDocument = gql `
  query retrieveUsersEditor($document: ID!) {
    retrieveUsersEditor(document: $document) {
      ...DocumentLockedPayloadFull
    }
  }
  ${DocumentLockedPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveUsersEditorQuery__
 *
 * To run a query within a Vue component, call `useRetrieveUsersEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveUsersEditorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveUsersEditorQuery({
 *   document: // value for 'document'
 * });
 */
export function useRetrieveUsersEditorQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveUsersEditorDocument, variables, options);
}
export function useRetrieveUsersEditorLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveUsersEditorDocument, variables, options);
}
export const CreateVersionEditorDocument = gql `
  mutation createVersionEditor($document: ID!) {
    createVersionEditor(document: $document)
  }
`;
/**
 * __useCreateVersionEditorMutation__
 *
 * To run a mutation, you first call `useCreateVersionEditorMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateVersionEditorMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateVersionEditorMutation({
 *   variables: {
 *     document: // value for 'document'
 *   },
 * });
 */
export function useCreateVersionEditorMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateVersionEditorDocument, options);
}
export const UpdateVariablesDocument = gql `
  mutation updateVariables($id: ID!, $variables: [VariableInput!]!) {
    updateVariables(id: $id, variables: $variables) {
      ...DocumentContentPayloadFull
    }
  }
  ${DocumentContentPayloadFullFragmentDoc}
`;
/**
 * __useUpdateVariablesMutation__
 *
 * To run a mutation, you first call `useUpdateVariablesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVariablesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateVariablesMutation({
 *   variables: {
 *     id: // value for 'id'
 *     variables: // value for 'variables'
 *   },
 * });
 */
export function useUpdateVariablesMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateVariablesDocument, options);
}
export const DocumentContentDocument = gql `
  subscription documentContent($id: ID!) {
    documentContent(id: $id) {
      ...DocumentContentPayloadFull
    }
  }
  ${DocumentContentPayloadFullFragmentDoc}
`;
/**
 * __useDocumentContentSubscription__
 *
 * To run a query within a Vue component, call `useDocumentContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDocumentContentSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useDocumentContentSubscription({
 *   id: // value for 'id'
 * });
 */
export function useDocumentContentSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(DocumentContentDocument, variables, options);
}
export const UsersEditorDocument = gql `
  subscription usersEditor($document: ID!) {
    usersEditor(document: $document) {
      ...DocumentLockedPayloadFull
    }
  }
  ${DocumentLockedPayloadFullFragmentDoc}
`;
/**
 * __useUsersEditorSubscription__
 *
 * To run a query within a Vue component, call `useUsersEditorSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUsersEditorSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useUsersEditorSubscription({
 *   document: // value for 'document'
 * });
 */
export function useUsersEditorSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(UsersEditorDocument, variables, options);
}
export const AccessDocumentLinkDocument = gql `
  query accessDocumentLink($id: ID!) {
    accessDocumentLink(id: $id) {
      ...DocumentLinkSecurePayload
    }
  }
  ${DocumentLinkSecurePayloadFragmentDoc}
`;
/**
 * __useAccessDocumentLinkQuery__
 *
 * To run a query within a Vue component, call `useAccessDocumentLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessDocumentLinkQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAccessDocumentLinkQuery({
 *   id: // value for 'id'
 * });
 */
export function useAccessDocumentLinkQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(AccessDocumentLinkDocument, variables, options);
}
export function useAccessDocumentLinkLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(AccessDocumentLinkDocument, variables, options);
}
export const ValidateAccessDocumentLinkDocument = gql `
  query validateAccessDocumentLink(
    $id: ID!
    $email: String!
    $name: String!
    $password: String
  ) {
    validateAccessDocumentLink(
      id: $id
      email: $email
      name: $name
      password: $password
    ) {
      ...ValidateDocumentLinkPayload
    }
  }
  ${ValidateDocumentLinkPayloadFragmentDoc}
`;
/**
 * __useValidateAccessDocumentLinkQuery__
 *
 * To run a query within a Vue component, call `useValidateAccessDocumentLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateAccessDocumentLinkQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useValidateAccessDocumentLinkQuery({
 *   id: // value for 'id'
 *   email: // value for 'email'
 *   name: // value for 'name'
 *   password: // value for 'password'
 * });
 */
export function useValidateAccessDocumentLinkQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(ValidateAccessDocumentLinkDocument, variables, options);
}
export function useValidateAccessDocumentLinkLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(ValidateAccessDocumentLinkDocument, variables, options);
}
export const RetrieveDocumentLinksDocument = gql `
  query retrieveDocumentLinks($documentId: ID!) {
    retrieveDocumentLinks(documentId: $documentId) {
      ...DocumentLinkPayloadFull
    }
  }
  ${DocumentLinkPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveDocumentLinksQuery__
 *
 * To run a query within a Vue component, call `useRetrieveDocumentLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDocumentLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveDocumentLinksQuery({
 *   documentId: // value for 'documentId'
 * });
 */
export function useRetrieveDocumentLinksQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveDocumentLinksDocument, variables, options);
}
export function useRetrieveDocumentLinksLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveDocumentLinksDocument, variables, options);
}
export const CreateDocumentLinkDocument = gql `
  mutation createDocumentLink(
    $data: CreateDocumentLinkInput!
    $documentId: ID!
  ) {
    createDocumentLink(data: $data, documentId: $documentId) {
      ...DocumentLinkPayloadFull
    }
  }
  ${DocumentLinkPayloadFullFragmentDoc}
`;
/**
 * __useCreateDocumentLinkMutation__
 *
 * To run a mutation, you first call `useCreateDocumentLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDocumentLinkMutation({
 *   variables: {
 *     data: // value for 'data'
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useCreateDocumentLinkMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateDocumentLinkDocument, options);
}
export const UpdateDocumentLinkDocument = gql `
  mutation updateDocumentLink($id: ID!, $data: UpdateDocumentLinkInput!) {
    updateDocumentLink(id: $id, data: $data) {
      ...DocumentLinkPayloadFull
    }
  }
  ${DocumentLinkPayloadFullFragmentDoc}
`;
/**
 * __useUpdateDocumentLinkMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDocumentLinkMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDocumentLinkMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateDocumentLinkDocument, options);
}
export const DeleteDocumentLinkDocument = gql `
  mutation deleteDocumentLink($id: ID!) {
    deleteDocumentLink(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteDocumentLinkMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDocumentLinkMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentLinkMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteDocumentLinkDocument, options);
}
export const LastsActiveUserDocumentDocument = gql `
  query lastsActiveUserDocument {
    retrieveDocumentPoliciesByUser(size: 5) {
      items {
        document {
          id
          name
          status
          statusChecker
        }
      }
    }
  }
`;
/**
 * __useLastsActiveUserDocumentQuery__
 *
 * To run a query within a Vue component, call `useLastsActiveUserDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastsActiveUserDocumentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLastsActiveUserDocumentQuery();
 */
export function useLastsActiveUserDocumentQuery(options = {}) {
    return VueApolloComposable.useQuery(LastsActiveUserDocumentDocument, {}, options);
}
export function useLastsActiveUserDocumentLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(LastsActiveUserDocumentDocument, {}, options);
}
export const RetrieveDocumentPoliciesDocument = gql `
  query retrieveDocumentPolicies(
    $page: Float
    $size: Float
    $orderBy: [DocumentPolicyOrderByInput!]
    $where: DocumentPolicyWhereInput
    $document: ID!
  ) {
    retrieveDocumentPolicies(
      page: $page
      size: $size
      orderBy: $orderBy
      where: $where
      document: $document
    ) {
      items {
        ...DocumentPolicyPayloadFull
      }
      page
      perPage
      pages
      total
    }
  }
  ${DocumentPolicyPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveDocumentPoliciesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveDocumentPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDocumentPoliciesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveDocumentPoliciesQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 *   document: // value for 'document'
 * });
 */
export function useRetrieveDocumentPoliciesQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveDocumentPoliciesDocument, variables, options);
}
export function useRetrieveDocumentPoliciesLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveDocumentPoliciesDocument, variables, options);
}
export const RetrieveDocumentPolicyByUserDocument = gql `
  query retrieveDocumentPolicyByUser($document: ID!) {
    retrieveDocumentPolicyByUser(document: $document) {
      ...DocumentPolicyPayloadFullSingle
    }
  }
  ${DocumentPolicyPayloadFullSingleFragmentDoc}
`;
/**
 * __useRetrieveDocumentPolicyByUserQuery__
 *
 * To run a query within a Vue component, call `useRetrieveDocumentPolicyByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDocumentPolicyByUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveDocumentPolicyByUserQuery({
 *   document: // value for 'document'
 * });
 */
export function useRetrieveDocumentPolicyByUserQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveDocumentPolicyByUserDocument, variables, options);
}
export function useRetrieveDocumentPolicyByUserLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveDocumentPolicyByUserDocument, variables, options);
}
export const RegisterDocumentAccessDocument = gql `
  mutation registerDocumentAccess($id: ID!) {
    registerAccessDocumentPolicy(id: $id) {
      id
    }
  }
`;
/**
 * __useRegisterDocumentAccessMutation__
 *
 * To run a mutation, you first call `useRegisterDocumentAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterDocumentAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterDocumentAccessMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRegisterDocumentAccessMutation(options = {}) {
    return VueApolloComposable.useMutation(RegisterDocumentAccessDocument, options);
}
export const CreateDocumentPolicyDocument = gql `
  mutation createDocumentPolicy(
    $data: CreateDocumentPolicyInput!
    $document: ID!
  ) {
    createDocumentPolicy(data: $data, document: $document) {
      ...DocumentPolicyPayloadFull
    }
  }
  ${DocumentPolicyPayloadFullFragmentDoc}
`;
/**
 * __useCreateDocumentPolicyMutation__
 *
 * To run a mutation, you first call `useCreateDocumentPolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentPolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDocumentPolicyMutation({
 *   variables: {
 *     data: // value for 'data'
 *     document: // value for 'document'
 *   },
 * });
 */
export function useCreateDocumentPolicyMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateDocumentPolicyDocument, options);
}
export const CreateDocumentPoliciesDocument = gql `
  mutation createDocumentPolicies(
    $data: [CreateDocumentPolicyInput!]!
    $document: ID!
  ) {
    createDocumentPolicies(data: $data, document: $document) {
      ...DocumentPolicyPayloadFull
    }
  }
  ${DocumentPolicyPayloadFullFragmentDoc}
`;
/**
 * __useCreateDocumentPoliciesMutation__
 *
 * To run a mutation, you first call `useCreateDocumentPoliciesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentPoliciesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDocumentPoliciesMutation({
 *   variables: {
 *     data: // value for 'data'
 *     document: // value for 'document'
 *   },
 * });
 */
export function useCreateDocumentPoliciesMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateDocumentPoliciesDocument, options);
}
export const SendDocumentPolicyInvitationDocument = gql `
  mutation sendDocumentPolicyInvitation($id: ID!) {
    sendDocumentPolicyInvitation(id: $id) {
      ...DocumentPolicyPayloadFull
    }
  }
  ${DocumentPolicyPayloadFullFragmentDoc}
`;
/**
 * __useSendDocumentPolicyInvitationMutation__
 *
 * To run a mutation, you first call `useSendDocumentPolicyInvitationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendDocumentPolicyInvitationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendDocumentPolicyInvitationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSendDocumentPolicyInvitationMutation(options = {}) {
    return VueApolloComposable.useMutation(SendDocumentPolicyInvitationDocument, options);
}
export const RequestAccessDocumentPolicyDocument = gql `
  mutation requestAccessDocumentPolicy($document: ID!) {
    requestAccessDocumentPolicy(document: $document) {
      ...DocumentPolicyPayloadLite
    }
  }
  ${DocumentPolicyPayloadLiteFragmentDoc}
`;
/**
 * __useRequestAccessDocumentPolicyMutation__
 *
 * To run a mutation, you first call `useRequestAccessDocumentPolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccessDocumentPolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestAccessDocumentPolicyMutation({
 *   variables: {
 *     document: // value for 'document'
 *   },
 * });
 */
export function useRequestAccessDocumentPolicyMutation(options = {}) {
    return VueApolloComposable.useMutation(RequestAccessDocumentPolicyDocument, options);
}
export const AcceptRequestAccessDocumentPolicyDocument = gql `
  mutation acceptRequestAccessDocumentPolicy($id: ID!, $approved: Boolean!) {
    acceptRequestAccessDocumentPolicy(id: $id, approved: $approved)
  }
`;
/**
 * __useAcceptRequestAccessDocumentPolicyMutation__
 *
 * To run a mutation, you first call `useAcceptRequestAccessDocumentPolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptRequestAccessDocumentPolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptRequestAccessDocumentPolicyMutation({
 *   variables: {
 *     id: // value for 'id'
 *     approved: // value for 'approved'
 *   },
 * });
 */
export function useAcceptRequestAccessDocumentPolicyMutation(options = {}) {
    return VueApolloComposable.useMutation(AcceptRequestAccessDocumentPolicyDocument, options);
}
export const UpdateDocumentPolicyDocument = gql `
  mutation updateDocumentPolicy($id: ID!, $data: UpdateDocumentPolicyInput!) {
    updateDocumentPolicy(id: $id, data: $data) {
      ...DocumentPolicyPayloadFull
    }
  }
  ${DocumentPolicyPayloadFullFragmentDoc}
`;
/**
 * __useUpdateDocumentPolicyMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentPolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentPolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDocumentPolicyMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDocumentPolicyMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateDocumentPolicyDocument, options);
}
export const UpdateDocumentPolicyDetailsDocument = gql `
  mutation updateDocumentPolicyDetails(
    $id: ID!
    $data: UpdateDocumentPolicyInput!
  ) {
    updateDocumentPolicy(id: $id, data: $data) {
      ...DocumentPolicyPayloadFullSingle
    }
  }
  ${DocumentPolicyPayloadFullSingleFragmentDoc}
`;
/**
 * __useUpdateDocumentPolicyDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentPolicyDetailsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentPolicyDetailsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDocumentPolicyDetailsMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDocumentPolicyDetailsMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateDocumentPolicyDetailsDocument, options);
}
export const DeleteDocumentPolicyDocument = gql `
  mutation deleteDocumentPolicy($id: ID!) {
    deleteDocumentPolicy(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteDocumentPolicyMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentPolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentPolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDocumentPolicyMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentPolicyMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteDocumentPolicyDocument, options);
}
export const DeleteDocumentPoliciesDocument = gql `
  mutation deleteDocumentPolicies($ids: [ID!]!, $document: ID!) {
    deleteDocumentPolicies(ids: $ids, document: $document) {
      deleted
    }
  }
`;
/**
 * __useDeleteDocumentPoliciesMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentPoliciesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentPoliciesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDocumentPoliciesMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *     document: // value for 'document'
 *   },
 * });
 */
export function useDeleteDocumentPoliciesMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteDocumentPoliciesDocument, options);
}
export const DocumentPoliciesSubscriptionDocument = gql `
  subscription documentPoliciesSubscription($document: ID!) {
    documentPolicies(document: $document) {
      item {
        ...DocumentPolicyPayloadFull
      }
      action
    }
  }
  ${DocumentPolicyPayloadFullFragmentDoc}
`;
/**
 * __useDocumentPoliciesSubscriptionSubscription__
 *
 * To run a query within a Vue component, call `useDocumentPoliciesSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDocumentPoliciesSubscriptionSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useDocumentPoliciesSubscriptionSubscription({
 *   document: // value for 'document'
 * });
 */
export function useDocumentPoliciesSubscriptionSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(DocumentPoliciesSubscriptionDocument, variables, options);
}
export const DocumentPolicyDocument = gql `
  subscription documentPolicy($document: ID!) {
    documentPolicy(document: $document) {
      ...DocumentPolicyPayloadFullSingle
    }
  }
  ${DocumentPolicyPayloadFullSingleFragmentDoc}
`;
/**
 * __useDocumentPolicySubscription__
 *
 * To run a query within a Vue component, call `useDocumentPolicySubscription` and pass it any options that fit your needs.
 * When your component renders, `useDocumentPolicySubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useDocumentPolicySubscription({
 *   document: // value for 'document'
 * });
 */
export function useDocumentPolicySubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(DocumentPolicyDocument, variables, options);
}
export const RetrieveDocumentRelationDocument = gql `
  query retrieveDocumentRelation($id: ID!, $documentId: ID!) {
    retrieveDocumentRelation(id: $id, documentId: $documentId) {
      ...DocumentRelationPayloadFull
    }
  }
  ${DocumentRelationPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveDocumentRelationQuery__
 *
 * To run a query within a Vue component, call `useRetrieveDocumentRelationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDocumentRelationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveDocumentRelationQuery({
 *   id: // value for 'id'
 *   documentId: // value for 'documentId'
 * });
 */
export function useRetrieveDocumentRelationQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveDocumentRelationDocument, variables, options);
}
export function useRetrieveDocumentRelationLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveDocumentRelationDocument, variables, options);
}
export const RetrieveDocumentRelationsDocument = gql `
  query retrieveDocumentRelations(
    $documentId: ID!
    $page: Float
    $size: Float
    $orderBy: [DocumentRelationOrderByInput!]
    $where: DocumentRelationWhereInput
  ) {
    retrieveDocumentRelations(
      documentId: $documentId
      page: $page
      size: $size
      orderBy: $orderBy
      where: $where
    ) {
      items {
        ...DocumentRelationExtendedPayload
      }
      page
      perPage
      pages
      total
    }
  }
  ${DocumentRelationExtendedPayloadFragmentDoc}
`;
/**
 * __useRetrieveDocumentRelationsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveDocumentRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDocumentRelationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveDocumentRelationsQuery({
 *   documentId: // value for 'documentId'
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveDocumentRelationsQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveDocumentRelationsDocument, variables, options);
}
export function useRetrieveDocumentRelationsLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveDocumentRelationsDocument, variables, options);
}
export const CountDocumentRelationsDocument = gql `
  query countDocumentRelations($documentId: ID!) {
    countDocumentRelations(documentId: $documentId)
  }
`;
/**
 * __useCountDocumentRelationsQuery__
 *
 * To run a query within a Vue component, call `useCountDocumentRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDocumentRelationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountDocumentRelationsQuery({
 *   documentId: // value for 'documentId'
 * });
 */
export function useCountDocumentRelationsQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(CountDocumentRelationsDocument, variables, options);
}
export function useCountDocumentRelationsLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(CountDocumentRelationsDocument, variables, options);
}
export const CreateDocumentRelationDocument = gql `
  mutation createDocumentRelation($data: CreateDocumentRelationInput!) {
    createDocumentRelation(data: $data) {
      ...DocumentRelationPayloadFull
    }
  }
  ${DocumentRelationPayloadFullFragmentDoc}
`;
/**
 * __useCreateDocumentRelationMutation__
 *
 * To run a mutation, you first call `useCreateDocumentRelationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentRelationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDocumentRelationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateDocumentRelationMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateDocumentRelationDocument, options);
}
export const UpdateDocumentRelationDocument = gql `
  mutation updateDocumentRelation(
    $data: UpdateDocumentRelationInput!
    $id: ID!
    $documentId: ID!
  ) {
    updateDocumentRelation(data: $data, id: $id, documentId: $documentId) {
      ...DocumentRelationPayloadFull
    }
  }
  ${DocumentRelationPayloadFullFragmentDoc}
`;
/**
 * __useUpdateDocumentRelationMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentRelationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentRelationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDocumentRelationMutation({
 *   variables: {
 *     data: // value for 'data'
 *     id: // value for 'id'
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useUpdateDocumentRelationMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateDocumentRelationDocument, options);
}
export const DeleteDocumentRelationDocument = gql `
  mutation deleteDocumentRelation($id: ID!, $documentId: ID!) {
    deleteDocumentRelation(id: $id, documentId: $documentId) {
      deleted
    }
  }
`;
/**
 * __useDeleteDocumentRelationMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentRelationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentRelationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDocumentRelationMutation({
 *   variables: {
 *     id: // value for 'id'
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteDocumentRelationMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteDocumentRelationDocument, options);
}
export const DeleteDocumentRelationsDocument = gql `
  mutation deleteDocumentRelations($ids: [ID!]!, $documentId: ID!) {
    deleteDocumentRelations(ids: $ids, documentId: $documentId) {
      deleted
    }
  }
`;
/**
 * __useDeleteDocumentRelationsMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentRelationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentRelationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDocumentRelationsMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteDocumentRelationsMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteDocumentRelationsDocument, options);
}
export const DocumentRelationDocument = gql `
  subscription documentRelation($id: ID!, $documentId: ID!) {
    documentRelation(id: $id, documentId: $documentId) {
      ...DocumentRelationPayloadFull
    }
  }
  ${DocumentRelationPayloadFullFragmentDoc}
`;
/**
 * __useDocumentRelationSubscription__
 *
 * To run a query within a Vue component, call `useDocumentRelationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDocumentRelationSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useDocumentRelationSubscription({
 *   id: // value for 'id'
 *   documentId: // value for 'documentId'
 * });
 */
export function useDocumentRelationSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(DocumentRelationDocument, variables, options);
}
export const DocumentRelationsDocument = gql `
  subscription documentRelations($documentId: ID!) {
    documentRelations(documentId: $documentId) {
      item {
        ...DocumentRelationPayloadFull
      }
      action
    }
  }
  ${DocumentRelationPayloadFullFragmentDoc}
`;
/**
 * __useDocumentRelationsSubscription__
 *
 * To run a query within a Vue component, call `useDocumentRelationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDocumentRelationsSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useDocumentRelationsSubscription({
 *   documentId: // value for 'documentId'
 * });
 */
export function useDocumentRelationsSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(DocumentRelationsDocument, variables, options);
}
export const RetrieveDocumentRolesDocument = gql `
  query retrieveDocumentRoles($document: ID) {
    retrieveDocumentRoles(document: $document) {
      ...DocumentRoleExtendedPayload
    }
  }
  ${DocumentRoleExtendedPayloadFragmentDoc}
`;
/**
 * __useRetrieveDocumentRolesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveDocumentRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDocumentRolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveDocumentRolesQuery({
 *   document: // value for 'document'
 * });
 */
export function useRetrieveDocumentRolesQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveDocumentRolesDocument, variables, options);
}
export function useRetrieveDocumentRolesLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveDocumentRolesDocument, variables, options);
}
export const RetrieveFolderDocument = gql `
  query retrieveFolder($id: ID!) {
    retrieveFolder(id: $id) {
      ...FolderPayloadFull
    }
  }
  ${FolderPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveFolderQuery__
 *
 * To run a query within a Vue component, call `useRetrieveFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveFolderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveFolderQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveFolderQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveFolderDocument, variables, options);
}
export function useRetrieveFolderLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveFolderDocument, variables, options);
}
export const RetrieveFoldersDocument = gql `
  query retrieveFolders(
    $group: FolderGroupEnum!
    $page: Float
    $size: Float
    $orderBy: [FolderOrderByInput!]
    $where: FolderWhereInput
  ) {
    retrieveFolders(
      group: $group
      page: $page
      size: $size
      orderBy: $orderBy
      where: $where
    ) {
      items {
        ...FolderExtendedPayload
      }
      page
      perPage
      pages
      total
    }
  }
  ${FolderExtendedPayloadFragmentDoc}
`;
/**
 * __useRetrieveFoldersQuery__
 *
 * To run a query within a Vue component, call `useRetrieveFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveFoldersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveFoldersQuery({
 *   group: // value for 'group'
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveFoldersQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveFoldersDocument, variables, options);
}
export function useRetrieveFoldersLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveFoldersDocument, variables, options);
}
export const RetrieveAllFoldersDocument = gql `
  query retrieveAllFolders(
    $group: FolderGroupEnum!
    $size: Float
    $where: FolderWhereInput
  ) {
    retrieveFolders(group: $group, size: $size, where: $where) {
      items {
        id
      }
    }
  }
`;
/**
 * __useRetrieveAllFoldersQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAllFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAllFoldersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAllFoldersQuery({
 *   group: // value for 'group'
 *   size: // value for 'size'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveAllFoldersQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveAllFoldersDocument, variables, options);
}
export function useRetrieveAllFoldersLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAllFoldersDocument, variables, options);
}
export const CountFoldersDocument = gql `
  query countFolders($group: FolderGroupEnum!) {
    countFolders(group: $group)
  }
`;
/**
 * __useCountFoldersQuery__
 *
 * To run a query within a Vue component, call `useCountFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountFoldersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountFoldersQuery({
 *   group: // value for 'group'
 * });
 */
export function useCountFoldersQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(CountFoldersDocument, variables, options);
}
export function useCountFoldersLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(CountFoldersDocument, variables, options);
}
export const CreateFolderDocument = gql `
  mutation createFolder($data: CreateFolderInput!) {
    createFolder(data: $data) {
      ...FolderPayloadFull
    }
  }
  ${FolderPayloadFullFragmentDoc}
`;
/**
 * __useCreateFolderMutation__
 *
 * To run a mutation, you first call `useCreateFolderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateFolderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateFolderMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateFolderMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateFolderDocument, options);
}
export const UpdateFolderDocument = gql `
  mutation updateFolder($id: ID!, $data: UpdateFolderInput!) {
    updateFolder(data: $data, id: $id) {
      ...FolderPayloadFull
    }
  }
  ${FolderPayloadFullFragmentDoc}
`;
/**
 * __useUpdateFolderMutation__
 *
 * To run a mutation, you first call `useUpdateFolderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFolderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateFolderMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFolderMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateFolderDocument, options);
}
export const DeleteFolderDocument = gql `
  mutation deleteFolder($id: ID!) {
    deleteFolder(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteFolderMutation__
 *
 * To run a mutation, you first call `useDeleteFolderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteFolderMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFolderMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteFolderDocument, options);
}
export const DeleteFoldersDocument = gql `
  mutation deleteFolders($ids: [ID!]!) {
    deleteFolders(ids: $ids) {
      deleted
    }
  }
`;
/**
 * __useDeleteFoldersMutation__
 *
 * To run a mutation, you first call `useDeleteFoldersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFoldersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteFoldersMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteFoldersMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteFoldersDocument, options);
}
export const FolderDocument = gql `
  subscription folder($id: ID!) {
    folder(id: $id) {
      ...FolderPayloadFull
    }
  }
  ${FolderPayloadFullFragmentDoc}
`;
/**
 * __useFolderSubscription__
 *
 * To run a query within a Vue component, call `useFolderSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFolderSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useFolderSubscription({
 *   id: // value for 'id'
 * });
 */
export function useFolderSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(FolderDocument, variables, options);
}
export const RetrieveFormFlowDocument = gql `
  query retrieveFormFlow($id: ID!) {
    retrieveFormFlow(id: $id) {
      ...FormFlowPayloadFull
    }
  }
  ${FormFlowPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveFormFlowQuery__
 *
 * To run a query within a Vue component, call `useRetrieveFormFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveFormFlowQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveFormFlowQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveFormFlowQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveFormFlowDocument, variables, options);
}
export function useRetrieveFormFlowLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveFormFlowDocument, variables, options);
}
export const RetrieveFormFlowsDocument = gql `
  query retrieveFormFlows(
    $page: Float
    $size: Float
    $orderBy: [FormFlowOrderByInput!]
    $document: String!
  ) {
    retrieveFormFlows(
      page: $page
      size: $size
      orderBy: $orderBy
      document: $document
    ) {
      items {
        ...FormFlowPayloadLite
        questions
      }
      page
      perPage
      pages
      total
    }
  }
  ${FormFlowPayloadLiteFragmentDoc}
`;
/**
 * __useRetrieveFormFlowsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveFormFlowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveFormFlowsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveFormFlowsQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   document: // value for 'document'
 * });
 */
export function useRetrieveFormFlowsQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveFormFlowsDocument, variables, options);
}
export function useRetrieveFormFlowsLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveFormFlowsDocument, variables, options);
}
export const CountFormFlowsDocument = gql `
  query countFormFlows($document: String!) {
    countFormFlows(document: $document)
  }
`;
/**
 * __useCountFormFlowsQuery__
 *
 * To run a query within a Vue component, call `useCountFormFlowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountFormFlowsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountFormFlowsQuery({
 *   document: // value for 'document'
 * });
 */
export function useCountFormFlowsQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(CountFormFlowsDocument, variables, options);
}
export function useCountFormFlowsLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(CountFormFlowsDocument, variables, options);
}
export const CreateFormFlowDocument = gql `
  mutation createFormFlow($data: CreateFormFlowInput!) {
    createFormFlow(data: $data) {
      ...FormFlowPayloadFull
    }
  }
  ${FormFlowPayloadFullFragmentDoc}
`;
/**
 * __useCreateFormFlowMutation__
 *
 * To run a mutation, you first call `useCreateFormFlowMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormFlowMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateFormFlowMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateFormFlowMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateFormFlowDocument, options);
}
export const UpdateFormFlowDocument = gql `
  mutation updateFormFlow($id: String!, $data: UpdateFormFlowInput!) {
    updateFormFlow(id: $id, data: $data) {
      ...FormFlowPayloadFull
    }
  }
  ${FormFlowPayloadFullFragmentDoc}
`;
/**
 * __useUpdateFormFlowMutation__
 *
 * To run a mutation, you first call `useUpdateFormFlowMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormFlowMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateFormFlowMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFormFlowMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateFormFlowDocument, options);
}
export const DeleteFormFlowDocument = gql `
  mutation deleteFormFlow($id: ID!) {
    deleteFormFlow(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteFormFlowMutation__
 *
 * To run a mutation, you first call `useDeleteFormFlowMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormFlowMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteFormFlowMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFormFlowMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteFormFlowDocument, options);
}
export const GenerateDocumentFormFlowDocument = gql `
  mutation generateDocumentFormFlow(
    $id: String!
    $variables: JSON!
    $completedFlowUser: CompletedByUserInput
    $source: String!
  ) {
    generateDocumentFormFlow(
      id: $id
      variables: $variables
      completedFlowUser: $completedFlowUser
      source: $source
    ) {
      id
    }
  }
`;
/**
 * __useGenerateDocumentFormFlowMutation__
 *
 * To run a mutation, you first call `useGenerateDocumentFormFlowMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDocumentFormFlowMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateDocumentFormFlowMutation({
 *   variables: {
 *     id: // value for 'id'
 *     variables: // value for 'variables'
 *     completedFlowUser: // value for 'completedFlowUser'
 *     source: // value for 'source'
 *   },
 * });
 */
export function useGenerateDocumentFormFlowMutation(options = {}) {
    return VueApolloComposable.useMutation(GenerateDocumentFormFlowDocument, options);
}
export const AutoCreateQuestionsDocument = gql `
  mutation autoCreateQuestions($id: ID!) {
    autoCreateQuestions(id: $id) {
      id
    }
  }
`;
/**
 * __useAutoCreateQuestionsMutation__
 *
 * To run a mutation, you first call `useAutoCreateQuestionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAutoCreateQuestionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAutoCreateQuestionsMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useAutoCreateQuestionsMutation(options = {}) {
    return VueApolloComposable.useMutation(AutoCreateQuestionsDocument, options);
}
export const FormFlowDocument = gql `
  subscription formFlow($id: ID!) {
    formFlow(id: $id) {
      ...FormFlowPayloadFull
    }
  }
  ${FormFlowPayloadFullFragmentDoc}
`;
/**
 * __useFormFlowSubscription__
 *
 * To run a query within a Vue component, call `useFormFlowSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFormFlowSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useFormFlowSubscription({
 *   id: // value for 'id'
 * });
 */
export function useFormFlowSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(FormFlowDocument, variables, options);
}
export const RetrievePublicFormFlowShareDocument = gql `
  query retrievePublicFormFlowShare($id: ID!) {
    retrievePublicFormFlowShare(id: $id) {
      ...FormFlowShareSecurePayload
    }
  }
  ${FormFlowShareSecurePayloadFragmentDoc}
`;
/**
 * __useRetrievePublicFormFlowShareQuery__
 *
 * To run a query within a Vue component, call `useRetrievePublicFormFlowShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrievePublicFormFlowShareQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrievePublicFormFlowShareQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrievePublicFormFlowShareQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrievePublicFormFlowShareDocument, variables, options);
}
export function useRetrievePublicFormFlowShareLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrievePublicFormFlowShareDocument, variables, options);
}
export const RetrieveValidateFormFlowShareDocument = gql `
  query retrieveValidateFormFlowShare($id: ID!, $code: String) {
    retrieveValidateFormFlowShare(id: $id, code: $code) {
      ...FormFlowSharePayloadFull
      account {
        ...AccountBasicPayload
        capabilities
      }
    }
  }
  ${FormFlowSharePayloadFullFragmentDoc}
  ${AccountBasicPayloadFragmentDoc}
`;
/**
 * __useRetrieveValidateFormFlowShareQuery__
 *
 * To run a query within a Vue component, call `useRetrieveValidateFormFlowShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveValidateFormFlowShareQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveValidateFormFlowShareQuery({
 *   id: // value for 'id'
 *   code: // value for 'code'
 * });
 */
export function useRetrieveValidateFormFlowShareQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveValidateFormFlowShareDocument, variables, options);
}
export function useRetrieveValidateFormFlowShareLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveValidateFormFlowShareDocument, variables, options);
}
export const RetrieveFormFlowSharesDocument = gql `
  query retrieveFormFlowShares(
    $page: Float
    $size: Float
    $orderBy: [FormFlowShareOrderByInput!]
    $formFlow: String!
  ) {
    retrieveFormFlowShares(
      page: $page
      size: $size
      orderBy: $orderBy
      formFlow: $formFlow
    ) {
      items {
        ...FormFlowSharePayloadExtended
      }
      page
      perPage
      pages
      total
    }
  }
  ${FormFlowSharePayloadExtendedFragmentDoc}
`;
/**
 * __useRetrieveFormFlowSharesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveFormFlowSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveFormFlowSharesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveFormFlowSharesQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   formFlow: // value for 'formFlow'
 * });
 */
export function useRetrieveFormFlowSharesQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveFormFlowSharesDocument, variables, options);
}
export function useRetrieveFormFlowSharesLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveFormFlowSharesDocument, variables, options);
}
export const UpsertFormFlowShareDocument = gql `
  mutation upsertFormFlowShare($data: UpdateOrCreateFormFlowShare!) {
    upsertFormFlowShare(data: $data) {
      ...FormFlowSharePayloadExtended
    }
  }
  ${FormFlowSharePayloadExtendedFragmentDoc}
`;
/**
 * __useUpsertFormFlowShareMutation__
 *
 * To run a mutation, you first call `useUpsertFormFlowShareMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFormFlowShareMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertFormFlowShareMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpsertFormFlowShareMutation(options = {}) {
    return VueApolloComposable.useMutation(UpsertFormFlowShareDocument, options);
}
export const DeleteFormFlowShareDocument = gql `
  mutation deleteFormFlowShare($id: ID!) {
    deleteFormFlowShare(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteFormFlowShareMutation__
 *
 * To run a mutation, you first call `useDeleteFormFlowShareMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormFlowShareMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteFormFlowShareMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFormFlowShareMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteFormFlowShareDocument, options);
}
export const RetrieveIntakeDocument = gql `
  query retrieveIntake($id: ID!) {
    retrieveIntake(id: $id) {
      ...IntakePayloadFull
    }
  }
  ${IntakePayloadFullFragmentDoc}
`;
/**
 * __useRetrieveIntakeQuery__
 *
 * To run a query within a Vue component, call `useRetrieveIntakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveIntakeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveIntakeQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveIntakeQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveIntakeDocument, variables, options);
}
export function useRetrieveIntakeLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveIntakeDocument, variables, options);
}
export const RetrieveIntakesDocument = gql `
  query retrieveIntakes(
    $page: Float
    $size: Float
    $orderBy: [IntakeOrderByInput!]
    $where: IntakeWhereInput
  ) {
    retrieveIntakes(
      page: $page
      size: $size
      orderBy: $orderBy
      where: $where
    ) {
      items {
        ...IntakePayloadLite
        createdAt
        updatedAt
      }
      page
      perPage
      pages
      total
    }
  }
  ${IntakePayloadLiteFragmentDoc}
`;
/**
 * __useRetrieveIntakesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveIntakesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveIntakesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveIntakesQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveIntakesQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveIntakesDocument, variables, options);
}
export function useRetrieveIntakesLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveIntakesDocument, variables, options);
}
export const CountIntakesDocument = gql `
  query countIntakes {
    countIntakes
  }
`;
/**
 * __useCountIntakesQuery__
 *
 * To run a query within a Vue component, call `useCountIntakesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountIntakesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountIntakesQuery();
 */
export function useCountIntakesQuery(options = {}) {
    return VueApolloComposable.useQuery(CountIntakesDocument, {}, options);
}
export function useCountIntakesLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(CountIntakesDocument, {}, options);
}
export const CreateIntakeDocument = gql `
  mutation createIntake($data: CreateIntakeInput!) {
    createIntake(data: $data) {
      ...IntakePayloadFull
    }
  }
  ${IntakePayloadFullFragmentDoc}
`;
/**
 * __useCreateIntakeMutation__
 *
 * To run a mutation, you first call `useCreateIntakeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntakeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateIntakeMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateIntakeMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateIntakeDocument, options);
}
export const UpdateIntakeDocument = gql `
  mutation updateIntake($id: String!, $data: UpdateIntakeInput!) {
    updateIntake(id: $id, data: $data) {
      ...IntakePayloadFull
    }
  }
  ${IntakePayloadFullFragmentDoc}
`;
/**
 * __useUpdateIntakeMutation__
 *
 * To run a mutation, you first call `useUpdateIntakeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntakeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateIntakeMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateIntakeMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateIntakeDocument, options);
}
export const DeleteIntakeDocument = gql `
  mutation deleteIntake($id: ID!) {
    deleteIntake(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteIntakeMutation__
 *
 * To run a mutation, you first call `useDeleteIntakeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntakeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteIntakeMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIntakeMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteIntakeDocument, options);
}
export const IntakeDocument = gql `
  subscription intake($id: ID!) {
    intake(id: $id) {
      ...IntakePayloadFull
    }
  }
  ${IntakePayloadFullFragmentDoc}
`;
/**
 * __useIntakeSubscription__
 *
 * To run a query within a Vue component, call `useIntakeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntakeSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useIntakeSubscription({
 *   id: // value for 'id'
 * });
 */
export function useIntakeSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(IntakeDocument, variables, options);
}
export const IntakesDocument = gql `
  subscription intakes {
    intakes {
      item {
        ...IntakePayloadLite
      }
      action
    }
  }
  ${IntakePayloadLiteFragmentDoc}
`;
/**
 * __useIntakesSubscription__
 *
 * To run a query within a Vue component, call `useIntakesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntakesSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useIntakesSubscription();
 */
export function useIntakesSubscription(options = {}) {
    return VueApolloComposable.useSubscription(IntakesDocument, {}, options);
}
export const CreateIntakeResponseDocument = gql `
  mutation createIntakeResponse(
    $data: CreateIntakeResponseInput!
    $intakeId: ID!
    $source: String!
  ) {
    createIntakeResponse(data: $data, intakeId: $intakeId, source: $source) {
      ...IntakeResponsePayloadExtended
    }
  }
  ${IntakeResponsePayloadExtendedFragmentDoc}
`;
/**
 * __useCreateIntakeResponseMutation__
 *
 * To run a mutation, you first call `useCreateIntakeResponseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntakeResponseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateIntakeResponseMutation({
 *   variables: {
 *     data: // value for 'data'
 *     intakeId: // value for 'intakeId'
 *     source: // value for 'source'
 *   },
 * });
 */
export function useCreateIntakeResponseMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateIntakeResponseDocument, options);
}
export const RetrieveIntakeShareDocument = gql `
  query retrieveIntakeShare($id: ID!) {
    retrieveIntakeShare(id: $id) {
      ...IntakeSharePayloadFull
    }
  }
  ${IntakeSharePayloadFullFragmentDoc}
`;
/**
 * __useRetrieveIntakeShareQuery__
 *
 * To run a query within a Vue component, call `useRetrieveIntakeShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveIntakeShareQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveIntakeShareQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveIntakeShareQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveIntakeShareDocument, variables, options);
}
export function useRetrieveIntakeShareLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveIntakeShareDocument, variables, options);
}
export const RetrievePublicIntakeShareDocument = gql `
  query retrievePublicIntakeShare($id: ID!) {
    retrievePublicIntakeShare(id: $id) {
      ...IntakeShareSecurePayload
    }
  }
  ${IntakeShareSecurePayloadFragmentDoc}
`;
/**
 * __useRetrievePublicIntakeShareQuery__
 *
 * To run a query within a Vue component, call `useRetrievePublicIntakeShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrievePublicIntakeShareQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrievePublicIntakeShareQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrievePublicIntakeShareQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrievePublicIntakeShareDocument, variables, options);
}
export function useRetrievePublicIntakeShareLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrievePublicIntakeShareDocument, variables, options);
}
export const RetrieveValidateIntakeShareDocument = gql `
  query retrieveValidateIntakeShare($id: ID!, $code: String) {
    retrieveValidateIntakeShare(id: $id, code: $code) {
      ...IntakeSharePayloadFull
      account {
        ...AccountBasicPayload
        capabilities
      }
    }
  }
  ${IntakeSharePayloadFullFragmentDoc}
  ${AccountBasicPayloadFragmentDoc}
`;
/**
 * __useRetrieveValidateIntakeShareQuery__
 *
 * To run a query within a Vue component, call `useRetrieveValidateIntakeShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveValidateIntakeShareQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveValidateIntakeShareQuery({
 *   id: // value for 'id'
 *   code: // value for 'code'
 * });
 */
export function useRetrieveValidateIntakeShareQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveValidateIntakeShareDocument, variables, options);
}
export function useRetrieveValidateIntakeShareLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveValidateIntakeShareDocument, variables, options);
}
export const RetrieveIntakeSharesDocument = gql `
  query retrieveIntakeShares(
    $page: Float
    $size: Float
    $orderBy: [IntakeShareOrderByInput!]
    $intake: String!
  ) {
    retrieveIntakeShares(
      page: $page
      size: $size
      orderBy: $orderBy
      intake: $intake
    ) {
      items {
        ...IntakeSharePayloadExtended
      }
      page
      perPage
      pages
      total
    }
  }
  ${IntakeSharePayloadExtendedFragmentDoc}
`;
/**
 * __useRetrieveIntakeSharesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveIntakeSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveIntakeSharesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveIntakeSharesQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   intake: // value for 'intake'
 * });
 */
export function useRetrieveIntakeSharesQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveIntakeSharesDocument, variables, options);
}
export function useRetrieveIntakeSharesLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveIntakeSharesDocument, variables, options);
}
export const UpsertIntakeShareDocument = gql `
  mutation upsertIntakeShare($data: UpdateOrCreateIntakeShare!) {
    upsertIntakeShare(data: $data) {
      ...IntakeSharePayloadExtended
    }
  }
  ${IntakeSharePayloadExtendedFragmentDoc}
`;
/**
 * __useUpsertIntakeShareMutation__
 *
 * To run a mutation, you first call `useUpsertIntakeShareMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertIntakeShareMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertIntakeShareMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpsertIntakeShareMutation(options = {}) {
    return VueApolloComposable.useMutation(UpsertIntakeShareDocument, options);
}
export const DeleteIntakeShareDocument = gql `
  mutation deleteIntakeShare($id: ID!) {
    deleteIntakeShare(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteIntakeShareMutation__
 *
 * To run a mutation, you first call `useDeleteIntakeShareMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntakeShareMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteIntakeShareMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIntakeShareMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteIntakeShareDocument, options);
}
export const IntakeSharesDocument = gql `
  subscription intakeShares($intakeId: ID!) {
    intakeShares(intakeId: $intakeId) {
      item {
        ...IntakeSharePayloadFull
      }
      action
    }
  }
  ${IntakeSharePayloadFullFragmentDoc}
`;
/**
 * __useIntakeSharesSubscription__
 *
 * To run a query within a Vue component, call `useIntakeSharesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntakeSharesSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useIntakeSharesSubscription({
 *   intakeId: // value for 'intakeId'
 * });
 */
export function useIntakeSharesSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(IntakeSharesDocument, variables, options);
}
export const RetrieveIntegrationsDocument = gql `
  query retrieveIntegrations {
    retrieveIntegrations {
      ...IntegrationPayloadFull
    }
  }
  ${IntegrationPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveIntegrationsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveIntegrationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveIntegrationsQuery();
 */
export function useRetrieveIntegrationsQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveIntegrationsDocument, {}, options);
}
export function useRetrieveIntegrationsLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveIntegrationsDocument, {}, options);
}
export const RetrieveAccountIntegrationDocument = gql `
  query retrieveAccountIntegration($integrationId: ID!) {
    retrieveAccountIntegration(integrationId: $integrationId) {
      ...AccountIntegrationPayloadFull
    }
  }
  ${AccountIntegrationPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveAccountIntegrationQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAccountIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAccountIntegrationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAccountIntegrationQuery({
 *   integrationId: // value for 'integrationId'
 * });
 */
export function useRetrieveAccountIntegrationQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveAccountIntegrationDocument, variables, options);
}
export function useRetrieveAccountIntegrationLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAccountIntegrationDocument, variables, options);
}
export const RetrieveAccountIntegrationsDocument = gql `
  query retrieveAccountIntegrations {
    retrieveAccountIntegrations {
      ...AccountIntegrationPayloadLite
    }
  }
  ${AccountIntegrationPayloadLiteFragmentDoc}
`;
/**
 * __useRetrieveAccountIntegrationsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAccountIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAccountIntegrationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAccountIntegrationsQuery();
 */
export function useRetrieveAccountIntegrationsQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveAccountIntegrationsDocument, {}, options);
}
export function useRetrieveAccountIntegrationsLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAccountIntegrationsDocument, {}, options);
}
export const EnableAccountIntegrationDocument = gql `
  mutation enableAccountIntegration(
    $data: EnableAccountIntegrationInput!
    $integrationId: ID!
  ) {
    enableAccountIntegration(data: $data, integrationId: $integrationId) {
      ...AccountIntegrationPayloadFull
    }
  }
  ${AccountIntegrationPayloadFullFragmentDoc}
`;
/**
 * __useEnableAccountIntegrationMutation__
 *
 * To run a mutation, you first call `useEnableAccountIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableAccountIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableAccountIntegrationMutation({
 *   variables: {
 *     data: // value for 'data'
 *     integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useEnableAccountIntegrationMutation(options = {}) {
    return VueApolloComposable.useMutation(EnableAccountIntegrationDocument, options);
}
export const UpdateAccountIntegrationDocument = gql `
  mutation updateAccountIntegration(
    $data: UpdateAccountIntegrationInput!
    $id: ID!
  ) {
    updateAccountIntegration(data: $data, id: $id) {
      ...AccountIntegrationPayloadFull
    }
  }
  ${AccountIntegrationPayloadFullFragmentDoc}
`;
/**
 * __useUpdateAccountIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateAccountIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountIntegrationMutation({
 *   variables: {
 *     data: // value for 'data'
 *     id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAccountIntegrationMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateAccountIntegrationDocument, options);
}
export const DeleteAccountIntegrationDocument = gql `
  mutation deleteAccountIntegration($integrationId: ID!) {
    deleteAccountIntegration(integrationId: $integrationId) {
      deleted
    }
  }
`;
/**
 * __useDeleteAccountIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteAccountIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAccountIntegrationMutation({
 *   variables: {
 *     integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useDeleteAccountIntegrationMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteAccountIntegrationDocument, options);
}
export const GenerateAccountIntegrationApiKeyDocument = gql `
  mutation generateAccountIntegrationApiKey($integrationId: ID!) {
    generateAccountIntegrationApiKey(integrationId: $integrationId) {
      apiKey
    }
  }
`;
/**
 * __useGenerateAccountIntegrationApiKeyMutation__
 *
 * To run a mutation, you first call `useGenerateAccountIntegrationApiKeyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAccountIntegrationApiKeyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateAccountIntegrationApiKeyMutation({
 *   variables: {
 *     integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGenerateAccountIntegrationApiKeyMutation(options = {}) {
    return VueApolloComposable.useMutation(GenerateAccountIntegrationApiKeyDocument, options);
}
export const RetrieveMarketplaceItemDocument = gql `
  query retrieveMarketplaceItem($id: ID!) {
    retrieveMarketplaceItem(id: $id) {
      ...MarketplaceItemPayloadFull
    }
  }
  ${MarketplaceItemPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveMarketplaceItemQuery__
 *
 * To run a query within a Vue component, call `useRetrieveMarketplaceItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveMarketplaceItemQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveMarketplaceItemQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveMarketplaceItemQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveMarketplaceItemDocument, variables, options);
}
export function useRetrieveMarketplaceItemLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveMarketplaceItemDocument, variables, options);
}
export const RetrieveMarketplaceItemByDocumentDocument = gql `
  query retrieveMarketplaceItemByDocument($documentId: ID!) {
    retrieveMarketplaceItemByDocument(documentId: $documentId) {
      ...MarketplaceItemPayloadFull
    }
  }
  ${MarketplaceItemPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveMarketplaceItemByDocumentQuery__
 *
 * To run a query within a Vue component, call `useRetrieveMarketplaceItemByDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveMarketplaceItemByDocumentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveMarketplaceItemByDocumentQuery({
 *   documentId: // value for 'documentId'
 * });
 */
export function useRetrieveMarketplaceItemByDocumentQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveMarketplaceItemByDocumentDocument, variables, options);
}
export function useRetrieveMarketplaceItemByDocumentLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveMarketplaceItemByDocumentDocument, variables, options);
}
export const BuyMarketplaceItemDocument = gql `
  mutation buyMarketplaceItem($id: ID!) {
    buyMarketplaceItem(id: $id)
  }
`;
/**
 * __useBuyMarketplaceItemMutation__
 *
 * To run a mutation, you first call `useBuyMarketplaceItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBuyMarketplaceItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBuyMarketplaceItemMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useBuyMarketplaceItemMutation(options = {}) {
    return VueApolloComposable.useMutation(BuyMarketplaceItemDocument, options);
}
export const CreateMarketplaceItemDocument = gql `
  mutation createMarketplaceItem($data: CreateMarketplaceItemInput!) {
    createMarketplaceItem(data: $data) {
      ...MarketplaceItemPayloadFull
    }
  }
  ${MarketplaceItemPayloadFullFragmentDoc}
`;
/**
 * __useCreateMarketplaceItemMutation__
 *
 * To run a mutation, you first call `useCreateMarketplaceItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarketplaceItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMarketplaceItemMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateMarketplaceItemMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateMarketplaceItemDocument, options);
}
export const UpdateMarketplaceItemDocument = gql `
  mutation updateMarketplaceItem($id: ID!, $data: UpdateMarketplaceItemInput!) {
    updateMarketplaceItem(id: $id, data: $data) {
      ...MarketplaceItemPayloadFull
    }
  }
  ${MarketplaceItemPayloadFullFragmentDoc}
`;
/**
 * __useUpdateMarketplaceItemMutation__
 *
 * To run a mutation, you first call `useUpdateMarketplaceItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketplaceItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMarketplaceItemMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMarketplaceItemMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateMarketplaceItemDocument, options);
}
export const DeleteMarketplaceItemDocument = gql `
  mutation deleteMarketplaceItem($id: ID!) {
    deleteMarketplaceItem(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteMarketplaceItemMutation__
 *
 * To run a mutation, you first call `useDeleteMarketplaceItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMarketplaceItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMarketplaceItemMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMarketplaceItemMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteMarketplaceItemDocument, options);
}
export const RetrieveOrganizationDocument = gql `
  query retrieveOrganization($id: ID!) {
    retrieveOrganization(id: $id) {
      ...OrganizationPayloadFull
    }
  }
  ${OrganizationPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveOrganizationQuery__
 *
 * To run a query within a Vue component, call `useRetrieveOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveOrganizationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveOrganizationQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveOrganizationQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveOrganizationDocument, variables, options);
}
export function useRetrieveOrganizationLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveOrganizationDocument, variables, options);
}
export const RetrieveOrganizationsDocument = gql `
  query retrieveOrganizations(
    $page: Float
    $size: Float
    $orderBy: [OrganizationOrderByInput!]
    $where: OrganizationWhereInput
  ) {
    retrieveOrganizations(
      page: $page
      size: $size
      orderBy: $orderBy
      where: $where
    ) {
      items {
        ...OrganizationExtendedPayload
      }
      page
      perPage
      pages
      total
    }
  }
  ${OrganizationExtendedPayloadFragmentDoc}
`;
/**
 * __useRetrieveOrganizationsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveOrganizationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveOrganizationsQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveOrganizationsQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveOrganizationsDocument, variables, options);
}
export function useRetrieveOrganizationsLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveOrganizationsDocument, variables, options);
}
export const RetrieveAllOrganizationsDocument = gql `
  query retrieveAllOrganizations($size: Float, $where: OrganizationWhereInput) {
    retrieveOrganizations(size: $size, where: $where) {
      items {
        ...OrganizationPayloadLite
      }
    }
  }
  ${OrganizationPayloadLiteFragmentDoc}
`;
/**
 * __useRetrieveAllOrganizationsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAllOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAllOrganizationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAllOrganizationsQuery({
 *   size: // value for 'size'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveAllOrganizationsQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveAllOrganizationsDocument, variables, options);
}
export function useRetrieveAllOrganizationsLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAllOrganizationsDocument, variables, options);
}
export const CountOrganizationsDocument = gql `
  query countOrganizations {
    countOrganizations
  }
`;
/**
 * __useCountOrganizationsQuery__
 *
 * To run a query within a Vue component, call `useCountOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountOrganizationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountOrganizationsQuery();
 */
export function useCountOrganizationsQuery(options = {}) {
    return VueApolloComposable.useQuery(CountOrganizationsDocument, {}, options);
}
export function useCountOrganizationsLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(CountOrganizationsDocument, {}, options);
}
export const UpsertOrganizationDocument = gql `
  mutation upsertOrganization($data: UpdateOrCreateOrganizationInput!) {
    upsertOrganization(data: $data) {
      ...OrganizationPayloadFull
    }
  }
  ${OrganizationPayloadFullFragmentDoc}
`;
/**
 * __useUpsertOrganizationMutation__
 *
 * To run a mutation, you first call `useUpsertOrganizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrganizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertOrganizationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpsertOrganizationMutation(options = {}) {
    return VueApolloComposable.useMutation(UpsertOrganizationDocument, options);
}
export const UpsertOrganizationsDocument = gql `
  mutation upsertOrganizations($data: [UpdateOrCreateOrganizationInput!]!) {
    upsertOrganizations(data: $data) {
      ...OrganizationPayloadFull
    }
  }
  ${OrganizationPayloadFullFragmentDoc}
`;
/**
 * __useUpsertOrganizationsMutation__
 *
 * To run a mutation, you first call `useUpsertOrganizationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrganizationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertOrganizationsMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpsertOrganizationsMutation(options = {}) {
    return VueApolloComposable.useMutation(UpsertOrganizationsDocument, options);
}
export const DeleteOrganizationDocument = gql `
  mutation deleteOrganization($id: ID!) {
    deleteOrganization(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOrganizationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteOrganizationDocument, options);
}
export const DeleteOrganizationsDocument = gql `
  mutation deleteOrganizations($ids: [ID!]!) {
    deleteOrganizations(ids: $ids) {
      deleted
    }
  }
`;
/**
 * __useDeleteOrganizationsMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOrganizationsMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteOrganizationsMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteOrganizationsDocument, options);
}
export const UploadOrganizationFileDocument = gql `
  mutation uploadOrganizationFile($id: String!, $key: String!, $file: Upload!) {
    uploadOrganizationFile(id: $id, key: $key, file: $file)
  }
`;
/**
 * __useUploadOrganizationFileMutation__
 *
 * To run a mutation, you first call `useUploadOrganizationFileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadOrganizationFileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadOrganizationFileMutation({
 *   variables: {
 *     id: // value for 'id'
 *     key: // value for 'key'
 *     file: // value for 'file'
 *   },
 * });
 */
export function useUploadOrganizationFileMutation(options = {}) {
    return VueApolloComposable.useMutation(UploadOrganizationFileDocument, options);
}
export const OrganizationDocument = gql `
  subscription organization($id: ID!) {
    organization(id: $id) {
      ...OrganizationPayloadFull
    }
  }
  ${OrganizationPayloadFullFragmentDoc}
`;
/**
 * __useOrganizationSubscription__
 *
 * To run a query within a Vue component, call `useOrganizationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useOrganizationSubscription({
 *   id: // value for 'id'
 * });
 */
export function useOrganizationSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(OrganizationDocument, variables, options);
}
export const OrganizationsSubscriptionDocument = gql `
  subscription organizationsSubscription {
    organizations {
      item {
        ...OrganizationPayloadFull
      }
      action
    }
  }
  ${OrganizationPayloadFullFragmentDoc}
`;
/**
 * __useOrganizationsSubscriptionSubscription__
 *
 * To run a query within a Vue component, call `useOrganizationsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsSubscriptionSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useOrganizationsSubscriptionSubscription();
 */
export function useOrganizationsSubscriptionSubscription(options = {}) {
    return VueApolloComposable.useSubscription(OrganizationsSubscriptionDocument, {}, options);
}
export const RetrievePartiesDocument = gql `
  query retrieveParties($documentId: ID!) {
    retrieveParties(documentId: $documentId) {
      items {
        ...PartyPayloadExtended
      }
    }
  }
  ${PartyPayloadExtendedFragmentDoc}
`;
/**
 * __useRetrievePartiesQuery__
 *
 * To run a query within a Vue component, call `useRetrievePartiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrievePartiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrievePartiesQuery({
 *   documentId: // value for 'documentId'
 * });
 */
export function useRetrievePartiesQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrievePartiesDocument, variables, options);
}
export function useRetrievePartiesLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrievePartiesDocument, variables, options);
}
export const CreatePartyDocument = gql `
  mutation createParty($data: CreatePartyInput!, $documentId: ID!) {
    createParty(data: $data, documentId: $documentId) {
      ...PartyPayloadFull
    }
  }
  ${PartyPayloadFullFragmentDoc}
`;
/**
 * __useCreatePartyMutation__
 *
 * To run a mutation, you first call `useCreatePartyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePartyMutation({
 *   variables: {
 *     data: // value for 'data'
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useCreatePartyMutation(options = {}) {
    return VueApolloComposable.useMutation(CreatePartyDocument, options);
}
export const UpdatePartyDocument = gql `
  mutation updateParty($id: ID!, $data: UpdatePartyInput!) {
    updateParty(data: $data, id: $id) {
      ...PartyPayloadFull
    }
  }
  ${PartyPayloadFullFragmentDoc}
`;
/**
 * __useUpdatePartyMutation__
 *
 * To run a mutation, you first call `useUpdatePartyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePartyMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePartyMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdatePartyDocument, options);
}
export const DeletePartyDocument = gql `
  mutation deleteParty($id: ID!) {
    deleteParty(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeletePartyMutation__
 *
 * To run a mutation, you first call `useDeletePartyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeletePartyMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeletePartyMutation(options = {}) {
    return VueApolloComposable.useMutation(DeletePartyDocument, options);
}
export const RetrieveProductDocument = gql `
  query retrieveProduct($id: ID!) {
    retrieveProduct(id: $id) {
      ...ProductPayloadFull
    }
  }
  ${ProductPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveProductQuery__
 *
 * To run a query within a Vue component, call `useRetrieveProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveProductQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveProductQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveProductQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveProductDocument, variables, options);
}
export function useRetrieveProductLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveProductDocument, variables, options);
}
export const RetrieveProductsDocument = gql `
  query retrieveProducts {
    retrieveProducts {
      ...ProductPayloadExtended
    }
  }
  ${ProductPayloadExtendedFragmentDoc}
`;
/**
 * __useRetrieveProductsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveProductsQuery();
 */
export function useRetrieveProductsQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveProductsDocument, {}, options);
}
export function useRetrieveProductsLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveProductsDocument, {}, options);
}
export const RetrieveProfileRelationDocument = gql `
  query retrieveProfileRelation($id: ID!) {
    retrieveProfileRelation(id: $id) {
      ...ProfileRelationPayloadFull
    }
  }
  ${ProfileRelationPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveProfileRelationQuery__
 *
 * To run a query within a Vue component, call `useRetrieveProfileRelationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveProfileRelationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveProfileRelationQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveProfileRelationQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveProfileRelationDocument, variables, options);
}
export function useRetrieveProfileRelationLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveProfileRelationDocument, variables, options);
}
export const RetrieveProfileRelationsDocument = gql `
  query retrieveProfileRelations(
    $profileId: ID!
    $page: Float
    $size: Float
    $orderBy: [ProfileRelationOrderByInput!]
    $where: ProfileRelationWhereInput
  ) {
    retrieveProfileRelations(
      profileId: $profileId
      page: $page
      size: $size
      orderBy: $orderBy
      where: $where
    ) {
      items {
        ...ProfileRelationExtendedPayload
      }
      page
      perPage
      pages
      total
    }
  }
  ${ProfileRelationExtendedPayloadFragmentDoc}
`;
/**
 * __useRetrieveProfileRelationsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveProfileRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveProfileRelationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveProfileRelationsQuery({
 *   profileId: // value for 'profileId'
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveProfileRelationsQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveProfileRelationsDocument, variables, options);
}
export function useRetrieveProfileRelationsLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveProfileRelationsDocument, variables, options);
}
export const CountProfileRelationsDocument = gql `
  query countProfileRelations($profileId: ID!) {
    countProfileRelations(profileId: $profileId)
  }
`;
/**
 * __useCountProfileRelationsQuery__
 *
 * To run a query within a Vue component, call `useCountProfileRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountProfileRelationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountProfileRelationsQuery({
 *   profileId: // value for 'profileId'
 * });
 */
export function useCountProfileRelationsQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(CountProfileRelationsDocument, variables, options);
}
export function useCountProfileRelationsLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(CountProfileRelationsDocument, variables, options);
}
export const CreateProfileRelationDocument = gql `
  mutation createProfileRelation($data: CreateProfileRelationInput!) {
    createProfileRelation(data: $data) {
      ...ProfileRelationPayloadFull
    }
  }
  ${ProfileRelationPayloadFullFragmentDoc}
`;
/**
 * __useCreateProfileRelationMutation__
 *
 * To run a mutation, you first call `useCreateProfileRelationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateProfileRelationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateProfileRelationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateProfileRelationMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateProfileRelationDocument, options);
}
export const UpdateProfileRelationDocument = gql `
  mutation updateProfileRelation($data: UpdateProfileRelationInput!, $id: ID!) {
    updateProfileRelation(data: $data, id: $id) {
      ...ProfileRelationPayloadFull
    }
  }
  ${ProfileRelationPayloadFullFragmentDoc}
`;
/**
 * __useUpdateProfileRelationMutation__
 *
 * To run a mutation, you first call `useUpdateProfileRelationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileRelationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProfileRelationMutation({
 *   variables: {
 *     data: // value for 'data'
 *     id: // value for 'id'
 *   },
 * });
 */
export function useUpdateProfileRelationMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateProfileRelationDocument, options);
}
export const DeleteProfileRelationDocument = gql `
  mutation deleteProfileRelation($id: ID!) {
    deleteProfileRelation(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteProfileRelationMutation__
 *
 * To run a mutation, you first call `useDeleteProfileRelationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfileRelationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProfileRelationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProfileRelationMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteProfileRelationDocument, options);
}
export const DeleteProfileRelationsDocument = gql `
  mutation deleteProfileRelations($ids: [ID!]!) {
    deleteProfileRelations(ids: $ids) {
      deleted
    }
  }
`;
/**
 * __useDeleteProfileRelationsMutation__
 *
 * To run a mutation, you first call `useDeleteProfileRelationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfileRelationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProfileRelationsMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteProfileRelationsMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteProfileRelationsDocument, options);
}
export const ProfileRelationDocument = gql `
  subscription profileRelation($id: ID!) {
    profileRelation(id: $id) {
      ...ProfileRelationPayloadFull
    }
  }
  ${ProfileRelationPayloadFullFragmentDoc}
`;
/**
 * __useProfileRelationSubscription__
 *
 * To run a query within a Vue component, call `useProfileRelationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProfileRelationSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useProfileRelationSubscription({
 *   id: // value for 'id'
 * });
 */
export function useProfileRelationSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(ProfileRelationDocument, variables, options);
}
export const ProfileRelationsSubscriptionDocument = gql `
  subscription profileRelationsSubscription {
    profileRelations {
      item {
        ...ProfileRelationPayloadFull
      }
      action
    }
  }
  ${ProfileRelationPayloadFullFragmentDoc}
`;
/**
 * __useProfileRelationsSubscriptionSubscription__
 *
 * To run a query within a Vue component, call `useProfileRelationsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProfileRelationsSubscriptionSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useProfileRelationsSubscriptionSubscription();
 */
export function useProfileRelationsSubscriptionSubscription(options = {}) {
    return VueApolloComposable.useSubscription(ProfileRelationsSubscriptionDocument, {}, options);
}
export const RetrieveRemindersDocument = gql `
  query retrieveReminders($documentId: ID!, $past: Boolean, $date: String) {
    retrieveReminders(documentId: $documentId, past: $past, date: $date) {
      items {
        ...ReminderPayloadExtended
      }
    }
  }
  ${ReminderPayloadExtendedFragmentDoc}
`;
/**
 * __useRetrieveRemindersQuery__
 *
 * To run a query within a Vue component, call `useRetrieveRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveRemindersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveRemindersQuery({
 *   documentId: // value for 'documentId'
 *   past: // value for 'past'
 *   date: // value for 'date'
 * });
 */
export function useRetrieveRemindersQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveRemindersDocument, variables, options);
}
export function useRetrieveRemindersLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveRemindersDocument, variables, options);
}
export const RetrieveMyRemindersDocument = gql `
  query retrieveMyReminders($date: DateTime!) {
    retrieveMyReminders(date: $date) {
      items {
        ...ReminderPayloadExtended
        document {
          id
          name
        }
      }
    }
  }
  ${ReminderPayloadExtendedFragmentDoc}
`;
/**
 * __useRetrieveMyRemindersQuery__
 *
 * To run a query within a Vue component, call `useRetrieveMyRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveMyRemindersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveMyRemindersQuery({
 *   date: // value for 'date'
 * });
 */
export function useRetrieveMyRemindersQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveMyRemindersDocument, variables, options);
}
export function useRetrieveMyRemindersLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveMyRemindersDocument, variables, options);
}
export const CreateReminderDocument = gql `
  mutation createReminder($data: CreateReminderInput!, $documentId: ID!) {
    createReminder(data: $data, documentId: $documentId) {
      ...ReminderPayloadFull
    }
  }
  ${ReminderPayloadFullFragmentDoc}
`;
/**
 * __useCreateReminderMutation__
 *
 * To run a mutation, you first call `useCreateReminderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateReminderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateReminderMutation({
 *   variables: {
 *     data: // value for 'data'
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useCreateReminderMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateReminderDocument, options);
}
export const UpdateReminderDocument = gql `
  mutation updateReminder($id: ID!, $data: UpdateReminderInput!) {
    updateReminder(data: $data, id: $id) {
      ...ReminderPayloadFull
    }
  }
  ${ReminderPayloadFullFragmentDoc}
`;
/**
 * __useUpdateReminderMutation__
 *
 * To run a mutation, you first call `useUpdateReminderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReminderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateReminderMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateReminderMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateReminderDocument, options);
}
export const DeleteReminderDocument = gql `
  mutation deleteReminder($id: ID!) {
    deleteReminder(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteReminderMutation__
 *
 * To run a mutation, you first call `useDeleteReminderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReminderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteReminderMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReminderMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteReminderDocument, options);
}
export const ReminderDocument = gql `
  subscription reminder($id: ID!) {
    reminder(id: $id) {
      ...ReminderPayloadFull
    }
  }
  ${ReminderPayloadFullFragmentDoc}
`;
/**
 * __useReminderSubscription__
 *
 * To run a query within a Vue component, call `useReminderSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReminderSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useReminderSubscription({
 *   id: // value for 'id'
 * });
 */
export function useReminderSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(ReminderDocument, variables, options);
}
export const RemindersSubscriptionDocument = gql `
  subscription remindersSubscription($documentId: ID!) {
    reminders(documentId: $documentId) {
      item {
        ...ReminderPayloadFull
      }
      action
    }
  }
  ${ReminderPayloadFullFragmentDoc}
`;
/**
 * __useRemindersSubscriptionSubscription__
 *
 * To run a query within a Vue component, call `useRemindersSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRemindersSubscriptionSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useRemindersSubscriptionSubscription({
 *   documentId: // value for 'documentId'
 * });
 */
export function useRemindersSubscriptionSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(RemindersSubscriptionDocument, variables, options);
}
export const RetrieveRuleDocument = gql `
  query retrieveRule($id: ID!) {
    retrieveRule(id: $id) {
      ...RulePayloadFull
    }
  }
  ${RulePayloadFullFragmentDoc}
`;
/**
 * __useRetrieveRuleQuery__
 *
 * To run a query within a Vue component, call `useRetrieveRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveRuleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveRuleQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveRuleQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveRuleDocument, variables, options);
}
export function useRetrieveRuleLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveRuleDocument, variables, options);
}
export const RetrieveRulesDocument = gql `
  query retrieveRules(
    $page: Float
    $size: Float
    $orderBy: [RuleOrderByInput!]
    $where: RuleWhereInput
  ) {
    retrieveRules(page: $page, size: $size, orderBy: $orderBy, where: $where) {
      items {
        ...RuleExtendedPayload
      }
      page
      perPage
      pages
      total
    }
  }
  ${RuleExtendedPayloadFragmentDoc}
`;
/**
 * __useRetrieveRulesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveRulesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveRulesQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveRulesQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveRulesDocument, variables, options);
}
export function useRetrieveRulesLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveRulesDocument, variables, options);
}
export const RetrieveActionRuleNodesDocument = gql `
  query retrieveActionRuleNodes {
    retrieveActionRuleNodes {
      ...ActionNodeRulePayload
    }
  }
  ${ActionNodeRulePayloadFragmentDoc}
`;
/**
 * __useRetrieveActionRuleNodesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveActionRuleNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveActionRuleNodesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveActionRuleNodesQuery();
 */
export function useRetrieveActionRuleNodesQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveActionRuleNodesDocument, {}, options);
}
export function useRetrieveActionRuleNodesLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveActionRuleNodesDocument, {}, options);
}
export const RetrieveQueryRuleTriggersDocument = gql `
  query retrieveQueryRuleTriggers {
    retrieveQueryRuleTriggers {
      events
      operators
      rules
      output
    }
  }
`;
/**
 * __useRetrieveQueryRuleTriggersQuery__
 *
 * To run a query within a Vue component, call `useRetrieveQueryRuleTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveQueryRuleTriggersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveQueryRuleTriggersQuery();
 */
export function useRetrieveQueryRuleTriggersQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveQueryRuleTriggersDocument, {}, options);
}
export function useRetrieveQueryRuleTriggersLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveQueryRuleTriggersDocument, {}, options);
}
export const RetrieveRuleExecutionsDocument = gql `
  query retrieveRuleExecutions($id: ID!) {
    retrieveRuleExecutions(id: $id) {
      createdAt
      updatedAt
      id
      metadata
      ms
      result
      status
    }
  }
`;
/**
 * __useRetrieveRuleExecutionsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveRuleExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveRuleExecutionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveRuleExecutionsQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveRuleExecutionsQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveRuleExecutionsDocument, variables, options);
}
export function useRetrieveRuleExecutionsLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveRuleExecutionsDocument, variables, options);
}
export const CountRulesDocument = gql `
  query countRules {
    countRules
  }
`;
/**
 * __useCountRulesQuery__
 *
 * To run a query within a Vue component, call `useCountRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountRulesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountRulesQuery();
 */
export function useCountRulesQuery(options = {}) {
    return VueApolloComposable.useQuery(CountRulesDocument, {}, options);
}
export function useCountRulesLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(CountRulesDocument, {}, options);
}
export const CreateRuleDocument = gql `
  mutation createRule($data: CreateRuleInput!) {
    createRule(data: $data) {
      ...RulePayloadFull
    }
  }
  ${RulePayloadFullFragmentDoc}
`;
/**
 * __useCreateRuleMutation__
 *
 * To run a mutation, you first call `useCreateRuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateRuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateRuleMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateRuleMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateRuleDocument, options);
}
export const UpdateRuleDocument = gql `
  mutation updateRule($id: ID!, $data: UpdateRuleInput!) {
    updateRule(id: $id, data: $data) {
      ...RulePayloadFull
    }
  }
  ${RulePayloadFullFragmentDoc}
`;
/**
 * __useUpdateRuleMutation__
 *
 * To run a mutation, you first call `useUpdateRuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRuleMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRuleMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateRuleDocument, options);
}
export const EnableRuleDocument = gql `
  mutation enableRule($id: ID!, $enable: Boolean!) {
    enableRule(id: $id, enable: $enable) {
      ...RulePayloadFull
    }
  }
  ${RulePayloadFullFragmentDoc}
`;
/**
 * __useEnableRuleMutation__
 *
 * To run a mutation, you first call `useEnableRuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableRuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableRuleMutation({
 *   variables: {
 *     id: // value for 'id'
 *     enable: // value for 'enable'
 *   },
 * });
 */
export function useEnableRuleMutation(options = {}) {
    return VueApolloComposable.useMutation(EnableRuleDocument, options);
}
export const DeleteRuleDocument = gql `
  mutation deleteRule($id: ID!) {
    deleteRule(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteRuleMutation__
 *
 * To run a mutation, you first call `useDeleteRuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRuleMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRuleMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteRuleDocument, options);
}
export const DeleteRulesDocument = gql `
  mutation deleteRules($ids: [ID!]!) {
    deleteRules(ids: $ids) {
      deleted
    }
  }
`;
/**
 * __useDeleteRulesMutation__
 *
 * To run a mutation, you first call `useDeleteRulesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRulesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRulesMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteRulesMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteRulesDocument, options);
}
export const RuleDocument = gql `
  subscription rule($id: ID!) {
    rule(id: $id) {
      ...RulePayloadFull
    }
  }
  ${RulePayloadFullFragmentDoc}
`;
/**
 * __useRuleSubscription__
 *
 * To run a query within a Vue component, call `useRuleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRuleSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useRuleSubscription({
 *   id: // value for 'id'
 * });
 */
export function useRuleSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(RuleDocument, variables, options);
}
export const RulesDocument = gql `
  subscription rules($workflow: ID) {
    rules(workflow: $workflow) {
      item {
        ...RuleExtendedPayload
      }
      action
    }
  }
  ${RuleExtendedPayloadFragmentDoc}
`;
/**
 * __useRulesSubscription__
 *
 * To run a query within a Vue component, call `useRulesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRulesSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useRulesSubscription({
 *   workflow: // value for 'workflow'
 * });
 */
export function useRulesSubscription(variables = {}, options = {}) {
    return VueApolloComposable.useSubscription(RulesDocument, variables, options);
}
export const GenerateSearchTokenDocument = gql `
  mutation generateSearchToken {
    generateSearchToken
  }
`;
/**
 * __useGenerateSearchTokenMutation__
 *
 * To run a mutation, you first call `useGenerateSearchTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSearchTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateSearchTokenMutation();
 */
export function useGenerateSearchTokenMutation(options = {}) {
    return VueApolloComposable.useMutation(GenerateSearchTokenDocument, options);
}
export const RetrieveSignaturesDocument = gql `
  query retrieveSignatures($documentId: ID!, $partyId: ID) {
    retrieveSignatures(documentId: $documentId, partyId: $partyId) {
      items {
        ...SignaturePayloadFull
      }
    }
  }
  ${SignaturePayloadFullFragmentDoc}
`;
/**
 * __useRetrieveSignaturesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveSignaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveSignaturesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveSignaturesQuery({
 *   documentId: // value for 'documentId'
 *   partyId: // value for 'partyId'
 * });
 */
export function useRetrieveSignaturesQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveSignaturesDocument, variables, options);
}
export function useRetrieveSignaturesLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveSignaturesDocument, variables, options);
}
export const CountSignaturesDocument = gql `
  query countSignatures($documentId: ID!) {
    countSignatures(documentId: $documentId)
  }
`;
/**
 * __useCountSignaturesQuery__
 *
 * To run a query within a Vue component, call `useCountSignaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountSignaturesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountSignaturesQuery({
 *   documentId: // value for 'documentId'
 * });
 */
export function useCountSignaturesQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(CountSignaturesDocument, variables, options);
}
export function useCountSignaturesLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(CountSignaturesDocument, variables, options);
}
export const RetrieveSignaturePlaceholdersDocument = gql `
  query retrieveSignaturePlaceholders($documentId: ID!, $partyId: ID) {
    retrieveSignaturePlaceholders(documentId: $documentId, partyId: $partyId) {
      items {
        ...SignaturePlaceholderPayloadFull
      }
    }
  }
  ${SignaturePlaceholderPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveSignaturePlaceholdersQuery__
 *
 * To run a query within a Vue component, call `useRetrieveSignaturePlaceholdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveSignaturePlaceholdersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveSignaturePlaceholdersQuery({
 *   documentId: // value for 'documentId'
 *   partyId: // value for 'partyId'
 * });
 */
export function useRetrieveSignaturePlaceholdersQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveSignaturePlaceholdersDocument, variables, options);
}
export function useRetrieveSignaturePlaceholdersLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveSignaturePlaceholdersDocument, variables, options);
}
export const CountSignaturePlaceholdersDocument = gql `
  query countSignaturePlaceholders($documentId: ID!) {
    countSignaturePlaceholders(documentId: $documentId)
  }
`;
/**
 * __useCountSignaturePlaceholdersQuery__
 *
 * To run a query within a Vue component, call `useCountSignaturePlaceholdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountSignaturePlaceholdersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountSignaturePlaceholdersQuery({
 *   documentId: // value for 'documentId'
 * });
 */
export function useCountSignaturePlaceholdersQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(CountSignaturePlaceholdersDocument, variables, options);
}
export function useCountSignaturePlaceholdersLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(CountSignaturePlaceholdersDocument, variables, options);
}
export const FetchValidSignatureDocument = gql `
  query fetchValidSignature {
    fetchValidSignature {
      content
      signature {
        ...SignaturePayloadLite
        metadata
      }
      author {
        email
      }
      approvals {
        id
        firstName
        lastName
        requestedAt
        approvedAt
        rejectedAt
        order
      }
      account {
        ...AccountBasicPayload
        capabilities
      }
    }
  }
  ${SignaturePayloadLiteFragmentDoc}
  ${AccountBasicPayloadFragmentDoc}
`;
/**
 * __useFetchValidSignatureQuery__
 *
 * To run a query within a Vue component, call `useFetchValidSignatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchValidSignatureQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchValidSignatureQuery();
 */
export function useFetchValidSignatureQuery(options = {}) {
    return VueApolloComposable.useQuery(FetchValidSignatureDocument, {}, options);
}
export function useFetchValidSignatureLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(FetchValidSignatureDocument, {}, options);
}
export const CreateSignatureDocument = gql `
  mutation createSignature($data: CreateSignatureInput!, $documentId: ID!) {
    createSignature(data: $data, documentId: $documentId) {
      ...SignaturePayloadFull
    }
  }
  ${SignaturePayloadFullFragmentDoc}
`;
/**
 * __useCreateSignatureMutation__
 *
 * To run a mutation, you first call `useCreateSignatureMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSignatureMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSignatureMutation({
 *   variables: {
 *     data: // value for 'data'
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useCreateSignatureMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateSignatureDocument, options);
}
export const UpdateSignatureDocument = gql `
  mutation updateSignature($id: ID!, $data: UpdateSignatureInput!) {
    updateSignature(data: $data, id: $id) {
      ...SignaturePayloadFull
    }
  }
  ${SignaturePayloadFullFragmentDoc}
`;
/**
 * __useUpdateSignatureMutation__
 *
 * To run a mutation, you first call `useUpdateSignatureMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignatureMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSignatureMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSignatureMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateSignatureDocument, options);
}
export const DeleteSignatureDocument = gql `
  mutation deleteSignature($id: ID!) {
    deleteSignature(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteSignatureMutation__
 *
 * To run a mutation, you first call `useDeleteSignatureMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignatureMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSignatureMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSignatureMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteSignatureDocument, options);
}
export const CreateSignaturePlaceholderDocument = gql `
  mutation createSignaturePlaceholder(
    $data: CreateSignaturePlaceholderInput!
    $documentId: ID!
  ) {
    createSignaturePlaceholder(data: $data, documentId: $documentId) {
      ...SignaturePlaceholderPayloadFull
    }
  }
  ${SignaturePlaceholderPayloadFullFragmentDoc}
`;
/**
 * __useCreateSignaturePlaceholderMutation__
 *
 * To run a mutation, you first call `useCreateSignaturePlaceholderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSignaturePlaceholderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSignaturePlaceholderMutation({
 *   variables: {
 *     data: // value for 'data'
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useCreateSignaturePlaceholderMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateSignaturePlaceholderDocument, options);
}
export const UpdateSignaturePlaceholderDocument = gql `
  mutation updateSignaturePlaceholder(
    $id: ID!
    $data: UpdateSignaturePlaceholderInput!
  ) {
    updateSignaturePlaceholder(data: $data, id: $id) {
      ...SignaturePlaceholderPayloadFull
    }
  }
  ${SignaturePlaceholderPayloadFullFragmentDoc}
`;
/**
 * __useUpdateSignaturePlaceholderMutation__
 *
 * To run a mutation, you first call `useUpdateSignaturePlaceholderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignaturePlaceholderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSignaturePlaceholderMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSignaturePlaceholderMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateSignaturePlaceholderDocument, options);
}
export const DeleteSignaturePlaceholderDocument = gql `
  mutation deleteSignaturePlaceholder($id: ID!) {
    deleteSignaturePlaceholder(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteSignaturePlaceholderMutation__
 *
 * To run a mutation, you first call `useDeleteSignaturePlaceholderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignaturePlaceholderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSignaturePlaceholderMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSignaturePlaceholderMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteSignaturePlaceholderDocument, options);
}
export const RequestSignaturesDocument = gql `
  mutation requestSignatures($documentId: ID!) {
    requestSignatures(documentId: $documentId) {
      id
    }
  }
`;
/**
 * __useRequestSignaturesMutation__
 *
 * To run a mutation, you first call `useRequestSignaturesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestSignaturesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestSignaturesMutation({
 *   variables: {
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRequestSignaturesMutation(options = {}) {
    return VueApolloComposable.useMutation(RequestSignaturesDocument, options);
}
export const RequestSignatureDocument = gql `
  mutation requestSignature($id: ID!) {
    requestSignature(id: $id) {
      id
    }
  }
`;
/**
 * __useRequestSignatureMutation__
 *
 * To run a mutation, you first call `useRequestSignatureMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestSignatureMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestSignatureMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRequestSignatureMutation(options = {}) {
    return VueApolloComposable.useMutation(RequestSignatureDocument, options);
}
export const SignDocumentDocument = gql `
  mutation signDocument(
    $id: ID!
    $idNumber: String
    $data: String
    $timeline: String
    $password: String
    $cert: Upload
  ) {
    signDocument(
      id: $id
      idNumber: $idNumber
      data: $data
      timeline: $timeline
      password: $password
      cert: $cert
    ) {
      ...SignaturePayloadFull
    }
  }
  ${SignaturePayloadFullFragmentDoc}
`;
/**
 * __useSignDocumentMutation__
 *
 * To run a mutation, you first call `useSignDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignDocumentMutation({
 *   variables: {
 *     id: // value for 'id'
 *     idNumber: // value for 'idNumber'
 *     data: // value for 'data'
 *     timeline: // value for 'timeline'
 *     password: // value for 'password'
 *     cert: // value for 'cert'
 *   },
 * });
 */
export function useSignDocumentMutation(options = {}) {
    return VueApolloComposable.useMutation(SignDocumentDocument, options);
}
export const SignatureDocument = gql `
  subscription signature($id: ID!) {
    signature(id: $id) {
      ...SignaturePayloadFull
    }
  }
  ${SignaturePayloadFullFragmentDoc}
`;
/**
 * __useSignatureSubscription__
 *
 * To run a query within a Vue component, call `useSignatureSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSignatureSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSignatureSubscription({
 *   id: // value for 'id'
 * });
 */
export function useSignatureSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(SignatureDocument, variables, options);
}
export const RetrieveSubscriptionDocument = gql `
  query retrieveSubscription {
    retrieveSubscription {
      ...SubscriptionProductPayloadFull
    }
  }
  ${SubscriptionProductPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveSubscriptionQuery__
 *
 * To run a query within a Vue component, call `useRetrieveSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveSubscriptionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveSubscriptionQuery();
 */
export function useRetrieveSubscriptionQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveSubscriptionDocument, {}, options);
}
export function useRetrieveSubscriptionLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveSubscriptionDocument, {}, options);
}
export const RetrieveBillingPortalDocument = gql `
  query retrieveBillingPortal {
    retrieveBillingPortal
  }
`;
/**
 * __useRetrieveBillingPortalQuery__
 *
 * To run a query within a Vue component, call `useRetrieveBillingPortalQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveBillingPortalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveBillingPortalQuery();
 */
export function useRetrieveBillingPortalQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveBillingPortalDocument, {}, options);
}
export function useRetrieveBillingPortalLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveBillingPortalDocument, {}, options);
}
export const SubscriptionProductDocument = gql `
  subscription subscriptionProduct($id: ID!) {
    subscriptionProduct(id: $id) {
      ...SubscriptionProductPayloadFull
    }
  }
  ${SubscriptionProductPayloadFullFragmentDoc}
`;
/**
 * __useSubscriptionProductSubscription__
 *
 * To run a query within a Vue component, call `useSubscriptionProductSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionProductSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSubscriptionProductSubscription({
 *   id: // value for 'id'
 * });
 */
export function useSubscriptionProductSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(SubscriptionProductDocument, variables, options);
}
export const RetrieveTagDocument = gql `
  query retrieveTag($id: ID!) {
    retrieveTag(id: $id) {
      ...TagPayloadFull
    }
  }
  ${TagPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveTagQuery__
 *
 * To run a query within a Vue component, call `useRetrieveTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveTagQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveTagQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveTagQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveTagDocument, variables, options);
}
export function useRetrieveTagLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveTagDocument, variables, options);
}
export const RetrieveTagsDocument = gql `
  query retrieveTags(
    $page: Float
    $size: Float
    $orderBy: [TagOrderByInput!]
    $where: TagWhereInput
  ) {
    retrieveTags(page: $page, size: $size, orderBy: $orderBy, where: $where) {
      items {
        ...TagExtendedPayload
      }
      page
      perPage
      pages
      total
    }
  }
  ${TagExtendedPayloadFragmentDoc}
`;
/**
 * __useRetrieveTagsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveTagsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveTagsQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveTagsQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveTagsDocument, variables, options);
}
export function useRetrieveTagsLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveTagsDocument, variables, options);
}
export const RetrieveAllTagsDocument = gql `
  query retrieveAllTags($size: Float, $where: TagWhereInput) {
    retrieveTags(size: $size, where: $where) {
      items {
        id
      }
    }
  }
`;
/**
 * __useRetrieveAllTagsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAllTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAllTagsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAllTagsQuery({
 *   size: // value for 'size'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveAllTagsQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveAllTagsDocument, variables, options);
}
export function useRetrieveAllTagsLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAllTagsDocument, variables, options);
}
export const CountTagsDocument = gql `
  query countTags {
    countTags
  }
`;
/**
 * __useCountTagsQuery__
 *
 * To run a query within a Vue component, call `useCountTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountTagsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountTagsQuery();
 */
export function useCountTagsQuery(options = {}) {
    return VueApolloComposable.useQuery(CountTagsDocument, {}, options);
}
export function useCountTagsLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(CountTagsDocument, {}, options);
}
export const UpsertTagDocument = gql `
  mutation upsertTag($data: UpdateOrCreateTagInput!) {
    upsertTag(data: $data) {
      ...TagPayloadFull
    }
  }
  ${TagPayloadFullFragmentDoc}
`;
/**
 * __useUpsertTagMutation__
 *
 * To run a mutation, you first call `useUpsertTagMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTagMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertTagMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpsertTagMutation(options = {}) {
    return VueApolloComposable.useMutation(UpsertTagDocument, options);
}
export const UpsertTagsDocument = gql `
  mutation upsertTags($data: [UpdateOrCreateTagInput!]!) {
    upsertTags(data: $data) {
      ...TagPayloadFull
    }
  }
  ${TagPayloadFullFragmentDoc}
`;
/**
 * __useUpsertTagsMutation__
 *
 * To run a mutation, you first call `useUpsertTagsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTagsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertTagsMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpsertTagsMutation(options = {}) {
    return VueApolloComposable.useMutation(UpsertTagsDocument, options);
}
export const DeleteTagDocument = gql `
  mutation deleteTag($id: ID!) {
    deleteTag(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTagMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteTagDocument, options);
}
export const DeleteTagsDocument = gql `
  mutation deleteTags($ids: [ID!]!) {
    deleteTags(ids: $ids) {
      deleted
    }
  }
`;
/**
 * __useDeleteTagsMutation__
 *
 * To run a mutation, you first call `useDeleteTagsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTagsMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteTagsMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteTagsDocument, options);
}
export const TagDocument = gql `
  subscription tag($id: ID!) {
    tag(id: $id) {
      ...TagPayloadFull
    }
  }
  ${TagPayloadFullFragmentDoc}
`;
/**
 * __useTagSubscription__
 *
 * To run a query within a Vue component, call `useTagSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTagSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useTagSubscription({
 *   id: // value for 'id'
 * });
 */
export function useTagSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(TagDocument, variables, options);
}
export const TagsDocument = gql `
  subscription tags {
    tags {
      item {
        ...TagExtendedPayload
      }
      action
    }
  }
  ${TagExtendedPayloadFragmentDoc}
`;
/**
 * __useTagsSubscription__
 *
 * To run a query within a Vue component, call `useTagsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTagsSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useTagsSubscription();
 */
export function useTagsSubscription(options = {}) {
    return VueApolloComposable.useSubscription(TagsDocument, {}, options);
}
export const RetrieveTemplateDocument = gql `
  query retrieveTemplate($id: ID!) {
    retrieveTemplate(id: $id) {
      ...TemplatePayloadFull
    }
  }
  ${TemplatePayloadFullFragmentDoc}
`;
/**
 * __useRetrieveTemplateQuery__
 *
 * To run a query within a Vue component, call `useRetrieveTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveTemplateQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveTemplateQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveTemplateDocument, variables, options);
}
export function useRetrieveTemplateLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveTemplateDocument, variables, options);
}
export const RetrieveTemplateWithAccountDocument = gql `
  query retrieveTemplateWithAccount($id: ID!) {
    retrieveTemplate(id: $id) {
      ...TemplateExtendedPayload
      content {
        id
        pathMerge
        path
        preview
        delimiters
        mimetype
        readOnly
        version
      }
      account {
        ...AccountBasicPayload
        capabilities
      }
    }
  }
  ${TemplateExtendedPayloadFragmentDoc}
  ${AccountBasicPayloadFragmentDoc}
`;
/**
 * __useRetrieveTemplateWithAccountQuery__
 *
 * To run a query within a Vue component, call `useRetrieveTemplateWithAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveTemplateWithAccountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveTemplateWithAccountQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveTemplateWithAccountQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveTemplateWithAccountDocument, variables, options);
}
export function useRetrieveTemplateWithAccountLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveTemplateWithAccountDocument, variables, options);
}
export const RetrieveTemplatesDocument = gql `
  query retrieveTemplates(
    $page: Float
    $size: Float
    $orderBy: [TemplateOrderByInput!]
    $where: TemplateWhereInput
  ) {
    retrieveTemplates(
      page: $page
      size: $size
      orderBy: $orderBy
      where: $where
    ) {
      items {
        ...TemplateExtendedPayload
      }
      page
      perPage
      pages
      total
    }
  }
  ${TemplateExtendedPayloadFragmentDoc}
`;
/**
 * __useRetrieveTemplatesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveTemplatesQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveTemplatesQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveTemplatesDocument, variables, options);
}
export function useRetrieveTemplatesLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveTemplatesDocument, variables, options);
}
export const RetrieveAllTemplatesDocument = gql `
  query retrieveAllTemplates($size: Float, $where: TemplateWhereInput) {
    retrieveTemplates(size: $size, where: $where) {
      items {
        id
        name
      }
    }
  }
`;
/**
 * __useRetrieveAllTemplatesQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAllTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAllTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAllTemplatesQuery({
 *   size: // value for 'size'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveAllTemplatesQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveAllTemplatesDocument, variables, options);
}
export function useRetrieveAllTemplatesLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAllTemplatesDocument, variables, options);
}
export const CountTemplatesDocument = gql `
  query countTemplates {
    countTemplates
  }
`;
/**
 * __useCountTemplatesQuery__
 *
 * To run a query within a Vue component, call `useCountTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountTemplatesQuery();
 */
export function useCountTemplatesQuery(options = {}) {
    return VueApolloComposable.useQuery(CountTemplatesDocument, {}, options);
}
export function useCountTemplatesLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(CountTemplatesDocument, {}, options);
}
export const CreateTemplateDocument = gql `
  mutation createTemplate($data: CreateTemplateInput!, $file: Upload) {
    createTemplate(data: $data, file: $file) {
      ...TemplatePayloadFull
    }
  }
  ${TemplatePayloadFullFragmentDoc}
`;
/**
 * __useCreateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTemplateMutation({
 *   variables: {
 *     data: // value for 'data'
 *     file: // value for 'file'
 *   },
 * });
 */
export function useCreateTemplateMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateTemplateDocument, options);
}
export const CloneTemplateDocument = gql `
  mutation cloneTemplate($id: ID!) {
    cloneTemplate(id: $id) {
      ...TemplatePayloadFull
    }
  }
  ${TemplatePayloadFullFragmentDoc}
`;
/**
 * __useCloneTemplateMutation__
 *
 * To run a mutation, you first call `useCloneTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCloneTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCloneTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCloneTemplateMutation(options = {}) {
    return VueApolloComposable.useMutation(CloneTemplateDocument, options);
}
export const UpdateTemplateDocument = gql `
  mutation updateTemplate($id: ID!, $data: UpdateTemplateInput!) {
    updateTemplate(data: $data, id: $id) {
      ...TemplatePayloadFull
    }
  }
  ${TemplatePayloadFullFragmentDoc}
`;
/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTemplateMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateTemplateDocument, options);
}
export const UpdateTemplateVersionDocument = gql `
  mutation updateTemplateVersion(
    $delimiter: DocumentDelimiter
    $id: ID!
    $file: Upload!
  ) {
    updateTemplateVersion(delimiter: $delimiter, id: $id, file: $file) {
      ...TemplatePayloadFull
    }
  }
  ${TemplatePayloadFullFragmentDoc}
`;
/**
 * __useUpdateTemplateVersionMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTemplateVersionMutation({
 *   variables: {
 *     delimiter: // value for 'delimiter'
 *     id: // value for 'id'
 *     file: // value for 'file'
 *   },
 * });
 */
export function useUpdateTemplateVersionMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateTemplateVersionDocument, options);
}
export const PublishUnpublishTemplateDocument = gql `
  mutation publishUnpublishTemplate(
    $data: PublishUnpublishTemplateInput!
    $id: ID!
  ) {
    publishUnpublishTemplate(data: $data, id: $id) {
      ...TemplatePayloadLite
    }
  }
  ${TemplatePayloadLiteFragmentDoc}
`;
/**
 * __usePublishUnpublishTemplateMutation__
 *
 * To run a mutation, you first call `usePublishUnpublishTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePublishUnpublishTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePublishUnpublishTemplateMutation({
 *   variables: {
 *     data: // value for 'data'
 *     id: // value for 'id'
 *   },
 * });
 */
export function usePublishUnpublishTemplateMutation(options = {}) {
    return VueApolloComposable.useMutation(PublishUnpublishTemplateDocument, options);
}
export const UpdateTemplateDestinationFolderDocument = gql `
  mutation updateTemplateDestinationFolder($destinationId: ID, $id: ID!) {
    updateTemplateDestinationFolder(destinationId: $destinationId, id: $id) {
      id
    }
  }
`;
/**
 * __useUpdateTemplateDestinationFolderMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateDestinationFolderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateDestinationFolderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTemplateDestinationFolderMutation({
 *   variables: {
 *     destinationId: // value for 'destinationId'
 *     id: // value for 'id'
 *   },
 * });
 */
export function useUpdateTemplateDestinationFolderMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateTemplateDestinationFolderDocument, options);
}
export const DeleteTemplateDocument = gql `
  mutation deleteTemplate($id: ID!) {
    deleteTemplate(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteTemplateDocument, options);
}
export const DeleteTemplatesDocument = gql `
  mutation deleteTemplates($ids: [ID!]!) {
    deleteTemplates(ids: $ids) {
      deleted
    }
  }
`;
/**
 * __useDeleteTemplatesMutation__
 *
 * To run a mutation, you first call `useDeleteTemplatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTemplatesMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteTemplatesMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteTemplatesDocument, options);
}
export const TemplateDocument = gql `
  subscription template($id: ID!) {
    template(id: $id) {
      ...TemplatePayloadFull
    }
  }
  ${TemplatePayloadFullFragmentDoc}
`;
/**
 * __useTemplateSubscription__
 *
 * To run a query within a Vue component, call `useTemplateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTemplateSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useTemplateSubscription({
 *   id: // value for 'id'
 * });
 */
export function useTemplateSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(TemplateDocument, variables, options);
}
export const RetrieveTicketDocument = gql `
  query retrieveTicket($id: ID!) {
    retrieveTicket(id: $id) {
      ...TicketPayloadFull
    }
  }
  ${TicketPayloadFullFragmentDoc}
`;
/**
 * __useRetrieveTicketQuery__
 *
 * To run a query within a Vue component, call `useRetrieveTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveTicketQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveTicketQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrieveTicketQuery(variables, options = {}) {
    return VueApolloComposable.useQuery(RetrieveTicketDocument, variables, options);
}
export function useRetrieveTicketLazyQuery(variables, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveTicketDocument, variables, options);
}
export const RetrieveTicketsDocument = gql `
  query retrieveTickets(
    $page: Float
    $size: Float
    $orderBy: [TicketOrderByInput!]
    $where: TicketWhereInput
  ) {
    retrieveTickets(
      page: $page
      size: $size
      orderBy: $orderBy
      where: $where
    ) {
      items {
        ...TicketExtendedPayload
      }
      page
      perPage
      pages
      total
    }
  }
  ${TicketExtendedPayloadFragmentDoc}
`;
/**
 * __useRetrieveTicketsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveTicketsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveTicketsQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   orderBy: // value for 'orderBy'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveTicketsQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveTicketsDocument, variables, options);
}
export function useRetrieveTicketsLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveTicketsDocument, variables, options);
}
export const RetrieveHotTicketsDocument = gql `
  query retrieveHotTickets {
    retrieveHotTickets {
      items {
        ...TicketPayloadLite
        createdAt
        updatedAt
        dueDateAt
        ref
        object
        metadata
      }
      page
      perPage
      pages
      total
    }
  }
  ${TicketPayloadLiteFragmentDoc}
`;
/**
 * __useRetrieveHotTicketsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveHotTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveHotTicketsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveHotTicketsQuery();
 */
export function useRetrieveHotTicketsQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveHotTicketsDocument, {}, options);
}
export function useRetrieveHotTicketsLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveHotTicketsDocument, {}, options);
}
export const RetrieveAllTicketsDocument = gql `
  query retrieveAllTickets($size: Float, $where: TicketWhereInput) {
    retrieveTickets(size: $size, where: $where) {
      items {
        id
      }
    }
  }
`;
/**
 * __useRetrieveAllTicketsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAllTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAllTicketsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAllTicketsQuery({
 *   size: // value for 'size'
 *   where: // value for 'where'
 * });
 */
export function useRetrieveAllTicketsQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(RetrieveAllTicketsDocument, variables, options);
}
export function useRetrieveAllTicketsLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAllTicketsDocument, variables, options);
}
export const RetrieveTicketStatusListDocument = gql `
  query retrieveTicketStatusList {
    retrieveTicketStatusList {
      key
      value
    }
  }
`;
/**
 * __useRetrieveTicketStatusListQuery__
 *
 * To run a query within a Vue component, call `useRetrieveTicketStatusListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveTicketStatusListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveTicketStatusListQuery();
 */
export function useRetrieveTicketStatusListQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveTicketStatusListDocument, {}, options);
}
export function useRetrieveTicketStatusListLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveTicketStatusListDocument, {}, options);
}
export const CountTicketsDocument = gql `
  query countTickets {
    countTickets
  }
`;
/**
 * __useCountTicketsQuery__
 *
 * To run a query within a Vue component, call `useCountTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountTicketsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountTicketsQuery();
 */
export function useCountTicketsQuery(options = {}) {
    return VueApolloComposable.useQuery(CountTicketsDocument, {}, options);
}
export function useCountTicketsLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(CountTicketsDocument, {}, options);
}
export const CreateTicketDocument = gql `
  mutation createTicket($data: CreateTicketInput!) {
    createTicket(data: $data) {
      ...TicketPayloadFull
    }
  }
  ${TicketPayloadFullFragmentDoc}
`;
/**
 * __useCreateTicketMutation__
 *
 * To run a mutation, you first call `useCreateTicketMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTicketMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTicketMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateTicketMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateTicketDocument, options);
}
export const UpdateTicketDocument = gql `
  mutation updateTicket($id: ID!, $data: UpdateTicketInput!) {
    updateTicket(data: $data, id: $id) {
      ...TicketPayloadFull
    }
  }
  ${TicketPayloadFullFragmentDoc}
`;
/**
 * __useUpdateTicketMutation__
 *
 * To run a mutation, you first call `useUpdateTicketMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTicketMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTicketMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTicketMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateTicketDocument, options);
}
export const CloneTicketDocument = gql `
  mutation cloneTicket($id: ID!) {
    cloneTicket(id: $id) {
      ...TicketPayloadFull
    }
  }
  ${TicketPayloadFullFragmentDoc}
`;
/**
 * __useCloneTicketMutation__
 *
 * To run a mutation, you first call `useCloneTicketMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCloneTicketMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCloneTicketMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCloneTicketMutation(options = {}) {
    return VueApolloComposable.useMutation(CloneTicketDocument, options);
}
export const UpdateTicketStatusDocument = gql `
  mutation updateTicketStatus($id: ID!, $newStatus: TicketStatus!) {
    updateTicketStatus(id: $id, newStatus: $newStatus) {
      id
    }
  }
`;
/**
 * __useUpdateTicketStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTicketStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTicketStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTicketStatusMutation({
 *   variables: {
 *     id: // value for 'id'
 *     newStatus: // value for 'newStatus'
 *   },
 * });
 */
export function useUpdateTicketStatusMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateTicketStatusDocument, options);
}
export const DeleteTicketDocument = gql `
  mutation deleteTicket($id: ID!) {
    deleteTicket(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteTicketMutation__
 *
 * To run a mutation, you first call `useDeleteTicketMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTicketMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTicketMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTicketMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteTicketDocument, options);
}
export const DeleteTicketsDocument = gql `
  mutation deleteTickets($ids: [ID!]!) {
    deleteTickets(ids: $ids) {
      deleted
    }
  }
`;
/**
 * __useDeleteTicketsMutation__
 *
 * To run a mutation, you first call `useDeleteTicketsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTicketsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTicketsMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteTicketsMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteTicketsDocument, options);
}
export const UpdateTicketVariablesDocument = gql `
  mutation updateTicketVariables($id: ID!, $variables: [VariableInput!]!) {
    updateTicketVariables(id: $id, variables: $variables) {
      ...TicketPayloadFull
    }
  }
  ${TicketPayloadFullFragmentDoc}
`;
/**
 * __useUpdateTicketVariablesMutation__
 *
 * To run a mutation, you first call `useUpdateTicketVariablesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTicketVariablesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTicketVariablesMutation({
 *   variables: {
 *     id: // value for 'id'
 *     variables: // value for 'variables'
 *   },
 * });
 */
export function useUpdateTicketVariablesMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateTicketVariablesDocument, options);
}
export const CreateDocumentFromTicketDocument = gql `
  mutation createDocumentFromTicket($ticketId: ID!, $templateId: ID!) {
    createDocumentFromTicket(ticketId: $ticketId, templateId: $templateId)
  }
`;
/**
 * __useCreateDocumentFromTicketMutation__
 *
 * To run a mutation, you first call `useCreateDocumentFromTicketMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentFromTicketMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDocumentFromTicketMutation({
 *   variables: {
 *     ticketId: // value for 'ticketId'
 *     templateId: // value for 'templateId'
 *   },
 * });
 */
export function useCreateDocumentFromTicketMutation(options = {}) {
    return VueApolloComposable.useMutation(CreateDocumentFromTicketDocument, options);
}
export const TicketDocument = gql `
  subscription ticket($id: ID!) {
    ticket(id: $id) {
      ...TicketPayloadFull
    }
  }
  ${TicketPayloadFullFragmentDoc}
`;
/**
 * __useTicketSubscription__
 *
 * To run a query within a Vue component, call `useTicketSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTicketSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useTicketSubscription({
 *   id: // value for 'id'
 * });
 */
export function useTicketSubscription(variables, options = {}) {
    return VueApolloComposable.useSubscription(TicketDocument, variables, options);
}
export const MeDocument = gql `
  query me {
    me {
      ...UserPayloadFull
    }
  }
  ${UserPayloadFullFragmentDoc}
`;
/**
 * __useMeQuery__
 *
 * To run a query within a Vue component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMeQuery();
 */
export function useMeQuery(options = {}) {
    return VueApolloComposable.useQuery(MeDocument, {}, options);
}
export function useMeLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(MeDocument, {}, options);
}
export const VerifyEmailDocument = gql `
  query verifyEmail {
    verifyUser {
      done
    }
  }
`;
/**
 * __useVerifyEmailQuery__
 *
 * To run a query within a Vue component, call `useVerifyEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVerifyEmailQuery();
 */
export function useVerifyEmailQuery(options = {}) {
    return VueApolloComposable.useQuery(VerifyEmailDocument, {}, options);
}
export function useVerifyEmailLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(VerifyEmailDocument, {}, options);
}
export const UpdateUserDocument = gql `
  mutation updateUser($data: UpdateUserInput!) {
    updateUser(data: $data) {
      ...UserPayloadFull
    }
  }
  ${UserPayloadFullFragmentDoc}
`;
/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateUserDocument, options);
}
export const UpdatePasswordDocument = gql `
  mutation updatePassword($data: UpdatePasswordInput!) {
    updatePassword(data: $data) {
      done
    }
  }
`;
/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePasswordMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePasswordMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdatePasswordDocument, options);
}
export const UpdateEmailDocument = gql `
  mutation updateEmail($data: UpdateEmailInput!) {
    updateEmail(data: $data) {
      id
    }
  }
`;
/**
 * __useUpdateEmailMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEmailMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEmailMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateEmailDocument, options);
}
export const UpdateUserMetadataDocument = gql `
  mutation updateUserMetadata($data: MetadataInput!) {
    updateUserMetadata(data: $data) {
      id
    }
  }
`;
/**
 * __useUpdateUserMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateUserMetadataMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMetadataMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserMetadataMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMetadataMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateUserMetadataDocument, options);
}
export const AcceptTosDocument = gql `
  mutation acceptTos {
    acceptTos {
      id
    }
  }
`;
/**
 * __useAcceptTosMutation__
 *
 * To run a mutation, you first call `useAcceptTosMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTosMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptTosMutation();
 */
export function useAcceptTosMutation(options = {}) {
    return VueApolloComposable.useMutation(AcceptTosDocument, options);
}
export const ResendVerificationEmailDocument = gql `
  mutation resendVerificationEmail($email: String!) {
    sendVerifyEmail(email: $email) {
      done
    }
  }
`;
/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResendVerificationEmailMutation({
 *   variables: {
 *     email: // value for 'email'
 *   },
 * });
 */
export function useResendVerificationEmailMutation(options = {}) {
    return VueApolloComposable.useMutation(ResendVerificationEmailDocument, options);
}
export const DeleteUserDocument = gql `
  mutation deleteUser {
    deleteUser {
      deleted
    }
  }
`;
/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUserMutation();
 */
export function useDeleteUserMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteUserDocument, options);
}
export const MyUserDocument = gql `
  subscription myUser {
    myUser {
      ...UserPayloadFull
    }
  }
  ${UserPayloadFullFragmentDoc}
`;
/**
 * __useMyUserSubscription__
 *
 * To run a query within a Vue component, call `useMyUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMyUserSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useMyUserSubscription();
 */
export function useMyUserSubscription(options = {}) {
    return VueApolloComposable.useSubscription(MyUserDocument, {}, options);
}
export const RetrieveAllWebhooksDocument = gql `
  query retrieveAllWebhooks {
    retrieveAllWebhooks {
      id
      url
      eventTypes
      headers
      createdAt
      updatedAt
    }
  }
`;
/**
 * __useRetrieveAllWebhooksQuery__
 *
 * To run a query within a Vue component, call `useRetrieveAllWebhooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAllWebhooksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveAllWebhooksQuery();
 */
export function useRetrieveAllWebhooksQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveAllWebhooksDocument, {}, options);
}
export function useRetrieveAllWebhooksLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveAllWebhooksDocument, {}, options);
}
export const RetrieveValidEventsDocument = gql `
  query retrieveValidEvents {
    retrieveValidEvents {
      eventType
      title
    }
  }
`;
/**
 * __useRetrieveValidEventsQuery__
 *
 * To run a query within a Vue component, call `useRetrieveValidEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveValidEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveValidEventsQuery();
 */
export function useRetrieveValidEventsQuery(options = {}) {
    return VueApolloComposable.useQuery(RetrieveValidEventsDocument, {}, options);
}
export function useRetrieveValidEventsLazyQuery(options = {}) {
    return VueApolloComposable.useLazyQuery(RetrieveValidEventsDocument, {}, options);
}
export const UpdateOrCreateWebhookDocument = gql `
  mutation updateOrCreateWebhook($data: UpdateOrCreateWebhookInput!) {
    updateOrCreateWebhook(data: $data) {
      ...WebhookPayloadFull
    }
  }
  ${WebhookPayloadFullFragmentDoc}
`;
/**
 * __useUpdateOrCreateWebhookMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateWebhookMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateWebhookMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOrCreateWebhookMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrCreateWebhookMutation(options = {}) {
    return VueApolloComposable.useMutation(UpdateOrCreateWebhookDocument, options);
}
export const DeleteWebhookDocument = gql `
  mutation deleteWebhook($id: ID!) {
    deleteWebhook(id: $id) {
      deleted
    }
  }
`;
/**
 * __useDeleteWebhookMutation__
 *
 * To run a mutation, you first call `useDeleteWebhookMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebhookMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteWebhookMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWebhookMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteWebhookDocument, options);
}
export const DeleteWebhooksDocument = gql `
  mutation deleteWebhooks($ids: [ID!]!) {
    deleteWebhooks(ids: $ids) {
      deleted
    }
  }
`;
/**
 * __useDeleteWebhooksMutation__
 *
 * To run a mutation, you first call `useDeleteWebhooksMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebhooksMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteWebhooksMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteWebhooksMutation(options = {}) {
    return VueApolloComposable.useMutation(DeleteWebhooksDocument, options);
}
/**
 * Represents an account
 * @typedef {Object} Account
 * @property {boolean} [active] - Has the value __true__ if the object is active or the value __false__ if it is not. If the __Account__ has been disabled by error, please [contact us](mailto:support@bounsel.com).
 * @property {boolean} [admin] - Current user is account admin
 * @property {AccountBrand} [brand] - Brand details
 * @property {Array<Capabilities>} capabilities - Account's capabilities enabled
 * @property {AccountContact} [contact] - Contact details
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} id - An unique identifier for the object.
 * @property {Array<string>} [integrations] - Account's integrations enabled
 * @property {JSON} [limits]
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - The account name.
 * @property {AccountNotificationIdentity} [notificationIdentity] - Notification identity object
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {Array<AccountPermissions>} [permissions] - List of my permissions with the current account
 * @property {JSON} quotas
 * @property {string} [role] - Current user role
 * @property {AccountSettings} [settings] - Account settings
 * @property {SubscriptionProduct} [subscription] - Subscription info
 * @property {AccountTax} [tax]
 * @property {string} [timezone] - Timezone's account
 * @property {boolean} tos - Account's terms of service accepted
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {("activeDocuments"|"approvalAvgByCategory"|"documentRiskAvg"|"documentRiskAvgByCategory"|"documentStages"|"documentValue"|"externalSide"|"mostActiveDocuments"|"mySide"|"ragDocumentStatus"|"signatureAvgByCategory"|"terminatedDocuments"|"toExpireDocuments"|"totalValueDocument")} AccountAnalytics
 */
/**
 * Represents an account brand
 * @typedef {Object} AccountBrand
 * @property {string} [altLogo] - Alternative logo's account
 * @property {string} [avatar] - Avatar's account
 * @property {string} [logo] - Logo's account
 * @property {string} [primaryColor] - Primary color
 */
/**
 * @typedef {Object} AccountBrandInput
 * @property {string} [altLogo] - Alternative logo's account
 * @property {string} [avatar] - Avatar's account
 * @property {string} [logo] - Logo's account
 * @property {string} [primaryColor] - Primary color
 */
/**
 * Represents an account contact
 * @typedef {Object} AccountContact
 * @property {string} [billing] - Billing contact
 * @property {string} primary - Primary contact
 * @property {string} [technical] - Technical contact
 */
/**
 * @typedef {Object} AccountContactInput
 * @property {string} [billing] - Billing contact
 * @property {string} primary - Primary contact
 * @property {string} [technical] - Technical contact
 */
/**
 * Represents an account data store
 * @typedef {Object} AccountDataStore
 * @property {Account} [account] - Account object
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {JSON} [plainValues] - Variables to store in the account data store
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {Array<JSON>} [variables] - Variables to store in the account data store
 */
/**
 * Represents an account integration
 * @typedef {Object} AccountIntegration
 * @property {boolean} active - Active integration in your account
 * @property {string} [apiKey] - Auto generate api key
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} id - An unique identifier for the object.
 * @property {Integration} [integration] - Integration's Id
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {JSON} [options] - Extra options to config the integration
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * Represents an account notification identity
 * @typedef {Object} AccountNotificationIdentity
 * @property {string} [defaultEmail] - Default notification email without domain
 * @property {JSON} [dns] - CNAMES to connect with your domain
 * @property {string} [domain] - Add custom notification domain
 * @property {boolean} [verified] - Check if the dns is verified
 */
/**
 * @typedef {("ArchiveDocuments"|"ConnectIntegrations"|"CreateAccountDataStore"|"CreateAccountPolicies"|"CreateAccountRoles"|"CreateAccountToken"|"CreateCategories"|"CreateCollections"|"CreateContacts"|"CreateDocumentRoles"|"CreateDocuments"|"CreateFolders"|"CreateIntakeResponses"|"CreateIntakeShares"|"CreateIntakes"|"CreateMarketplaceItem"|"CreateOrganizations"|"CreateProfileRelations"|"CreateRules"|"CreateSaml"|"CreateSubscription"|"CreateTags"|"CreateTeams"|"CreateTemplates"|"CreateTickets"|"CreateWorkflows"|"DeleteAccount"|"DeleteAccountDataStore"|"DeleteAccountPolicies"|"DeleteAccountRoles"|"DeleteAccountToken"|"DeleteCategories"|"DeleteCollections"|"DeleteContacts"|"DeleteDocumentRoles"|"DeleteDocuments"|"DeleteFolders"|"DeleteIntakeResponses"|"DeleteIntakeShares"|"DeleteIntakes"|"DeleteMarketplaceItem"|"DeleteOrganizations"|"DeleteProfileRelations"|"DeleteRules"|"DeleteSaml"|"DeleteSubscription"|"DeleteTags"|"DeleteTeams"|"DeleteTemplates"|"DeleteTickets"|"DeleteWorkflows"|"ExportAccountPolicies"|"ExportDocuments"|"ExportTemplates"|"RestoreDocuments"|"SubscribeWebhook"|"UpdateAccount"|"UpdateAccountDataStore"|"UpdateAccountPolicies"|"UpdateAccountRoles"|"UpdateAccountToken"|"UpdateBilling"|"UpdateCategories"|"UpdateCollections"|"UpdateContacts"|"UpdateDocumentRoles"|"UpdateFolders"|"UpdateIntakeResponses"|"UpdateIntakeShares"|"UpdateIntakes"|"UpdateMarketplaceItem"|"UpdateOrganizations"|"UpdateProfileRelations"|"UpdateRules"|"UpdateSaml"|"UpdateTags"|"UpdateTeams"|"UpdateTickets"|"UpdateWorkflows"|"ViewAccountDataStore"|"ViewAccountPolicies"|"ViewAccountRoles"|"ViewAccountToken"|"ViewAllDocuments"|"ViewAnalytics"|"ViewAuditLog"|"ViewBilling"|"ViewCategories"|"ViewCollections"|"ViewContacts"|"ViewDocumentRoles"|"ViewDocuments"|"ViewFolders"|"ViewIntakeResponses"|"ViewIntakeShares"|"ViewIntakes"|"ViewIntegrations"|"ViewOrganizations"|"ViewProfileRelations"|"ViewRuleExecutions"|"ViewRules"|"ViewSaml"|"ViewSubscription"|"ViewTags"|"ViewTeams"|"ViewTemplates"|"ViewTickets"|"ViewWebhook"|"ViewWorkflows")} AccountPermissions
 */
/**
 * Represents an account policy subscription
 * @typedef {Object} AccountPoliciesSubscription
 * @property {CudAction} action - Action
 * @property {AccountPolicy} item - Account policy Id
 */
/**
 * Represents an account policy
 * @typedef {Object} AccountPolicy
 * @property {DateTime} [accessedAt] - Date when the policy is accessed.
 * @property {Account} [account] - Account Id
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {AccountRole} [role] - Account role Id
 * @property {PolicyStatus} [status] - Policy's status. "pending" or "active".
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {User} [user] - User Id
 */
/**
 * @typedef {Object} AccountPolicyCursorPaginated
 * @property {string} [currentCursor] - Current id cursor
 * @property {Array<AccountPolicy>} items - List of items
 * @property {string} [nextCursor] - Next id cursor page
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {Object} AccountPolicyOrderByInput
 * @property {OrderBy} [accessedAt]
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [role]
 * @property {OrderBy} [status]
 * @property {OrderBy} [updatedAt]
 * @property {OrderBy} [user]
 */
/**
 * @typedef {Object} AccountPolicyPaginated
 * @property {Array<AccountPolicy>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {Object} AccountPolicyWhereInput
 * @property {string} [role]
 * @property {string} [search]
 * @property {DocumentStatus} [status]
 */
/**
 * Represents an account role
 * @typedef {Object} AccountRole
 * @property {Account} [account] - Account role owner
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {boolean} [global] - Set if your roles are globals
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - Name of the role
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {Array<AccountPermissions>} [permissions] - Name of the role
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * Represents an account saml
 * @typedef {Object} AccountSaml
 * @property {Account} account - Account Id
 * @property {AccountSamlConfig} [config] - Saml config
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * Represents an account saml configuration
 * @typedef {Object} AccountSamlConfig
 * @property {string} [cert]
 * @property {algorithm} [digestAlgorithm] - sha256
 * @property {string} [entryPoint]
 * @property {string} [identifierFormat]
 * @property {string} [identityProviderUrl]
 * @property {string} [issuer] - 449cb4c5-1660-4dd3-9e20-0abd673e385c
 * @property {string} [logoutUrl]
 * @property {algorithm} [signatureAlgorithm] - sha256
 */
/**
 * @typedef {Object} AccountSamlConfigInput
 * @property {string} cert
 * @property {algorithm} digestAlgorithm - sha256
 * @property {string} entryPoint
 * @property {string} identifierFormat
 * @property {string} identityProviderUrl
 * @property {string} issuer - 449cb4c5-1660-4dd3-9e20-0abd673e385c
 * @property {string} logoutUrl
 * @property {algorithm} signatureAlgorithm - sha256
 */
/**
 * Represents an account settings
 * @typedef {Object} AccountSettings
 * @property {boolean} [autoApproveDocPolicy] - Auto approve document access request
 * @property {boolean} [createTags] - Allow to create tags on documents
 * @property {boolean} [documentShareExternalAccountMembers] - Share documents with external account members
 * @property {Array<string>} [hiddenCategories] - Hidden categories
 * @property {string} [refBuilder] - Reference builder code
 * @property {number} [refCounter] - Reference initial counter
 * @property {boolean} [refModification] - Allow reference modification
 * @property {boolean} [repositoryViewAllDocs] - View all docs from repository
 */
/**
 * @typedef {Object} AccountSettingsInput
 * @property {boolean} [autoApproveDocPolicy] - Auto approve document access request
 * @property {boolean} [createTags] - Allow to create tags on documents
 * @property {boolean} [documentShareExternalAccountMembers] - Share documents with external account members
 * @property {Array<string>} [hiddenCategories] - Hidden categories
 * @property {string} [refBuilder] - Reference builder code
 * @property {number} [refCounter] - Reference initial counter
 * @property {boolean} [refModification] - Allow reference modification
 * @property {boolean} [repositoryViewAllDocs] - View all docs from repository
 */
/**
 * @typedef {Object} AccountTax
 * @property {string} taxId
 */
/**
 * Represents an account
 * @typedef {Object} AccountToken
 * @property {boolean} [active] - Has the value __true__ if the api key is active or the value __false__ if it is not. If the __Token__ has been disabled by error, please [contact us](mailto:support@bounsel.com).
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} id - An unique identifier for the object.
 * @property {string} [key] - Api token needed to use the API
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The account token name.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {number} [used] - Counter with the token usage
 * @property {DateTime} [usedAt] - When the key has been used
 */
/**
 * Represents a action node rule
 * @typedef {Object} ActionNodeRule
 * @property {Array<Capabilities>} [capabilities] - Action Node capabilities
 * @property {Array<JSON>} [config] - Action Node execution config
 * @property {string} [domain] - Action Node domain group
 * @property {string} [icon] - Action Node icon
 * @property {string} [id] - Action Node Id
 * @property {string} [name] - Action Node name
 * @property {JSON} [schema] - Action Node schema
 */
/**
 * Represents a action rule
 * @typedef {Object} ActionRule
 * @property {string} [cb] - Action callback
 * @property {JSON} [config] - Action params config
 * @property {string} [id] - Action Id
 * @property {string} node - Node action type
 * @property {JSON} [params] - Action params
 */
/**
 * @typedef {Object} ActionRuleInput
 * @property {string} [cb] - Action callback
 * @property {JSON} [config] - Action params config
 * @property {string} [id] - Action Id
 * @property {string} [node] - Node action type
 * @property {JSON} [params] - Action params
 */
/**
 * Represents a approval
 * @typedef {Object} Approval
 * @property {DateTime} [approvedAt] - Date time when the approval was approved
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {Document} document - Document Id
 * @property {string} email - Approval's email
 * @property {string} firstName - Signatory's first name
 * @property {string} id - An unique identifier for the object.
 * @property {string} lastName - Signatory's last name
 * @property {string} [message] - Custom message to send to the signatory
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {SecureNotification} [notification] - Contact secure notification
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {number} [order] - Approval order
 * @property {string} [phone] - Approval's phone
 * @property {DateTime} [rejectedAt] - Date time when the approval was rejected
 * @property {DateTime} [requestedAt] - Date time when the approval was requested
 * @property {ApprovalSettings} [settings] - Approval settings
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * Represents a approval
 * @typedef {Object} ApprovalMessage
 * @property {Approval} approval - Approval
 * @property {User} [author] - Approval message author id
 * @property {string} [authorEmail] - Approval message author email
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} id - An unique identifier for the object.
 * @property {string} message - Approval message
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {string} [type] - Approval message type
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {Object} ApprovalMessagePaginated
 * @property {string} [currentCursor] - Current id cursor
 * @property {Array<ApprovalMessage>} items - List of items
 * @property {string} [nextCursor] - Next id cursor page
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * Represents an approval message subscription
 * @typedef {Object} ApprovalMessagesSubscription
 * @property {CudAction} action - Action
 * @property {ApprovalMessage} item - Approval message
 */
/**
 * @typedef {Object} ApprovalPaginated
 * @property {Array<Approval>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {("parallel"|"sequence")} ApprovalProcessType
 */
/**
 * Represents a approval setting
 * @typedef {Object} ApprovalSettings
 * @property {boolean} [allowComment] - Allow add or remove comments during the review process
 * @property {boolean} [allowDownload] - Allow to download the pdf before review
 * @property {boolean} [allowModification] - Allow modified your approval or reject
 */
/**
 * Represents a valid object with the data to sign
 * @typedef {Object} ApprovalToReview
 * @property {Account} account - Account
 * @property {Approval} approval - Approval
 * @property {User} [author] - Author
 * @property {string} content - Pdf url
 */
/**
 * Represents an audit
 * @typedef {Object} Audit
 * @property {Account} [account] - Account context
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {JSON} [details] - Request details information
 * @property {Document} [document] - Document context
 * @property {Events} eventType - Event type
 * @property {string} id - An unique identifier for the object.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {JSON} [payload] - Payload info related with the event
 * @property {AuditASObject} [target] - Object context
 * @property {User} [toUser] - User who receive the event context
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {User} [user] - User who make the event context
 */
/**
 * Represents an audit
 * @typedef {Object} AuditASObject
 * @property {JSON} [context] - Object context
 * @property {string} [id] - Object id
 * @property {Domains} [type] - Object type
 */
/**
 * @typedef {Object} AuditCursorPaginated
 * @property {string} [currentCursor] - Current id cursor
 * @property {Array<Audit>} items - List of items
 * @property {string} [nextCursor] - Next id cursor page
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {Object} AuditPaginated
 * @property {Array<Audit>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {("activity"|"analytics"|"approvalMessages"|"approvals"|"attachmentFiles"|"attachments"|"audit"|"authSaml"|"branding"|"brandingColors"|"brandingEmails"|"categories"|"collections"|"crm"|"documentShareLink"|"documentStatus"|"documents"|"documentsImport"|"downloadDoc"|"downloadPdf"|"editor"|"exportCsv"|"flowAdvancedQuestions"|"flowBasicQuestions"|"flowCustomDesign"|"flowCustomDesignPalettes"|"flowHideWatermark"|"flowLogic"|"flowMultiple"|"flowRedirectUrl"|"flowSendCompletedDocument"|"flowShareApps"|"flowShareDirect"|"flowSharePrivate"|"flowSharePublic"|"flows"|"folderSmart"|"folders"|"integrationAi"|"integrationAirtable"|"integrationApi"|"integrationDocusign"|"integrationGcalendar"|"integrationGdrive"|"integrationHubspot"|"integrationMsharepoint"|"integrationMteams"|"integrationNotion"|"integrationS3"|"integrationSlack"|"integrationTwilio"|"integrationWebhook"|"integrationWebhooknotification"|"integrationZapier"|"integrationZapsign"|"marketplace"|"marketplacePublish"|"massiveActions"|"members"|"notificationCustomMessage"|"notifications"|"ocr"|"parties"|"privateNote"|"publicPortal"|"reminders"|"renewals"|"repositoryAdvancedSearch"|"repositorySearch"|"rules"|"signatures"|"smartFields"|"supportChat"|"supportHelpCenter"|"tagColor"|"tags"|"teams"|"templates"|"ticketing"|"ticketingActivity"|"ticketingCustomFields"|"variables"|"variablesDetection"|"versions"|"workflows")} Capabilities
 */
/**
 * Represents a tags subscription
 * @typedef {Object} CategoriesSubscription
 * @property {CudAction} action - Action performed on the category subcription
 * @property {Category} item - Category object
 */
/**
 * Represents a category
 * @typedef {Object} Category
 * @property {Account} [account] - Account owner of the category
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {boolean} [global] - Flag to describe whether the category is Bounsel default or a new one
 * @property {string} [group] - Name of the group in which the category belongs to.
 * @property {boolean} [hidden] - Flag to describe whether the category is hidden or not
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - The category name.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {string} slug - Extension name given to the category. Written in kebab-case format. Often useful for displaying to developers. Is kebab-case sensitive.
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {Object} CategoryOrderByInput
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [group]
 * @property {OrderBy} [name]
 */
/**
 * @typedef {Object} CategoryPaginated
 * @property {Array<Category>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {Object} CategoryWhereInput
 * @property {string} [group]
 * @property {string} [name]
 * @property {string} [search]
 */
/**
 * @typedef {("delivered"|"failed"|"opened"|"pending"|"sent")} CertifyOptions
 */
/**
 * @typedef {Object} CompletedByUserInput
 * @property {string} email - User email who fill the flow
 * @property {string} firstName - First name's user who fill the flow
 * @property {string} [lastName] - Last name's user who fill the flow
 */
/**
 * Represents a contact
 * @typedef {Object} Contact
 * @property {Account} account - Account Id
 * @property {Array<JSON>} [attributes] - Contact attributes
 * @property {string} [avatar] - Avatar's contact
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} email - Contact email
 * @property {string} firstName - First name's contact
 * @property {string} id - An unique identifier for the object.
 * @property {string} [lastName] - Last name's contact
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - Contact name
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {JSON} [plainAttributes] - Contact attributes
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {Object} ContactOrderByInput
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [email]
 * @property {OrderBy} [firstName]
 * @property {OrderBy} [lastName]
 */
/**
 * @typedef {Object} ContactPaginated
 * @property {Array<Contact>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {Object} ContactWhereInput
 * @property {string} [email]
 * @property {string} [firstName]
 * @property {string} [lastName]
 * @property {string} [search]
 */
/**
 * Represents an contact subscription
 * @typedef {Object} ContactsSubscription
 * @property {CudAction} action - Action
 * @property {Contact} item - Contact Id
 */
/**
 * @typedef {Object} CreateAccountInput
 * @property {boolean} acceptTos - Terms of service acceptance
 * @property {AccountBrandInput} [brand] - Brand details
 * @property {AccountContactInput} contact - Contact details
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - The account name.
 * @property {AccountSettingsInput} [settings] - Account settings
 */
/**
 * @typedef {Object} CreateAccountPolicyInput
 * @property {string} [message] - Custom message for the notification
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} role - Account role Id
 * @property {UserInviteOrConnectInput} user - User Id
 */
/**
 * @typedef {Object} CreateAccountSamlInput
 * @property {AccountSamlConfigInput} [config] - Saml config
 * @property {string} [configXml] - Saml config in XML format
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} slug - Kebab case name to identify saml account
 */
/**
 * @typedef {Object} CreateApprovalInput
 * @property {string} email - Approval's email
 * @property {string} firstName - Signatory's first name
 * @property {string} lastName - Signatory's last name
 * @property {string} [message] - Custom message to send to the signatory
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {number} [order] - Approval order
 * @property {string} [phone] - Approval's phone
 */
/**
 * @typedef {Object} CreateApprovalMessageInput
 * @property {string} [author] - Approval message author id
 * @property {string} [authorEmail] - Approval message author email
 * @property {string} message - Approval message
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [type] - Approval message type
 */
/**
 * @typedef {Object} CreateDocumentInput
 * @property {string} [category] - The ID of the __Category__ attached to this document. Often useful to organize your documents.
 * @property {Level} [complexity] - The complexity of the document
 * @property {string} [currency] - Currency detail
 * @property {DocumentDelimiter} [delimiter] - Select delimiters to detect variables
 * @property {string} [description] - An arbitrary string attached to the object. Often useful for displaying to users.
 * @property {DateTime} [endedAt] - End date of the document
 * @property {string} [folder] - The ID of the __Folder__ where the document is located on.
 * @property {string} [jurisdiction] - It refers to where a dispute will be resolved
 * @property {string} [language] - The language which has been wrote this document. The value must be an [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) into __lower-case__. It has upper-case/lower-case sensibility.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The document name without extension.
 * @property {Level} [priority] - The priority of the document
 * @property {boolean} [public] - Make document read permission to all your organization
 * @property {string} [ref] - An unique reference number.
 * @property {boolean} [renewal] - Whether the document is automatically renewed.
 * @property {DocumentSettingsInput} [settings] - Document settings
 * @property {DateTime} [startedAt] - Start date of the document
 * @property {DocumentStatus} [status] - Document status
 * @property {Array<string>} [tags] - Value of the contract
 * @property {number} [value] - Value of the contract
 */
/**
 * @typedef {Object} CreateDocumentLinkInput
 * @property {Array<string>} [allowList] - List of allowed domains for the document link.
 * @property {Array<string>} [denyList] - List of denied domains for the document link.
 * @property {DateTime} [expiredAt] - Date when the document link expires.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Document Link name
 * @property {string} [password] - Password to access the document link.
 * @property {string} role - Document role Id
 */
/**
 * @typedef {Object} CreateDocumentPolicyInput
 * @property {string} [message] - Custom message for the notification
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} role - Document role Id
 * @property {UserInviteOrConnectInput} user - User Id
 */
/**
 * @typedef {Object} CreateDocumentRelationInput
 * @property {string} from - Document relation from Id
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} to - Document relation to Id
 * @property {string} type - Type of document relation
 */
/**
 * @typedef {Object} CreateDocumentRoleInput
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - Name of the role
 * @property {Array<DocumentPermissions>} permissions - Name of the role
 */
/**
 * @typedef {Object} CreateFolderInput
 * @property {FolderGroupEnum} group - Group/collection name
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - Folder's name
 * @property {string} [parent] - Parent folder
 */
/**
 * @typedef {Object} CreateFormFlowInput
 * @property {boolean} [active] - Set an active form flow
 * @property {boolean} [default] - Set a default form flow
 * @property {string} [description] - FormFlow's description
 * @property {string} document - Document Id
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - FormFlow's name
 * @property {FormFlowOptionInput} [options] - Options form flow
 * @property {Array<JSON>} [questions] - Questions
 * @property {string} [slug] - FormFlow's slug
 */
/**
 * @typedef {Object} CreateIntakeInput
 * @property {boolean} [active] - Set an active intake
 * @property {boolean} [default] - Set a default intake
 * @property {string} [description] - Intake's description
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Intake's name
 * @property {IntakeOptionInput} [options] - Options
 * @property {JSON} [questions] - Questions
 * @property {string} [slug] - Intake's slug
 * @property {JSON} [theme] - Theme
 */
/**
 * @typedef {Object} CreateIntakeResponseInput
 * @property {string} [email] - An email to share this flow. If this field has not empty only the email specified can complete this flow.
 * @property {string} [name] - Intake name
 * @property {JSON} [result] - Result of the flow
 */
/**
 * @typedef {Object} CreateMarketplaceItemInput
 * @property {string} [cover] - Cover image of the item
 * @property {string} [currency] - Currency of the value
 * @property {string} [description] - Marketplace item's description
 * @property {string} documentId - Title of the item
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {Array<string>} [tags] - Keywords related with the item
 * @property {string} title - Title of the item
 * @property {number} [value] - Price of this marketplace item
 */
/**
 * @typedef {Object} CreatePartyInput
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The party name.
 * @property {number} [order] - Order of the party
 * @property {PartyType} type - Type of party. It can be a "Person" or "Organisation".
 */
/**
 * @typedef {Object} CreateProfileRelationInput
 * @property {string} [document] - Document Id related with profile relation
 * @property {string} from - Profile relation from Id
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} to - Profile relation to Id
 * @property {string} type - Type of profile relation
 */
/**
 * @typedef {Object} CreateReminderInput
 * @property {Array<ReminderContactInput>} [contacts] - Contact
 * @property {string} [description] - Reminder's description
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Reminder's name
 * @property {DateTime} notifyAt - Date when the notification should be sent
 */
/**
 * @typedef {Object} CreateRuleInput
 * @property {Array<ActionRuleInput>} [actions] - Rule's actions
 * @property {string} [active] - Rule activated
 * @property {string} [cron] - Cron expression
 * @property {string} [description] - Rule's description
 * @property {Array<Events>} [events] - Rule events
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - Rule's name
 * @property {Array<string>} [tags] - Rule's tags
 * @property {JSON} [trigger] - Rule's trigger
 * @property {string} [workflow] - Workflow Id
 */
/**
 * @typedef {Object} CreateSignatureInput
 * @property {string} email - Signature's email
 * @property {string} firstName - Signatory's first name
 * @property {string} [idNumber] - Signature's ID number
 * @property {string} lastName - Signatory's last name
 * @property {string} [message] - Custom message to send to the signatory
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {number} [order] - Signature order
 * @property {string} party - Party side Id
 * @property {string} [phone] - Signature's phone
 * @property {SignatureSettingsInput} [settings] - Signature settings
 */
/**
 * @typedef {Object} CreateSignaturePlaceholderInput
 * @property {string} [keyName] - Key name
 * @property {string} [message] - Custom message to send to the signatory
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {number} [order] - Signature order
 * @property {string} party - Party side Id
 * @property {SignatureSettingsInput} [settings] - Signature settings
 */
/**
 * @typedef {Object} CreateTemplateInput
 * @property {string} [category] - The ID of the __Category__ attached to this document. Often useful to organize your documents.
 * @property {Level} [complexity] - The complexity of the document
 * @property {string} [currency] - Currency detail
 * @property {DocumentDelimiter} [delimiter] - Select delimiters to detect variables
 * @property {string} [description] - An arbitrary string attached to the object. Often useful for displaying to users.
 * @property {string} [folder] - The ID of the __Folder__ where the document is located on.
 * @property {string} [jurisdiction] - It refers to where a dispute will be resolved
 * @property {string} [language] - The language which has been wrote this document. The value must be an [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) into __lower-case__. It has upper-case/lower-case sensibility.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - The document name without extension.
 * @property {Level} [priority] - The priority of the document
 * @property {boolean} [public] - Make document read permission to all your organization
 * @property {boolean} [published] - Has the value __true__ if the template is published or the value __false__ if it is not.
 * @property {DocumentSettingsInput} [settings] - Document settings
 * @property {Array<string>} [tags] - Value of the contract
 * @property {number} [value] - Value of the contract
 */
/**
 * @typedef {Object} CreateTicketInput
 * @property {string} [assignee] - Assignee of the ticket
 * @property {string} [category] - The ID of the __Category__ attached to this ticket. Often useful to organize your tickets.
 * @property {Level} [complexity] - The complexity of the ticket
 * @property {string} [description] - Description of the ticket
 * @property {DateTime} [dueDateAt] - End date of the ticke
 * @property {string} [language] - The language which has been wrote this ticket. The value must be an [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) into __lower-case__. It has upper-case/lower-case sensibility.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The ticket name without extension.
 * @property {Level} [priority] - The priority of the ticket
 * @property {string} [ref] - An unique reference number.
 * @property {string} [requester] - Requester of the ticket
 * @property {TicketSettingsInput} [settings] - Settings of the ticket
 * @property {TicketStatus} [status] - Ticket status
 * @property {Array<string>} [tags] - A list of __Tag__ IDs attached to the ticket. Often useful to organize your tickets.
 */
/**
 * @typedef {("add"|"delete"|"update")} CudAction
 */
/**
 * A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format.
 * @typedef {*} DateTime
 */
/**
 * @typedef {Object} Deleted
 * @property {boolean} deleted - Show if the resource has been deleted.
 * @property {string} id - An unique identifier for the object.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 */
/**
 * @typedef {Object} DeletedMany
 * @property {number} deleted - Show if the resources has been deleted.
 */
/**
 * Represents a document
 * @typedef {Object} Document
 * @property {boolean} [access] - Allow access to document
 * @property {Account} [account] - Account owner of the template
 * @property {boolean} [approved] - Whether the document is approved
 * @property {boolean} [archived] - Document is archived
 * @property {User} [author] - Author template
 * @property {DateTime} [cancelledAt] - Time at which the document was cancelled.
 * @property {Category} [category] - The ID of the __Category__ attached to this document. Often useful to organize your documents.
 * @property {string} [complexity] - The complexity of the document
 * @property {DocumentContent} [content] - Content info
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} [currency] - Currency detail
 * @property {string} [description] - An arbitrary string attached to the object. Often useful for displaying to users.
 * @property {DateTime} [endedAt] - End date of the document
 * @property {Folder} [folder] - The ID of the __Folder__ where the document is located on.
 * @property {string} id - An unique identifier for the object.
 * @property {string} [jurisdiction] - It refers to where a dispute will be resolved
 * @property {string} [language] - The language which has been wrote this document. The value must be an [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) into __lower-case__. It has upper-case/lower-case sensibility.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The document name without extension.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {Array<DocumentPermissions>} [permissions] - Current user permissions
 * @property {string} [priority] - The priority of the document
 * @property {RagStatus} [ragStatus] - RAG status of the document
 * @property {string} [ref] - An unique reference number.
 * @property {boolean} [renewal] - Whether the document is automatically renewed.
 * @property {number} [risk] - Risk of the document
 * @property {string} [role] - Current user role
 * @property {DocumentSettings} [settings] - Document settings
 * @property {boolean} [signed] - Whether the document is signed
 * @property {DateTime} [startedAt] - Start date of the document
 * @property {string} [status] - Document status
 * @property {JSON} [statusChecker] - Status action list of the document
 * @property {Array<Tag>} [tags] - A list of __Tag__ IDs attached to the document. Often useful to organize your documents.
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {string} [value] - Value of the contract
 * @property {JSON} [variables] - Set of key-value pairs to complete a document. Each variable must match with your template variables.
 */
/**
 * Represents a document content
 * @typedef {Object} DocumentContent
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {JSON} [delimiters] - Delimiters to auto detect variables
 * @property {DocumentUnion} document - Document owner of the content file
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [mimetype] - Type of file
 * @property {string} [name] - Name for the content file
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {string} [path] - Main content file
 * @property {string} [pathMerge] - Main content file merge with variables (Only documents)
 * @property {string} [preview] - PDF preview of the content file
 * @property {boolean} readOnly - Variables are read only
 * @property {string} [signed] - Main signed content file
 * @property {ProcessStatus} status - Process status
 * @property {string} [thumbnail] - Preview of the content file
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {Array<Variable>} [variables] - List of variables
 * @property {number} version - Content version
 */
/**
 * @typedef {("BRACKET"|"DOLLAR_KEY"|"DOUBLE_KEY"|"KEY")} DocumentDelimiter
 */
/**
 * Represents an document link
 * @typedef {Object} DocumentLink
 * @property {DateTime} [accessedAt] - Date when the policy is accessed.
 * @property {Array<string>} [allowList] - List of allowed domains for the document link.
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {Array<string>} [denyList] - List of denied domains for the document link.
 * @property {Document} [document] - Document Id
 * @property {DateTime} [expiredAt] - Date when the document link expires.
 * @property {string} id - An unique identifier for the object.
 * @property {boolean} [isExpired] - Indicates if the document link is expired.
 * @property {boolean} [isSecure] - Indicates if the document link is secure.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Document Link name
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {Array<DocumentPermissions>} [permissions] - Document permissions.
 * @property {DocumentRole} [role] - Document role Id
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * Represents a document locked
 * @typedef {Object} DocumentLocked
 * @property {boolean} [locked] - Document is locked by other user
 * @property {DateTime} [lockedAt] - Date when the document was locked
 * @property {User} [user] - User who locked the document
 */
/**
 * @typedef {Object} DocumentOrderByInput
 * @property {OrderBy} [complexity]
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [endedAt]
 * @property {OrderBy} [jurisdiction]
 * @property {OrderBy} [language]
 * @property {OrderBy} [name]
 * @property {OrderBy} [priority]
 * @property {OrderBy} [ragStatus]
 * @property {OrderBy} [ref]
 * @property {OrderBy} [renewal]
 * @property {OrderBy} [risk]
 * @property {OrderBy} [startedAt]
 * @property {OrderBy} [status]
 * @property {OrderBy} [updatedAt]
 * @property {OrderBy} [value]
 */
/**
 * @typedef {Object} DocumentPaginated
 * @property {Array<Document>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {("AccessFormFlow"|"AddSuggestions"|"ChangeOwner"|"CloneDocument"|"CreateApprovals"|"CreateAttachments"|"CreateComments"|"CreateDocumentLinks"|"CreateDocumentPolicies"|"CreateDocumentRelations"|"CreateFormFlows"|"CreateParties"|"CreateReminders"|"CreateSignatures"|"CreateVariables"|"DeleteApprovals"|"DeleteAttachments"|"DeleteComments"|"DeleteDocument"|"DeleteDocumentLinks"|"DeleteDocumentPolicies"|"DeleteDocumentRelations"|"DeleteFormFlows"|"DeleteParties"|"DeleteReminders"|"DeleteSignatures"|"DeleteVariables"|"EditContent"|"ExportActivity"|"ExportContent"|"RequestApprovals"|"RequestSignatures"|"RestoreVersion"|"UpdateApprovals"|"UpdateAttachments"|"UpdateComments"|"UpdateDocument"|"UpdateDocumentLinks"|"UpdateDocumentPolicies"|"UpdateDocumentRelations"|"UpdateFormFlows"|"UpdateParties"|"UpdateReminders"|"UpdateReview"|"UpdateSettings"|"UpdateSettingsVariables"|"UpdateSignatures"|"UpdateVariables"|"UpdateVersions"|"ViewActivity"|"ViewAnalytics"|"ViewApprovals"|"ViewAttachments"|"ViewComments"|"ViewContent"|"ViewDocument"|"ViewDocumentLinks"|"ViewDocumentPolicies"|"ViewDocumentRelations"|"ViewFormFlows"|"ViewParties"|"ViewReminders"|"ViewReview"|"ViewSettings"|"ViewSignatures"|"ViewSuggestions"|"ViewVariables"|"ViewVersions")} DocumentPermissions
 */
/**
 * Represents an document policy subscription
 * @typedef {Object} DocumentPoliciesSubscription
 * @property {CudAction} action - Action
 * @property {DocumentPolicy} item - Document policy Id
 */
/**
 * Represents an document policy
 * @typedef {Object} DocumentPolicy
 * @property {DateTime} [accessedAt] - Date when the policy is accessed.
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {Document} document - Document Id
 * @property {string} id - An unique identifier for the object.
 * @property {boolean} [important] - Mark as important a document
 * @property {boolean} [inAccount] - Belong to the account
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [note] - Private note in the document
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {DocumentRole} role - Document role Id
 * @property {PolicyStatus} status - Policy's status. "pending" or "active".
 * @property {boolean} [subscribe] - Subscribe to the documents events
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {User} user - User Id
 */
/**
 * @typedef {Object} DocumentPolicyOrderByInput
 * @property {OrderBy} [accessedAt]
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [role]
 * @property {OrderBy} [status]
 * @property {OrderBy} [updatedAt]
 * @property {OrderBy} [user]
 */
/**
 * @typedef {Object} DocumentPolicyPaginated
 * @property {Array<DocumentPolicy>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {Object} DocumentPolicyWhereInput
 * @property {string} [role]
 * @property {string} [search]
 * @property {DocumentStatus} [status]
 */
/**
 * Represents a Document Relation
 * @typedef {Object} DocumentRelation
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {DocumentUnion} from - Document relation from Id
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {DocumentUnion} [to] - Document relation to Id
 * @property {string} [type] - Type of document relation
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {Object} DocumentRelationOrderByInput
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [from]
 * @property {OrderBy} [to]
 * @property {OrderBy} [type]
 */
/**
 * @typedef {Object} DocumentRelationPaginated
 * @property {Array<DocumentRelation>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {Object} DocumentRelationWhereInput
 * @property {string} [from]
 * @property {string} [search]
 * @property {string} [to]
 * @property {string} [type]
 */
/**
 * Represents an documentRelation subscription
 * @typedef {Object} DocumentRelationsSubscription
 * @property {CudAction} action - Action
 * @property {DocumentRelation} item - Document relation
 */
/**
 * Represents a document role
 * @typedef {Object} DocumentRole
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {boolean} global - Set if your roles are globals
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - Name of the role
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {Array<DocumentPermissions>} [permissions] - Document role permissions such create policies, create projects, etc..
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * Represents a Document setting
 * @typedef {Object} DocumentSettings
 * @property {ApprovalProcessType} [approvalProcess] - Approval process
 * @property {SignProcessType} [signProcess] - Sign process
 */
/**
 * @typedef {Object} DocumentSettingsInput
 * @property {ApprovalProcessType} [approvalProcess] - Approval process
 * @property {SignProcessType} [signProcess] - Sign process
 */
/**
 * @typedef {("active"|"approved"|"awaitingInput"|"cancelled"|"completed"|"drafting"|"expired"|"initial"|"negotiating"|"onHold"|"pendingAction"|"rejected"|"renewed"|"signed"|"signing"|"toExpire"|"toRenew"|"toReview"|"toSign"|"underExternalReview"|"underFinanceReview"|"underLegalReview"|"underReview")} DocumentStatus
 */
/**
 * Document type
 * @typedef {(Document|Template)} DocumentUnion
 */
/**
 * @typedef {Object} DocumentWhereInput
 * @property {JSON} [filters]
 * @property {string} [folderId]
 * @property {string} [name]
 * @property {string} [search]
 * @property {DocumentStatus} [status]
 */
/**
 * @typedef {("account"|"accountDataStore"|"accountIntegration"|"accountPolicy"|"accountRole"|"accountSaml"|"accountToken"|"activity"|"addon"|"admin"|"approval"|"approvalMessage"|"attachment"|"audit"|"category"|"collection"|"contact"|"crmCompany"|"crmContact"|"crmDeal"|"currency"|"document"|"documentContent"|"documentLink"|"documentPolicy"|"documentRelation"|"documentRole"|"folder"|"formFlow"|"formFlowShare"|"intake"|"intakeResponse"|"intakeShare"|"integration"|"invoice"|"marketplaceItem"|"organization"|"party"|"paymentMethod"|"product"|"productQuota"|"profileRelation"|"promotionCode"|"reminder"|"reminderContact"|"rule"|"ruleExecution"|"secureNotification"|"share"|"signature"|"signaturePlaceholder"|"sla"|"subscription"|"tag"|"taxRate"|"template"|"ticket"|"user"|"userAuth"|"variable"|"webhook"|"workflow")} Domains
 */
/**
 * @typedef {Object} Done
 * @property {boolean} done - Show if the action was done.
 */
/**
 * @typedef {Object} EnableAccountIntegrationInput
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {JSON} [options] - Extra options to config the integration
 */
/**
 * @typedef {Object} EnumKeyPair
 * @property {string} key - Key of enum property
 * @property {string} label - Label of enum property
 * @property {string} value - Value of enum property
 */
/**
 * @typedef {("AccountCreated"|"AccountDataStoreCreated"|"AccountDataStoreDeleted"|"AccountDataStoreMetadataUpdated"|"AccountDataStoreUpdated"|"AccountDeleted"|"AccountDisabled"|"AccountEnabled"|"AccountIntegrationDisable"|"AccountIntegrationEnable"|"AccountIntegrationExecuted"|"AccountIntegrationGenerateKey"|"AccountIntegrationMetadataUpdated"|"AccountIntegrationUpdated"|"AccountMetadataUpdated"|"AccountNotificationIdentityDisabled"|"AccountNotificationIdentityEnabled"|"AccountNotificationIdentityVerified"|"AccountPolicyAccessed"|"AccountPolicyCreated"|"AccountPolicyDeleted"|"AccountPolicyMetadataUpdated"|"AccountPolicyRequested"|"AccountPolicyUpdated"|"AccountRoleCreated"|"AccountRoleDeleted"|"AccountRoleMetadataUpdated"|"AccountRoleUpdated"|"AccountSamlCreated"|"AccountSamlDeleted"|"AccountSamlMetadataUpdated"|"AccountSamlUpdated"|"AccountTokenCreated"|"AccountTokenDeleted"|"AccountTokenDisabled"|"AccountTokenEnabled"|"AccountTokenKeyUpdated"|"AccountTokenMetadataUpdated"|"AccountTokenUpdated"|"AccountTokenUsedAtUpdated"|"AccountTosAccepted"|"AccountUpdated"|"ActivityCreated"|"ActivityDeleted"|"ActivityUpdated"|"AdminAccessed"|"AdminCreated"|"AdminDeleted"|"AdminEmailUpdated"|"AdminPasswordUpdated"|"AdminUpdated"|"ApprovalApproved"|"ApprovalCreated"|"ApprovalDeleted"|"ApprovalMessageCreated"|"ApprovalMessageDeleted"|"ApprovalMessageUpdated"|"ApprovalRejected"|"ApprovalRequested"|"ApprovalUpdated"|"AttachmentCreated"|"AttachmentDeleted"|"AttachmentUpdated"|"CategoryCreated"|"CategoryDeleted"|"CategoryUpdated"|"CollectionCreated"|"CollectionDeleted"|"CollectionFieldAdded"|"CollectionRecordAdded"|"CollectionUpdated"|"ContactCreated"|"ContactDeleted"|"ContactUpdated"|"DocumentActionCreated"|"DocumentActionDeleted"|"DocumentActionFullyCompleted"|"DocumentActionUpdated"|"DocumentActivated"|"DocumentArchived"|"DocumentCancelled"|"DocumentContentCreated"|"DocumentContentDeleted"|"DocumentContentReadOnly"|"DocumentContentStatusUpdated"|"DocumentContentUpdated"|"DocumentCreated"|"DocumentDeleted"|"DocumentDestinationFolderUpdated"|"DocumentEdited"|"DocumentExpired"|"DocumentFullyApproved"|"DocumentFullyRejected"|"DocumentFullySigned"|"DocumentLinkAccessed"|"DocumentLinkCreated"|"DocumentLinkDeleted"|"DocumentLinkMetadataUpdated"|"DocumentLinkUpdated"|"DocumentOnHolded"|"DocumentOnUnHolded"|"DocumentPolicyAccessed"|"DocumentPolicyCreated"|"DocumentPolicyDeleted"|"DocumentPolicyMetadataUpdated"|"DocumentPolicyRequested"|"DocumentPolicyUpdated"|"DocumentRelationCreated"|"DocumentRelationDeleted"|"DocumentRelationUpdated"|"DocumentRenewed"|"DocumentRestored"|"DocumentRoleCreated"|"DocumentRoleDeleted"|"DocumentRoleMetadataUpdated"|"DocumentRoleUpdated"|"DocumentStatusUpdated"|"DocumentToExpired"|"DocumentToRenewed"|"DocumentUpdated"|"EditorLocked"|"FolderCreated"|"FolderDeleted"|"FolderUpdated"|"FormFlowCompleted"|"FormFlowCreated"|"FormFlowDeleted"|"FormFlowSetDefault"|"FormFlowShareCreated"|"FormFlowShareDeleted"|"FormFlowShareUpdated"|"FormFlowUpdated"|"IntakeCompleted"|"IntakeCreated"|"IntakeDeleted"|"IntakeResponseCreated"|"IntakeResponseDeleted"|"IntakeResponseUpdated"|"IntakeSetDefault"|"IntakeShareCreated"|"IntakeShareDeleted"|"IntakeShareUpdated"|"IntakeUpdated"|"IntegrationCreated"|"IntegrationDeleted"|"IntegrationMetadataUpdated"|"IntegrationUpdated"|"MarketplaceItemApproveUpdated"|"MarketplaceItemCreated"|"MarketplaceItemDeleted"|"MarketplaceItemUpdated"|"OrganizationCreated"|"OrganizationDeleted"|"OrganizationUpdated"|"PartyCreated"|"PartyDeleted"|"PartyUpdated"|"ProductCreated"|"ProductDeleted"|"ProductDisabled"|"ProductEnabled"|"ProductUpdated"|"ProfileRelationCreated"|"ProfileRelationDeleted"|"ProfileRelationUpdated"|"ReminderContactCreated"|"ReminderContactDeleted"|"ReminderContactUpdated"|"ReminderCreated"|"ReminderDeleted"|"ReminderNotified"|"ReminderUpdated"|"RuleActivated"|"RuleCreated"|"RuleDeactivated"|"RuleDeleted"|"RuleExecutionCreated"|"RuleExecutionDeleted"|"RuleMetadataUpdated"|"RuleUpdated"|"SecureNotificationCreated"|"SecureNotificationDeleted"|"SecureNotificationMetadataUpdated"|"SecureNotificationStatusUpdated"|"SecureNotificationUpdated"|"ShareCreated"|"ShareDeleted"|"ShareUpdated"|"SignatureCreated"|"SignatureDeleted"|"SignaturePlaceholderCreated"|"SignaturePlaceholderDeleted"|"SignaturePlaceholderUpdated"|"SignatureRequested"|"SignatureSigned"|"SignatureUpdated"|"SlaCreated"|"SlaDeleted"|"SlaUpdated"|"StripeChargeFailed"|"StripeChargeSucceeded"|"StripeCustomerCreated"|"StripeCustomerDeleted"|"StripeCustomerDiscountCreated"|"StripeCustomerDiscountDeleted"|"StripeCustomerDiscountUpdated"|"StripeCustomerSourceCreated"|"StripeCustomerSourceUpdated"|"StripeCustomerSubscriptionCreated"|"StripeCustomerSubscriptionDeleted"|"StripeCustomerSubscriptionPendingUpdateApplied"|"StripeCustomerSubscriptionPendingUpdateExpired"|"StripeCustomerSubscriptionTrialWillEnd"|"StripeCustomerSubscriptionUpdated"|"StripeCustomerTaxIdCreated"|"StripeCustomerTaxIdDeleted"|"StripeCustomerTaxIdUpdated"|"StripeCustomerUpdated"|"StripeInvoiceCreated"|"StripeInvoiceFinalizationFailed"|"StripeInvoiceFinalized"|"StripeInvoiceItemCreated"|"StripeInvoiceItemDeleted"|"StripeInvoiceItemUpdated"|"StripeInvoicePaid"|"StripeInvoicePaymentFailed"|"StripeInvoicePaymentSucceeded"|"StripeInvoiceSent"|"StripeInvoiceUpcoming"|"StripeInvoiceUpdated"|"StripeIssuingAuthorizationRequest"|"StripeIssuingAuthorizationUpdated"|"StripeIssuingCardCreated"|"StripeIssuingCardHolderCreated"|"StripeIssuingCardHolderUpdated"|"StripeIssuingCardUpdated"|"StripePaymentIntentAmountCapturableUpdated"|"StripePaymentIntentCanceled"|"StripePaymentIntentCreated"|"StripePaymentIntentPaymentFailed"|"StripePaymentIntentSucceeded"|"StripePaymentMethodAttached"|"StripePaymentMethodDetached"|"StripePaymentMethodUpdated"|"StripePlanCreated"|"StripePlanDeleted"|"StripePlanUpdated"|"StripePriceCreated"|"StripePriceDeleted"|"StripePriceUpdated"|"StripeProductCreated"|"StripeProductDeleted"|"StripeProductUpdated"|"StripePromotionCodeCreated"|"StripePromotionCodeUpdated"|"StripeSetupIntentCreated"|"StripeSetupIntentFailed"|"StripeSetupIntentRequiresAction"|"StripeSetupIntentSucceeded"|"StripeTaxRateCreated"|"StripeTaxRateDeleted"|"StripeTaxRateUpdated"|"SubFormFlowCompleted"|"SubIntakeCompleted"|"SubscriptionCancelled"|"SubscriptionCreated"|"SubscriptionDeleted"|"SubscriptionUpdated"|"SubscriptionUsageRecorded"|"SubscriptionUsageReset"|"TagCreated"|"TagDeleted"|"TagUpdated"|"TemplateCreated"|"TemplateDeleted"|"TemplateDestinationFolderUpdated"|"TemplatePublished"|"TemplateUnPublished"|"TemplateUpdated"|"TicketArchived"|"TicketAssigneeUpdated"|"TicketCreated"|"TicketDeleted"|"TicketRestored"|"TicketStatusUpdated"|"TicketUpdated"|"UserAccessed"|"UserAwayUpdated"|"UserCreated"|"UserDeleted"|"UserDisabled"|"UserEditorConnected"|"UserEditorDisconnected"|"UserEmailUpdated"|"UserEmailVerified"|"UserEnabled"|"UserMetadataUpdated"|"UserOauthAccountAdded"|"UserOauthAccountRemoved"|"UserPasswordUpdated"|"UserPhoneVerified"|"UserTosAccepted"|"UserUpdated"|"WebhookCreated"|"WebhookDeleted"|"WebhookUpdated"|"WorkflowActivated"|"WorkflowCreated"|"WorkflowDeactivated"|"WorkflowDeleted"|"WorkflowMetadataUpdated"|"WorkflowUpdated")} Events
 */
/**
 * Represents a folder
 * @typedef {Object} Folder
 * @property {Account} account - Account Id
 * @property {FolderAncestors} [ancestors] - Ancestors details
 * @property {Array<Folder>} [children] - Children folders
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {FolderGroupEnum} group - Group/collection name
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - Folder's name
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {Folder} [parent] - Parent folder
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * Represents a folder ancestor
 * @typedef {Object} FolderAncestors
 * @property {Folder} [parent] - Parent tree ancestor
 * @property {Array<Folder>} [path] - Breadcrumb folder elements
 * @property {Folder} [root] - Root tree ancestor
 */
/**
 * @typedef {("document"|"template")} FolderGroupEnum
 */
/**
 * @typedef {Object} FolderOrderByInput
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [name]
 * @property {OrderBy} [updatedAt]
 */
/**
 * @typedef {Object} FolderPaginated
 * @property {Array<Folder>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {Object} FolderWhereInput
 * @property {string} [name]
 * @property {string} [parent]
 * @property {string} [search]
 */
/**
 * Represents a formFlow
 * @typedef {Object} FormFlow
 * @property {boolean} active - Set an active form flow
 * @property {Array<JSON>} [activeQuestions] - Questions
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {boolean} default - Set a default form flow
 * @property {string} [description] - FormFlow's description
 * @property {DocumentUnion} document - Document Id
 * @property {string} id - An unique identifier for the object.
 * @property {number} [maxQuestions] - Max number of questions per flow
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - FormFlow's name
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {FormFlowOption} [options] - Options form flow
 * @property {Array<JSON>} [questions] - Questions
 * @property {Array<JSON>} [shares] - A list of shared details.
 * @property {string} [slug] - FormFlow's slug
 * @property {string} [thumbnail] - Document content last version thumbnail
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * Represents a formFlow option
 * @typedef {Object} FormFlowOption
 * @property {boolean} [allowDownload] - Generate the pdf and download in the moment
 * @property {string} [bgColor] - Background color for each form slide
 * @property {string} [bgImage] - Background image for each form slide
 * @property {boolean} [hideBranding] - Hide watermark
 * @property {boolean} [hideLogo] - Hide account logo
 * @property {string} [mainAccentColor] - Main accent text color
 * @property {string} [mainTextColor] - Main text color
 * @property {boolean} [navigationArrows] - Show or hide the navigation arrows
 * @property {boolean} [progressBar] - Show or hide the form progress
 * @property {string} [redirectUrl] - Redirect url after flow is completed
 * @property {string} [secondaryTextColor] - Secondary text color
 * @property {string} [tertiaryTextColor] - Tertiary text color
 */
/**
 * @typedef {Object} FormFlowOptionInput
 * @property {boolean} [allowDownload] - Generate the pdf and download in the moment
 * @property {string} [bgColor] - Background color for each form slide
 * @property {string} [bgImage] - Background image for each form slide
 * @property {boolean} [hideBranding] - Hide watermark
 * @property {boolean} [hideLogo] - Hide account logo
 * @property {string} [mainAccentColor] - Main accent text color
 * @property {string} [mainTextColor] - Main text color
 * @property {boolean} [navigationArrows] - Show or hide the navigation arrows
 * @property {boolean} [progressBar] - Show or hide the form progress
 * @property {string} [redirectUrl] - Redirect url after flow is completed
 * @property {string} [secondaryTextColor] - Secondary text color
 * @property {string} [tertiaryTextColor] - Tertiary text color
 */
/**
 * @typedef {Object} FormFlowOrderByInput
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [default]
 * @property {OrderBy} [name]
 * @property {OrderBy} [slug]
 */
/**
 * @typedef {Object} FormFlowPaginated
 * @property {Array<FormFlow>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * Represents a formFlowShare
 * @typedef {Object} FormFlowShare
 * @property {Account} [account] - FormFlowShare account
 * @property {boolean} [active] - Has the value __true__ if the object is active or the value __false__ if it is not. If the __FlowShare__ has been disabled by some error, please go to [Bounsel Flow](https://www.bounsel.app/templates) and publish your flow.
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} [description] - FormFlow description
 * @property {string} [email] - An email to share this flow. If this field has not empty only the email specified can complete this flow.
 * @property {DateTime} [expiredAt] - Time at which the flowShare was expired.
 * @property {FormFlow} formFlow - Form flow Id
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - FormFlow name
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {FormFlowShareOption} [options] - Options form flow share
 * @property {boolean} [public] - Has the value __true__ if the flow has a public url to be completed, or the value __false__ if it has not.
 * @property {boolean} [secured] - Set a secured form flow
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {string} [url] - URL to access the flow
 */
/**
 * Represents a form Flow share option
 * @typedef {Object} FormFlowShareOption
 * @property {string} [customMessage] - Add custom message to send to the user
 * @property {boolean} [sendCopyCompletedDocument] - Send a copy of the generated document to a user.
 */
/**
 * @typedef {Object} FormFlowShareOptionInput
 * @property {string} [customMessage] - Add custom message to send to the user
 * @property {boolean} [sendCopyCompletedDocument] - Send a copy of the generated document to a user.
 */
/**
 * @typedef {Object} FormFlowShareOrderByInput
 * @property {OrderBy} [active]
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [expiredAt]
 * @property {OrderBy} [secured]
 */
/**
 * @typedef {Object} FormFlowSharePaginated
 * @property {Array<FormFlowShare>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * Represents a secure formFlowShare
 * @typedef {Object} FormFlowShareSecure
 * @property {string} [account] - FormFlowShare account
 * @property {string} [code] - Temporal code to access to form flow
 * @property {string} [description] - FormFlow description
 * @property {string} id - FormFlowShare Id
 * @property {string} [name] - FormFlow name
 * @property {boolean} [public] - Has the value __true__ if the flow has a public url to be completed, or the value __false__ if it has not.
 * @property {boolean} [secured] - Set a secured form flow
 */
/**
 * Represents an account integration api key
 * @typedef {Object} GenerateAccountIntegrationApiKey
 * @property {string} apiKey - Auto generate api key
 */
/**
 * @typedef {Object} ImportDocumentsInput
 * @property {string} [category] - The ID of the __Category__ attached to this document. Often useful to organize your documents.
 * @property {string} [folder] - The ID of the __Folder__ where the document is located on.
 */
/**
 * Represents a intake
 * @typedef {Object} Intake
 * @property {boolean} active - Set an active intake
 * @property {JSON} [activeQuestions] - Questions
 * @property {JSON} [activeTheme] - Theme
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {boolean} default - Set a default intake
 * @property {string} [description] - Intake's description
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Intake's name
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {IntakeOption} [options] - Options
 * @property {JSON} [questions] - Questions
 * @property {string} [slug] - Intake's slug
 * @property {JSON} [theme] - Theme
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * Represents a Intake option
 * @typedef {Object} IntakeOption
 * @property {Array<JSON>} [actions] - Complete actions
 */
/**
 * @typedef {Object} IntakeOptionInput
 * @property {Array<JSON>} [actions] - Complete actions
 */
/**
 * @typedef {Object} IntakeOrderByInput
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [default]
 * @property {OrderBy} [name]
 * @property {OrderBy} [slug]
 */
/**
 * @typedef {Object} IntakePaginated
 * @property {Array<Intake>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * Represents a intake response
 * @typedef {Object} IntakeResponse
 * @property {Contact} [contact] - Contact object
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} id - An unique identifier for the object.
 * @property {Intake} intake - Form flow Id
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {JSON} [result] - Result of the flow
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * Represents a intakeShare
 * @typedef {Object} IntakeShare
 * @property {Account} [account] - IntakeShare account
 * @property {boolean} [active] - Has the value __true__ if the object is active or the value __false__ if it is not. If the __FlowShare__ has been disabled by some error, please go to [Bounsel Flow](https://www.bounsel.app/templates) and publish your flow.
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} [description] - Intake description
 * @property {string} [email] - An email to share this flow. If this field has not empty only the email specified can complete this flow.
 * @property {DateTime} [expiredAt] - Time at which the flowShare was expired.
 * @property {string} id - An unique identifier for the object.
 * @property {Intake} intake - Form flow Id
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Intake name
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {IntakeShareOption} [options] - Options form flow share
 * @property {boolean} [public] - Has the value __true__ if the flow has a public url to be completed, or the value __false__ if it has not.
 * @property {boolean} [secured] - Set a secured form flow
 * @property {string} [slug] - Slug short url
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {string} [url] - URL to access the flow
 */
/**
 * Represents a form Flow share option
 * @typedef {Object} IntakeShareOption
 * @property {string} [customMessage] - Add custom message to send to the user
 * @property {boolean} [sendCopyCompletedDocument] - Send a copy of the generated document to a user.
 */
/**
 * @typedef {Object} IntakeShareOptionInput
 * @property {string} [customMessage] - Add custom message to send to the user
 * @property {boolean} [sendCopyCompletedDocument] - Send a copy of the generated document to a user.
 */
/**
 * @typedef {Object} IntakeShareOrderByInput
 * @property {OrderBy} [active]
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [expiredAt]
 * @property {OrderBy} [secured]
 */
/**
 * @typedef {Object} IntakeSharePaginated
 * @property {Array<IntakeShare>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * Represents a secure intakeShare
 * @typedef {Object} IntakeShareSecure
 * @property {string} [account] - IntakeShare account
 * @property {string} [code] - Temporal code to access to form flow
 * @property {string} [description] - Intake description
 * @property {string} id - IntakeShare Id
 * @property {string} [name] - Intake name
 * @property {boolean} [public] - Has the value __true__ if the flow has a public url to be completed, or the value __false__ if it has not.
 * @property {boolean} [secured] - Set a secured form flow
 * @property {string} [slug] - Slug short url
 */
/**
 * Represents an intake shares subscription
 * @typedef {Object} IntakeSharesSubscription
 * @property {CudAction} action - Action
 * @property {IntakeShare} item - Intake share object
 */
/**
 * @typedef {Object} IntakeWhereInput
 * @property {string} [name]
 * @property {string} [search]
 */
/**
 * Represents an intakes subscription
 * @typedef {Object} IntakesSubscription
 * @property {CudAction} action - Action
 * @property {Intake} item - Intake object
 */
/**
 * Represents an integration
 * @typedef {Object} Integration
 * @property {string} [avatar] - Integration url avatar
 * @property {Array<string>} [categories] - Integration's categories
 * @property {IntegrationConfig} [config] - Integration config
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {Array<string>} [groups] - Integration's groups
 * @property {string} id - An unique identifier for the object.
 * @property {string} key - A unique key name to identify the integration.
 * @property {string} name - The integration name, meant to be displayable.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {string} [subtitle] - Integration url avatar
 * @property {string} [title] - Integration url avatar
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * Represents an integration config
 * @typedef {Object} IntegrationConfig
 * @property {boolean} [beta] - Whether the integration is in beta.
 * @property {Array<JSON>} [credentials] - Credentials options for the integration.
 * @property {JSON} [credentialsOptions] - Credentials options for the integration.
 * @property {Array<JSON>} [properties] - Properties for the integration.
 */
/**
 * The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).
 * @typedef {*} JSON
 */
/**
 * @typedef {("high"|"highest"|"low"|"lowest"|"medium")} Level
 */
/**
 * Mixed scalar type: accepts string, number, boolean, JSON object, array, Date (as ISO string), bigint (as string), null, or undefined
 * @typedef {*} MIXED
 */
/**
 * Represents a marketplace item
 * @typedef {Object} MarketplaceItem
 * @property {Account} account - Document Id
 * @property {boolean} approve - Marketplace item is approved
 * @property {number} counter - Number of times that the template was used
 * @property {string} [cover] - Cover image of the item
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} currency - Currency of the value
 * @property {string} [description] - Marketplace item's description
 * @property {Document} document - Document Id
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {Array<string>} [tags] - Keywords related with the item
 * @property {string} title - Title of the item
 * @property {string} [type] - Type of marketplace item
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {number} [value] - Price of this marketplace item
 */
/**
 * @typedef {Object} MetadataInput
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 */
/**
 * @typedef {Object} Mutation
 * @property {boolean} [acceptRequestAccessDocumentPolicy]
 * @property {User} [acceptTos]
 * @property {FormFlow} [autoCreateQuestions]
 * @property {boolean} [buyMarketplaceItem]
 * @property {Document} [cloneDocument]
 * @property {Template} [cloneTemplate]
 * @property {Ticket} [cloneTicket]
 * @property {Account} [createAccount]
 * @property {Array<AccountPolicy>} [createAccountPolicies]
 * @property {AccountPolicy} [createAccountPolicy]
 * @property {AccountSaml} [createAccountSaml]
 * @property {AccountToken} [createAccountToken]
 * @property {Approval} [createApproval]
 * @property {ApprovalMessage} [createApprovalMessage]
 * @property {Document} [createDocument]
 * @property {string} [createDocumentFromTicket]
 * @property {DocumentLink} [createDocumentLink]
 * @property {Array<DocumentPolicy>} [createDocumentPolicies]
 * @property {DocumentPolicy} [createDocumentPolicy]
 * @property {DocumentRelation} [createDocumentRelation]
 * @property {DocumentRole} [createDocumentRole]
 * @property {Folder} [createFolder]
 * @property {FormFlow} [createFormFlow]
 * @property {Intake} [createIntake]
 * @property {IntakeResponse} [createIntakeResponse]
 * @property {MarketplaceItem} [createMarketplaceItem]
 * @property {Party} [createParty]
 * @property {ProfileRelation} [createProfileRelation]
 * @property {Reminder} [createReminder]
 * @property {Rule} [createRule]
 * @property {Signature} [createSignature]
 * @property {SignaturePlaceholder} [createSignaturePlaceholder]
 * @property {Template} [createTemplate]
 * @property {Ticket} [createTicket]
 * @property {boolean} [createVersionEditor]
 * @property {Deleted} [deleteAccountIntegration]
 * @property {DeletedMany} [deleteAccountPolicies]
 * @property {Deleted} [deleteAccountPolicy]
 * @property {Deleted} [deleteAccountSaml]
 * @property {Deleted} [deleteAccountToken]
 * @property {Deleted} [deleteApproval]
 * @property {DeletedMany} [deleteCategories]
 * @property {Deleted} [deleteCategory]
 * @property {Deleted} [deleteContact]
 * @property {DeletedMany} [deleteContacts]
 * @property {Deleted} [deleteDocument]
 * @property {Deleted} [deleteDocumentLink]
 * @property {DeletedMany} [deleteDocumentPolicies]
 * @property {Deleted} [deleteDocumentPolicy]
 * @property {Deleted} [deleteDocumentRelation]
 * @property {DeletedMany} [deleteDocumentRelations]
 * @property {Deleted} [deleteDocumentRole]
 * @property {DeletedMany} [deleteDocuments]
 * @property {Deleted} [deleteFolder]
 * @property {DeletedMany} [deleteFolders]
 * @property {Deleted} [deleteFormFlow]
 * @property {Deleted} [deleteFormFlowShare]
 * @property {Deleted} [deleteIntake]
 * @property {Deleted} [deleteIntakeShare]
 * @property {Deleted} [deleteMarketplaceItem]
 * @property {Deleted} [deleteOrganization]
 * @property {DeletedMany} [deleteOrganizations]
 * @property {Deleted} [deleteParty]
 * @property {Deleted} [deleteProfileRelation]
 * @property {DeletedMany} [deleteProfileRelations]
 * @property {Deleted} [deleteReminder]
 * @property {Deleted} [deleteRule]
 * @property {DeletedMany} [deleteRules]
 * @property {Deleted} [deleteSignature]
 * @property {Deleted} [deleteSignaturePlaceholder]
 * @property {Deleted} [deleteTag]
 * @property {DeletedMany} [deleteTags]
 * @property {Deleted} [deleteTemplate]
 * @property {DeletedMany} [deleteTemplates]
 * @property {Deleted} [deleteTicket]
 * @property {DeletedMany} [deleteTickets]
 * @property {Deleted} [deleteUser]
 * @property {Deleted} [deleteWebhook]
 * @property {DeletedMany} [deleteWebhooks]
 * @property {Account} [disableNotificationIdentity]
 * @property {AccountIntegration} [enableAccountIntegration]
 * @property {Account} [enableNotificationIdentity]
 * @property {Rule} [enableRule]
 * @property {GenerateAccountIntegrationApiKey} [generateAccountIntegrationApiKey]
 * @property {Document} [generateDocumentFormFlow]
 * @property {string} [generateSearchToken]
 * @property {Category} [hideCategory]
 * @property {boolean} [importDocuments]
 * @property {Template} [publishUnpublishTemplate]
 * @property {AccountPolicy} [registerAccessAccountPolicy]
 * @property {DocumentPolicy} [registerAccessDocumentPolicy]
 * @property {DocumentPolicy} [requestAccessDocumentPolicy]
 * @property {Approval} [requestApproval]
 * @property {Array<Approval>} [requestApprovals]
 * @property {Signature} [requestSignature]
 * @property {Array<Signature>} [requestSignatures]
 * @property {Approval} [reviewDocument]
 * @property {AccountPolicy} [sendAccountPolicyInvitation]
 * @property {ApprovalMessage} [sendApprovalMessage]
 * @property {DocumentPolicy} [sendDocumentPolicyInvitation]
 * @property {Done} [sendVerifyEmail]
 * @property {Signature} [signDocument]
 * @property {Document} [summarizeDocument]
 * @property {Account} [updateAccount]
 * @property {AccountDataStore} [updateAccountDataStore]
 * @property {AccountIntegration} [updateAccountIntegration]
 * @property {AccountPolicy} [updateAccountPolicy]
 * @property {AccountSaml} [updateAccountSaml]
 * @property {Approval} [updateApproval]
 * @property {Document} [updateDocument]
 * @property {DocumentContent} [updateDocumentContent]
 * @property {Document} [updateDocumentDestinationFolder]
 * @property {DocumentLink} [updateDocumentLink]
 * @property {DocumentPolicy} [updateDocumentPolicy]
 * @property {DocumentRelation} [updateDocumentRelation]
 * @property {DocumentRole} [updateDocumentRole]
 * @property {Document} [updateDocumentStatus]
 * @property {Document} [updateDocumentVersion]
 * @property {User} [updateEmail]
 * @property {Folder} [updateFolder]
 * @property {FormFlow} [updateFormFlow]
 * @property {Intake} [updateIntake]
 * @property {MarketplaceItem} [updateMarketplaceItem]
 * @property {Webhook} [updateOrCreateWebhook]
 * @property {Party} [updateParty]
 * @property {Done} [updatePassword]
 * @property {ProfileRelation} [updateProfileRelation]
 * @property {Reminder} [updateReminder]
 * @property {Rule} [updateRule]
 * @property {Signature} [updateSignature]
 * @property {SignaturePlaceholder} [updateSignaturePlaceholder]
 * @property {Template} [updateTemplate]
 * @property {Template} [updateTemplateDestinationFolder]
 * @property {Template} [updateTemplateVersion]
 * @property {Ticket} [updateTicket]
 * @property {Ticket} [updateTicketStatus]
 * @property {Ticket} [updateTicketVariables]
 * @property {User} [updateUser]
 * @property {User} [updateUserMetadata]
 * @property {DocumentContent} [updateVariables]
 * @property {boolean} [uploadContactFile]
 * @property {Array<JSON>} [uploadDataStoreFiles]
 * @property {boolean} [uploadOrganizationFile]
 * @property {Array<Category>} [upsertCategories]
 * @property {Category} [upsertCategory]
 * @property {Contact} [upsertContact]
 * @property {Array<Contact>} [upsertContacts]
 * @property {FormFlowShare} [upsertFormFlowShare]
 * @property {IntakeShare} [upsertIntakeShare]
 * @property {Organization} [upsertOrganization]
 * @property {Array<Organization>} [upsertOrganizations]
 * @property {Tag} [upsertTag]
 * @property {Array<Tag>} [upsertTags]
 * @property {Account} [verifyNotificationIdentity]
 */
/**
 * Represents a next transition state workflow
 * @typedef {Object} NextTransitionStateWorkflow
 * @property {Rule} [rule] - Workflow state transition next state rule
 * @property {string} [target] - Workflow state transition next state target
 */
/**
 * @typedef {("asc"|"desc")} OrderBy
 */
/**
 * Represents a organization
 * @typedef {Object} Organization
 * @property {Account} account - Account Id
 * @property {string} [alias] - Organization alias
 * @property {Array<JSON>} [attributes] - Organization attributes
 * @property {string} [avatar] - Avatar's organization
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - Organization name
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {JSON} [plainAttributes] - Organization attributes
 * @property {string} [registrationId] - Organization registration id
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {Object} OrganizationOrderByInput
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [name]
 */
/**
 * @typedef {Object} OrganizationPaginated
 * @property {Array<Organization>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {Object} OrganizationWhereInput
 * @property {string} [name]
 * @property {string} [search]
 */
/**
 * Represents an organization subscription
 * @typedef {Object} OrganizationsSubscription
 * @property {CudAction} action - Action
 * @property {Organization} item - Organization Id
 */
/**
 * Represents a party
 * @typedef {Object} Party
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {Document} document - Document owner of the party
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The party name.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {number} [order] - Order of the party
 * @property {PartyType} [type] - Type of party. It can be a "Person" or "Organisation".
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {Object} PartyPaginated
 * @property {Array<Party>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {("organization"|"person")} PartyType
 */
/**
 * @typedef {("active"|"pending"|"request")} PolicyStatus
 */
/**
 * @typedef {("completed"|"failed"|"pending"|"progress")} ProcessStatus
 */
/**
 * Represents a product
 * @typedef {Object} Product
 * @property {boolean} [active] - Define if product is ready to be showed to customers
 * @property {Array<Capabilities>} [capabilities] - List of features enabled buying this product
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {boolean} default - Define if product is the default one
 * @property {string} [description] - Brew description about it
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [limits]
 * @property {JSON} [metadata] - Additional information about this product in JSON format
 * @property {string} [name] - Name of product
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {number} position
 * @property {string} [slug] - Internal descriptive tag using SnakeCase format
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {Product} [upgradeProduct] - ID of product that can be upgraded to
 */
/**
 * Represents a profileRelation
 * @typedef {Object} ProfileRelation
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {Document} [document] - Document Id related with profile relation
 * @property {ProfileUnion} from - Profile relation from Id
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {ProfileUnion} [to] - Profile relation to Id
 * @property {string} [type] - Type of profile relation
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {Object} ProfileRelationOrderByInput
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [from]
 * @property {OrderBy} [to]
 * @property {OrderBy} [type]
 */
/**
 * @typedef {Object} ProfileRelationPaginated
 * @property {Array<ProfileRelation>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {Object} ProfileRelationWhereInput
 * @property {string} [from]
 * @property {string} [search]
 * @property {string} [to]
 * @property {string} [type]
 */
/**
 * Represents an profileRelation subscription
 * @typedef {Object} ProfileRelationsSubscription
 * @property {CudAction} action - Action
 * @property {ProfileRelation} item - Profile relation
 */
/**
 * Profile type
 * @typedef {(Contact|Organization)} ProfileUnion
 */
/**
 * Represents an public document link
 * @typedef {Object} PublicDocumentLink
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {Document} document - Document Id
 * @property {string} id - An unique identifier for the object.
 * @property {boolean} [isExpired] - Indicates if the document link is expired.
 * @property {boolean} [isSecure] - Indicates if the document link is secure.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {("AccountPolicyCreated"|"AccountPolicyDeleted"|"ApprovalApproved"|"ApprovalCreated"|"ApprovalDeleted"|"ApprovalMessageCreated"|"ApprovalMessageDeleted"|"ApprovalMessageUpdated"|"ApprovalRejected"|"ApprovalRequested"|"ApprovalUpdated"|"ContactCreated"|"ContactDeleted"|"ContactUpdated"|"DocumentActivated"|"DocumentArchived"|"DocumentCancelled"|"DocumentContentCreated"|"DocumentContentStatusUpdated"|"DocumentContentUpdated"|"DocumentCreated"|"DocumentDeleted"|"DocumentDestinationFolderUpdated"|"DocumentExpired"|"DocumentFullyApproved"|"DocumentFullyRejected"|"DocumentFullySigned"|"DocumentPolicyAccessed"|"DocumentPolicyCreated"|"DocumentPolicyDeleted"|"DocumentRestored"|"DocumentStatusUpdated"|"DocumentToExpired"|"DocumentUpdated"|"FolderCreated"|"FolderDeleted"|"FolderUpdated"|"FormFlowCompleted"|"FormFlowCreated"|"FormFlowDeleted"|"FormFlowShareCreated"|"FormFlowShareDeleted"|"FormFlowUpdated"|"PartyCreated"|"PartyDeleted"|"PartyUpdated"|"ReminderCreated"|"ReminderDeleted"|"ReminderNotified"|"ReminderUpdated"|"SignatureCreated"|"SignatureDeleted"|"SignatureRequested"|"SignatureSigned"|"SignatureUpdated"|"SubFormFlowCompleted"|"TagCreated"|"TagDeleted"|"TagUpdated"|"TemplateCreated"|"TemplateDeleted"|"TemplateDestinationFolderUpdated"|"TemplatePublished"|"TemplateUnPublished"|"TemplateUpdated")} PublicEvents
 */
/**
 * @typedef {Object} PublishUnpublishTemplateInput
 * @property {boolean} [published] - Has the value __true__ if the template is published or the value __false__ if it is not.
 */
/**
 * QnA object
 * @typedef {Object} QnaDocument
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {Document} [document] - Document's data
 * @property {string} id - An unique identifier for the object.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {number} [page] - Page number
 * @property {string} result - Resulted data
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {Object} Query
 * @property {PublicDocumentLink} [accessDocumentLink]
 * @property {AuditPaginated} [activityByAudit]
 * @property {AuditCursorPaginated} [activityByDocument]
 * @property {AuditCursorPaginated} [activityByEmail]
 * @property {number} [countApprovals]
 * @property {number} [countCategories]
 * @property {number} [countContacts]
 * @property {number} [countDocumentRelations]
 * @property {number} [countDocuments]
 * @property {number} [countFolders]
 * @property {number} [countFormFlows]
 * @property {number} [countIntakes]
 * @property {number} [countMarketplaceItems]
 * @property {number} [countOrganizations]
 * @property {number} [countParties]
 * @property {number} [countProfileRelations]
 * @property {number} [countReminders]
 * @property {number} [countRules]
 * @property {number} [countSignaturePlaceholders]
 * @property {number} [countSignatures]
 * @property {number} [countTags]
 * @property {number} [countTemplates]
 * @property {number} [countTickets]
 * @property {ApprovalMessagePaginated} [fetchApprovalMessages]
 * @property {ApprovalToReview} [fetchValidApproval]
 * @property {SignatureToSign} [fetchValidSignature]
 * @property {User} [me]
 * @property {QnaDocument} [qnaDocument]
 * @property {JSON} [queryAccountAnalytic]
 * @property {Account} [retrieveAccount]
 * @property {AccountDataStore} [retrieveAccountDataStore]
 * @property {string} [retrieveAccountId]
 * @property {AccountIntegration} [retrieveAccountIntegration]
 * @property {Array<AccountIntegration>} [retrieveAccountIntegrations]
 * @property {AccountPolicyPaginated} [retrieveAccountPolicies]
 * @property {AccountPolicyCursorPaginated} [retrieveAccountPoliciesByUser]
 * @property {AccountPolicy} [retrieveAccountPolicy]
 * @property {Array<AccountRole>} [retrieveAccountRoles]
 * @property {AccountSaml} [retrieveAccountSaml]
 * @property {string} [retrieveAccountSamlBySlug]
 * @property {Array<AccountToken>} [retrieveAccountTokens]
 * @property {Array<ActionNodeRule>} [retrieveActionRuleNodes]
 * @property {Array<Webhook>} [retrieveAllWebhooks]
 * @property {ApprovalMessagePaginated} [retrieveApprovalMessages]
 * @property {ApprovalPaginated} [retrieveApprovals]
 * @property {string} [retrieveBillingPortal]
 * @property {CategoryPaginated} [retrieveCategories]
 * @property {Category} [retrieveCategory]
 * @property {Contact} [retrieveContact]
 * @property {ContactPaginated} [retrieveContacts]
 * @property {Document} [retrieveDocument]
 * @property {string} [retrieveDocumentAccountId]
 * @property {string} [retrieveDocumentByGWorkspace]
 * @property {DocumentContent} [retrieveDocumentContent]
 * @property {Array<DocumentLink>} [retrieveDocumentLinks]
 * @property {DocumentPolicyPaginated} [retrieveDocumentPolicies]
 * @property {DocumentPolicyPaginated} [retrieveDocumentPoliciesByUser]
 * @property {DocumentPolicy} [retrieveDocumentPolicy]
 * @property {DocumentPolicy} [retrieveDocumentPolicyByUser]
 * @property {DocumentRelation} [retrieveDocumentRelation]
 * @property {DocumentRelationPaginated} [retrieveDocumentRelations]
 * @property {DocumentRole} [retrieveDocumentRole]
 * @property {Array<DocumentRole>} [retrieveDocumentRoles]
 * @property {Array<EnumKeyPair>} [retrieveDocumentStatusList]
 * @property {string} [retrieveDocumentType]
 * @property {DocumentPaginated} [retrieveDocuments]
 * @property {JSON} [retrieveEditorDocumentContent]
 * @property {DocumentLocked} [retrieveEditorLock]
 * @property {Folder} [retrieveFolder]
 * @property {FolderPaginated} [retrieveFolders]
 * @property {FormFlow} [retrieveFormFlow]
 * @property {FormFlowShare} [retrieveFormFlowShare]
 * @property {FormFlowSharePaginated} [retrieveFormFlowShares]
 * @property {FormFlowPaginated} [retrieveFormFlows]
 * @property {DocumentPaginated} [retrieveHotDocuments]
 * @property {TicketPaginated} [retrieveHotTickets]
 * @property {Intake} [retrieveIntake]
 * @property {IntakeShare} [retrieveIntakeShare]
 * @property {IntakeSharePaginated} [retrieveIntakeShares]
 * @property {IntakePaginated} [retrieveIntakes]
 * @property {Array<Integration>} [retrieveIntegrations]
 * @property {DocumentContent} [retrieveLastVersionDocumentContent]
 * @property {MarketplaceItem} [retrieveMarketplaceItem]
 * @property {MarketplaceItem} [retrieveMarketplaceItemByDocument]
 * @property {ReminderPaginated} [retrieveMyReminders]
 * @property {Organization} [retrieveOrganization]
 * @property {OrganizationPaginated} [retrieveOrganizations]
 * @property {PartyPaginated} [retrieveParties]
 * @property {Party} [retrieveParty]
 * @property {Product} [retrieveProduct]
 * @property {Array<Product>} [retrieveProducts]
 * @property {ProfileRelation} [retrieveProfileRelation]
 * @property {ProfileRelationPaginated} [retrieveProfileRelations]
 * @property {FormFlowShareSecure} [retrievePublicFormFlowShare]
 * @property {IntakeShareSecure} [retrievePublicIntakeShare]
 * @property {QueryBuilderOptions} [retrieveQueryBuilderOptions]
 * @property {QueryTriggerRule} [retrieveQueryRuleTriggers]
 * @property {Reminder} [retrieveReminder]
 * @property {ReminderPaginated} [retrieveReminders]
 * @property {Rule} [retrieveRule]
 * @property {Array<RuleExecution>} [retrieveRuleExecutions]
 * @property {RulePaginated} [retrieveRules]
 * @property {SecureNotification} [retrieveSecureNotification]
 * @property {SignaturePlaceholderPaginated} [retrieveSignaturePlaceholders]
 * @property {SignaturePaginated} [retrieveSignatures]
 * @property {SubscriptionProduct} [retrieveSubscription]
 * @property {Tag} [retrieveTag]
 * @property {TagPaginated} [retrieveTags]
 * @property {Template} [retrieveTemplate]
 * @property {TemplatePaginated} [retrieveTemplates]
 * @property {Ticket} [retrieveTicket]
 * @property {Array<EnumKeyPair>} [retrieveTicketStatusList]
 * @property {TicketPaginated} [retrieveTickets]
 * @property {Array<DocumentLocked>} [retrieveUsersEditor]
 * @property {Array<ValidEvent>} [retrieveValidEvents]
 * @property {FormFlowShare} [retrieveValidateFormFlowShare]
 * @property {IntakeShare} [retrieveValidateIntakeShare]
 * @property {Webhook} [retrieveWebhook]
 * @property {ValidateAccessDocumentLink} [validateAccessDocumentLink]
 * @property {Done} [verifyUser]
 */
/**
 * Represents a query builder filter options
 * @typedef {Object} QueryBuilderOptions
 * @property {Array<JSON>} [operators] - Query builder operators
 * @property {Array<JSON>} [rules] - Query builder rules
 */
/**
 * Represents a query trigger rule
 * @typedef {Object} QueryTriggerRule
 * @property {Array<JSON>} [events] - Events
 * @property {Array<JSON>} [operators] - Operators
 * @property {JSON} [output] - Output
 * @property {JSON} [rules] - Rules
 */
/**
 * @typedef {("amber"|"green"|"red")} RagStatus
 */
/**
 * Represents a reminder
 * @typedef {Object} Reminder
 * @property {Array<ReminderContact>} [contacts] - Contact
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} [description] - Reminder's description
 * @property {Document} document - Document Id
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Reminder's name
 * @property {DateTime} [notifiedAt] - Date when the notification should be sent
 * @property {DateTime} notifyAt - Date when the notification should be sent
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * Represents a reminder
 * @typedef {Object} ReminderContact
 * @property {string} [avatar] - Contact's avatar
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} [email] - Contact's email
 * @property {string} [firstName] - Contact's first name
 * @property {string} id - An unique identifier for the object.
 * @property {string} [lastName] - Contact's last name
 * @property {string} [name] - Contact's name
 * @property {SecureNotification} [notification] - Contact's notification Id
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {string} [phone] - Contact's phone number
 * @property {Reminder} [reminder] - Contact's reminder Id
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {Object} ReminderContactInput
 * @property {string} email - Contact's email
 * @property {string} firstName - Contact's first name
 * @property {string} [id] - Contact's Id
 * @property {string} [lastName] - Contact's last name
 * @property {string} [phone] - Contact's phone number
 */
/**
 * @typedef {Object} ReminderPaginated
 * @property {Array<Reminder>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * Represents a reminder subscription
 * @typedef {Object} RemindersSubscription
 * @property {CudAction} action - Action
 * @property {Reminder} item - Reminder Id
 */
/**
 * Represents a rule
 * @typedef {Object} Rule
 * @property {Account} [account] - Account Id
 * @property {Array<ActionRule>} [actions] - Rule's actions
 * @property {boolean} [active] - Rule activated
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} [cron] - Cron expression
 * @property {string} [description] - Rule's description
 * @property {Array<Events>} [events] - Rule events
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Rule's name
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {Array<string>} [tags] - Rule's tags
 * @property {JSON} [trigger] - Rule's trigger
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {Workflow} [workflow] - Workflow Id
 */
/**
 * Represents a rule execution
 * @typedef {Object} RuleExecution
 * @property {Account} [account] - Account Id
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {number} [ms] - Rule execution time in ms
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {JSON} [result] - Rule execution result
 * @property {Rule} [rule] - Rule
 * @property {RuleExecutionStatus} [status] - Rule execution status
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {("failed"|"pending"|"success")} RuleExecutionStatus
 */
/**
 * @typedef {Object} RuleOrderByInput
 * @property {OrderBy} [active]
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [name]
 * @property {OrderBy} [updatedAt]
 */
/**
 * @typedef {Object} RulePaginated
 * @property {Array<Rule>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {Object} RuleWhereInput
 * @property {string} [name]
 * @property {string} [search]
 */
/**
 * Represents an document policy subscription
 * @typedef {Object} RulesSubscription
 * @property {CudAction} [action] - Action
 * @property {Rule} [item] - Rule
 */
/**
 * Represents a secureNotification
 * @typedef {Object} SecureNotification
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {DateTime} [deliveredAt] - Date when the notification was delivered
 * @property {string} [email] - Contact's email
 * @property {DateTime} [failedAt] - Date when the notification was failed
 * @property {Array<JSON>} [history] - History tracking of this secure notification
 * @property {string} id - An unique identifier for the object.
 * @property {string} [lastName] - Contact's last name number
 * @property {string} [message] - Custom notification message
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Contact's name
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {DateTime} [openedAt] - Date when the notification was opened
 * @property {string} [phone] - Contact's phone number
 * @property {DateTime} [sentAt] - Date when the notification was sent
 * @property {CertifyOptions} [status] - Secure notification status
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {("parallel"|"sequence")} SignProcessType
 */
/**
 * Represents a signature
 * @typedef {Object} Signature
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {Document} document - Document Id
 * @property {string} email - Signature's email
 * @property {string} firstName - Signatory's first name
 * @property {string} id - An unique identifier for the object.
 * @property {string} [idNumber] - Signature's ID number
 * @property {string} [image] - Signature image
 * @property {string} lastName - Signatory's last name
 * @property {string} [message] - Custom message to send to the signatory
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {SecureNotification} [notification] - Contact secure notification
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {number} [order] - Signature order
 * @property {Party} party - Party side Id
 * @property {string} [phone] - Signature's phone
 * @property {DateTime} [requestedAt] - Date time when the signature was requested
 * @property {SignatureSettings} [settings] - Signature settings
 * @property {DateTime} [signedAt] - Date time when the signature was signed
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {Object} SignaturePaginated
 * @property {Array<Signature>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * Represents a signature placeholder
 * @typedef {Object} SignaturePlaceholder
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {Document} document - Document Id
 * @property {string} id - An unique identifier for the object.
 * @property {string} keyName - Document Id
 * @property {string} [message] - Custom message to send to the signatory
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {number} [order] - Signature order
 * @property {Party} party - Party side Id
 * @property {SignatureSettings} [settings] - Signature settings
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {Object} SignaturePlaceholderPaginated
 * @property {Array<SignaturePlaceholder>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * Represents a signature setting
 * @typedef {Object} SignatureSettings
 * @property {boolean} [allowApprovals] - Allow to view approvals before sign
 * @property {boolean} [allowBiometric] - Allow Advanced Biometric Electronic Signature
 * @property {boolean} [allowCertificate] - Allow Advanced Electronic Signature with certificate
 * @property {boolean} [allowDownload] - Allow to download the pdf before signing
 * @property {boolean} [rubricAllPages] - Rubric on all pages
 * @property {number} [sendReminders] - Send reminders each decided days
 */
/**
 * @typedef {Object} SignatureSettingsInput
 * @property {boolean} [allowApprovals] - Allow to view approvals before sign
 * @property {boolean} [allowBiometric] - Allow Advanced Biometric Electronic Signature
 * @property {boolean} [allowCertificate] - Allow Advanced Electronic Signature with certificate
 * @property {boolean} [allowDownload] - Allow to download the pdf before signing
 * @property {boolean} [rubricAllPages] - Rubric on all pages
 * @property {number} [sendReminders] - Send reminders each decided days
 */
/**
 * Represents a valid object with the data to sign
 * @typedef {Object} SignatureToSign
 * @property {Account} account - Account
 * @property {Array<Approval>} [approvals] - Approvals
 * @property {User} [author] - Author
 * @property {string} content - Pdf url
 * @property {Signature} signature - Signature
 */
/**
 * Represents a state workflow
 * @typedef {Object} StateWorkflow
 * @property {string} [colorCode] - Workflow state color code
 * @property {string} [id] - Workflow state id
 * @property {boolean} [isDefault] - Workflow state is default
 * @property {boolean} [isFinal] - Workflow state is final
 * @property {boolean} [isInitial] - Workflow state is initial
 * @property {string} [label] - Workflow state label
 * @property {JSON} [metadata] - Workflow state metadata
 * @property {string} [name] - Workflow state name
 * @property {Array<TransitionStateWorkflow>} [transition] - Workflow state transition
 */
/**
 * @typedef {Object} Subscription
 * @property {FormFlowShare} FormFlowShare
 * @property {AccountDataStore} accountDataStore
 * @property {AccountPoliciesSubscription} accountPolicies
 * @property {Approval} approval
 * @property {ApprovalMessagesSubscription} approvalMessages
 * @property {ApprovalMessagesSubscription} approvalMessagesPublic
 * @property {CategoriesSubscription} categories
 * @property {Category} category
 * @property {Contact} contact
 * @property {ContactsSubscription} contacts
 * @property {Document} document
 * @property {DocumentContent} documentContent
 * @property {DocumentPoliciesSubscription} documentPolicies
 * @property {DocumentPolicy} documentPolicy
 * @property {DocumentRelation} documentRelation
 * @property {DocumentRelationsSubscription} documentRelations
 * @property {Folder} folder
 * @property {FormFlow} formFlow
 * @property {Intake} intake
 * @property {IntakeShare} intakeShare
 * @property {IntakeSharesSubscription} intakeShares
 * @property {IntakesSubscription} intakes
 * @property {Account} myAccount
 * @property {User} myUser
 * @property {Organization} organization
 * @property {OrganizationsSubscription} organizations
 * @property {Party} party
 * @property {Product} product
 * @property {ProfileRelation} profileRelation
 * @property {ProfileRelationsSubscription} profileRelations
 * @property {Reminder} reminder
 * @property {RemindersSubscription} reminders
 * @property {Rule} rule
 * @property {RulesSubscription} rules
 * @property {SecureNotification} secureNotification
 * @property {Signature} signature
 * @property {SignaturePlaceholder} signaturePlaceholder
 * @property {SubscriptionProduct} subscriptionProduct
 * @property {Tag} tag
 * @property {TagsSubscription} tags
 * @property {Template} template
 * @property {Ticket} ticket
 * @property {Array<DocumentLocked>} usersEditor
 */
/**
 * Represents a Subscription
 * @typedef {Object} SubscriptionProduct
 * @property {Account} account - Account ID of buyer
 * @property {boolean} [cancelAtPeriodEnds]
 * @property {DateTime} [cancelledAt]
 * @property {Array<Capabilities>} [capabilities]
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {DateTime} [endsAt]
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [limits]
 * @property {JSON} [metadata]
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {number} [quantity]
 * @property {DateTime} [startedAt]
 * @property {SubscriptionStatus} status
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {("active"|"cancelled"|"failed"|"pending"|"trialing")} SubscriptionStatus
 */
/**
 * Represents a tag
 * @typedef {Object} Tag
 * @property {Account} account - Account owner of the tag
 * @property {string} [color] - The tag color. Often useful for displaying to users. The value must be a valid hexadecimal code.
 * @property {number} [count] - A number to show how many __Document__ objects are using this tag.
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - The tag name. The value must be a unique identifier.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {Object} TagOrderByInput
 * @property {OrderBy} [color]
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [name]
 */
/**
 * @typedef {Object} TagPaginated
 * @property {Array<Tag>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {Object} TagWhereInput
 * @property {string} [color]
 * @property {string} [name]
 * @property {string} [search]
 */
/**
 * Represents a tags subscription
 * @typedef {Object} TagsSubscription
 * @property {CudAction} action - The action performed on the tag
 * @property {Tag} item - The tag
 */
/**
 * Represents a template
 * @typedef {Object} Template
 * @property {boolean} [access] - Allow access to document
 * @property {Account} [account] - Account owner of the template
 * @property {User} [author] - Author template
 * @property {Category} [category] - The ID of the __Category__ attached to this document. Often useful to organize your documents.
 * @property {string} [complexity] - The complexity of the document
 * @property {DocumentContent} [content] - Content info
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} [currency] - Currency detail
 * @property {string} [description] - An arbitrary string attached to the object. Often useful for displaying to users.
 * @property {Folder} [folder] - The ID of the __Folder__ where the document is located on.
 * @property {string} id - An unique identifier for the object.
 * @property {string} [jurisdiction] - It refers to where a dispute will be resolved
 * @property {string} [language] - The language which has been wrote this document. The value must be an [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) into __lower-case__. It has upper-case/lower-case sensibility.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The document name without extension.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {Array<DocumentPermissions>} [permissions] - Current user permissions
 * @property {string} [priority] - The priority of the document
 * @property {boolean} [published] - Has the value __true__ if the template is published or the value __false__ if it is not.
 * @property {string} [role] - Current user role
 * @property {DocumentSettings} [settings] - Document settings
 * @property {string} [status] - Document status
 * @property {Array<Tag>} [tags] - A list of __Tag__ IDs attached to the document. Often useful to organize your documents.
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {string} [value] - Value of the contract
 */
/**
 * @typedef {Object} TemplateOrderByInput
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [name]
 * @property {OrderBy} [published]
 * @property {OrderBy} [updatedAt]
 */
/**
 * @typedef {Object} TemplatePaginated
 * @property {Array<Template>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * @typedef {Object} TemplateWhereInput
 * @property {string} [folderId]
 * @property {string} [name]
 * @property {string} [search]
 */
/**
 * Represents a ticket
 * @typedef {Object} Ticket
 * @property {Account} [account] - Account owner of the template
 * @property {boolean} [archived] - Ticket is archived
 * @property {User} [assignee] - Assignee of the ticket
 * @property {Category} [category] - The ID of the __Category__ attached to this ticket. Often useful to organize your tickets.
 * @property {string} [complexity] - The complexity of the ticket
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} [description] - An arbitrary string attached to the object. Often useful for displaying to users.
 * @property {DateTime} [dueDateAt] - End date of the ticke
 * @property {string} id - An unique identifier for the object.
 * @property {string} [language] - The language which has been wrote this ticket. The value must be an [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) into __lower-case__. It has upper-case/lower-case sensibility.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The ticket name without extension.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {string} [priority] - The priority of the ticket
 * @property {RagStatus} [ragStatus] - RAG status of the ticket
 * @property {string} [ref] - An unique reference number.
 * @property {string} [requester] - Requester of the ticket
 * @property {TicketSettings} [settings] - Settings of the ticket
 * @property {string} [status] - Ticket status
 * @property {JSON} [statusChecker] - Status action list of the ticket
 * @property {Array<Tag>} [tags] - A list of __Tag__ IDs attached to the ticket. Often useful to organize your tickets.
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {Array<JSON>} [variables] - Set of key-value pairs to complete a ticket. Each variable must match with your template variables.
 */
/**
 * @typedef {Object} TicketOrderByInput
 * @property {OrderBy} [assignee]
 * @property {OrderBy} [complexity]
 * @property {OrderBy} [createdAt]
 * @property {OrderBy} [dueDateAt]
 * @property {OrderBy} [language]
 * @property {OrderBy} [name]
 * @property {OrderBy} [priority]
 * @property {OrderBy} [ragStatus]
 * @property {OrderBy} [ref]
 * @property {OrderBy} [requester]
 * @property {OrderBy} [status]
 * @property {OrderBy} [updatedAt]
 */
/**
 * @typedef {Object} TicketPaginated
 * @property {Array<Ticket>} items - List of items
 * @property {number} page - A cursor for __pagination__ across multiple pages of results.
 * @property {number} pages - Total pages
 * @property {number} perPage - Items per page
 * @property {number} total - Total items
 */
/**
 * Represents a Ticket setting
 * @typedef {Object} TicketSettings
 * @property {boolean} [autoClosure] - Auto closure ticket
 */
/**
 * @typedef {Object} TicketSettingsInput
 * @property {boolean} [autoClosure] - Auto closure ticket
 */
/**
 * @typedef {("approved"|"closed"|"inProgress"|"onHold"|"open"|"rejected")} TicketStatus
 */
/**
 * @typedef {Object} TicketWhereInput
 * @property {string} [assignee]
 * @property {JSON} [filters]
 * @property {string} [name]
 * @property {string} [requester]
 * @property {string} [search]
 * @property {TicketStatus} [status]
 */
/**
 * Represents a transition state workflow
 * @typedef {Object} TransitionStateWorkflow
 * @property {string} [metadata] - Workflow state transition event
 * @property {NextTransitionStateWorkflow} [nextState] - Workflow state transition next state
 */
/**
 * @typedef {Object} UpdateAccountInput
 * @property {AccountBrandInput} [brand] - Brand details
 * @property {AccountContactInput} [contact] - Contact details
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The account name.
 * @property {AccountSettingsInput} [settings] - Account settings
 */
/**
 * @typedef {Object} UpdateAccountIntegrationInput
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {JSON} [options] - Extra options to config the integration
 */
/**
 * @typedef {Object} UpdateAccountPolicyInput
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [role] - Account role Id
 */
/**
 * @typedef {Object} UpdateAccountSamlInput
 * @property {AccountSamlConfigInput} [config] - Saml config
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [slug] - Kebab case name to identify saml account
 */
/**
 * @typedef {Object} UpdateApprovalInput
 * @property {string} [email] - Approval's email
 * @property {string} [firstName] - Signatory's first name
 * @property {string} [lastName] - Signatory's last name
 * @property {string} [message] - Custom message to send to the signatory
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {number} [order] - Approval order
 * @property {string} [phone] - Approval's phone
 */
/**
 * @typedef {Object} UpdateDocumentContentInput
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Name for the content file
 */
/**
 * @typedef {Object} UpdateDocumentInput
 * @property {string} [category] - The ID of the __Category__ attached to this document. Often useful to organize your documents.
 * @property {Level} [complexity] - The complexity of the document
 * @property {string} [currency] - Currency detail
 * @property {string} [description] - An arbitrary string attached to the object. Often useful for displaying to users.
 * @property {DateTime} [endedAt] - End date of the document
 * @property {string} [folder] - The ID of the __Folder__ where the document is located on.
 * @property {string} [jurisdiction] - It refers to where a dispute will be resolved
 * @property {string} [language] - The language which has been wrote this document. The value must be an [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) into __lower-case__. It has upper-case/lower-case sensibility.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The document name without extension.
 * @property {Level} [priority] - The priority of the document
 * @property {boolean} [public] - Make document read permission to all your organization
 * @property {string} [ref] - An unique reference number.
 * @property {boolean} [renewal] - Whether the document is automatically renewed.
 * @property {DocumentSettingsInput} [settings] - Document settings
 * @property {DateTime} [startedAt] - Start date of the document
 * @property {Array<string>} [tags] - Value of the contract
 * @property {number} [value] - Value of the contract
 */
/**
 * @typedef {Object} UpdateDocumentLinkInput
 * @property {Array<string>} [allowList] - List of allowed domains for the document link.
 * @property {Array<string>} [denyList] - List of denied domains for the document link.
 * @property {DateTime} [expiredAt] - Date when the document link expires.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Document Link name
 * @property {string} [password] - Password to access the document link.
 * @property {string} [role] - Document role Id
 */
/**
 * @typedef {Object} UpdateDocumentPolicyInput
 * @property {boolean} [important] - Mark as important a document
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [note] - Private note in the document
 * @property {string} [role] - Document role Id
 * @property {boolean} [subscribe] - Subscribe to the documents events
 */
/**
 * @typedef {Object} UpdateDocumentRelationInput
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [type] - Type of document relation
 */
/**
 * @typedef {Object} UpdateDocumentRoleInput
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - Name of the role
 * @property {Array<DocumentPermissions>} permissions - Name of the role
 */
/**
 * @typedef {Object} UpdateEmailInput
 * @property {string} email - User email
 */
/**
 * @typedef {Object} UpdateFolderInput
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} name - Folder's name
 * @property {string} [parent] - Parent folder
 */
/**
 * @typedef {Object} UpdateFormFlowInput
 * @property {boolean} [active] - Set an active form flow
 * @property {boolean} [default] - Set a default form flow
 * @property {string} [description] - FormFlow's description
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - FormFlow's name
 * @property {FormFlowOptionInput} [options] - Options form flow
 * @property {Array<JSON>} [questions] - Questions
 * @property {string} [slug] - FormFlow's slug
 */
/**
 * @typedef {Object} UpdateIntakeInput
 * @property {boolean} [active] - Set an active intake
 * @property {boolean} [default] - Set a default intake
 * @property {string} [description] - Intake's description
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Intake's name
 * @property {IntakeOptionInput} [options] - Options
 * @property {JSON} [questions] - Questions
 * @property {string} [slug] - Intake's slug
 * @property {JSON} [theme] - Theme
 */
/**
 * @typedef {Object} UpdateMarketplaceItemInput
 * @property {string} [cover] - Cover image of the item
 * @property {string} [currency] - Currency of the value
 * @property {string} [description] - Marketplace item's description
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {Array<string>} [tags] - Keywords related with the item
 * @property {string} [title] - Title of the item
 * @property {number} [value] - Price of this marketplace item
 */
/**
 * @typedef {Object} UpdateOrCreateCategoryInput
 * @property {string} [group] - Name of the group in which the category belongs to.
 * @property {string} [id] - Category id
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The category name.
 */
/**
 * @typedef {Object} UpdateOrCreateContactInput
 * @property {Array<JSON>} [attributes] - Contact attributes
 * @property {DateTime} [createdAt] - Date of creation
 * @property {string} [id] - Contact Id
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 */
/**
 * @typedef {Object} UpdateOrCreateFormFlowShare
 * @property {boolean} [active] - Has the value __true__ if the object is active or the value __false__ if it is not. If the __FlowShare__ has been disabled by some error, please go to [Bounsel Flow](https://www.bounsel.app/templates) and publish your flow.
 * @property {string} [email] - An email to share this flow. If this field has not empty only the email specified can complete this flow.
 * @property {DateTime} [expiredAt] - Time at which the flowShare was expired.
 * @property {string} formFlow - Form flow Id
 * @property {string} [id] - FormFlowShare Id
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {FormFlowShareOptionInput} [options] - Options form flow share
 * @property {boolean} [public] - Has the value __true__ if the flow has a public url to be completed, or the value __false__ if it has not.
 */
/**
 * @typedef {Object} UpdateOrCreateIntakeShare
 * @property {boolean} [active] - Has the value __true__ if the object is active or the value __false__ if it is not. If the __FlowShare__ has been disabled by some error, please go to [Bounsel Flow](https://www.bounsel.app/templates) and publish your flow.
 * @property {string} [email] - An email to share this flow. If this field has not empty only the email specified can complete this flow.
 * @property {DateTime} [expiredAt] - Time at which the flowShare was expired.
 * @property {string} [id] - IntakeShare Id
 * @property {string} intake - Form flow Id
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {IntakeShareOptionInput} [options] - Options form flow share
 * @property {boolean} [public] - Has the value __true__ if the flow has a public url to be completed, or the value __false__ if it has not.
 * @property {string} [slug] - Slug short url
 */
/**
 * @typedef {Object} UpdateOrCreateOrganizationInput
 * @property {Array<JSON>} [attributes] - Organization attributes
 * @property {DateTime} [createdAt] - Date of creation
 * @property {string} [id] - Organization Id
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 */
/**
 * @typedef {Object} UpdateOrCreateTagInput
 * @property {string} [color] - The tag color. Often useful for displaying to users. The value must be a valid hexadecimal code.
 * @property {string} [id] - Tag's id
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The tag name. The value must be a unique identifier.
 */
/**
 * @typedef {Object} UpdateOrCreateWebhookInput
 * @property {Array<PublicEvents>} eventTypes - The value must be a string that matches with the following options.
 * @property {JSON} [headers] - Extra headers to use in the request call.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} url - A unique key name to identify the webhook.
 */
/**
 * @typedef {Object} UpdatePartyInput
 * @property {string} [id] - Party's id
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The party name.
 * @property {number} [order] - Order of the party
 * @property {PartyType} type - Type of party. It can be a "Person" or "Organisation".
 */
/**
 * @typedef {Object} UpdatePasswordInput
 * @property {string} [currentPassword] - User password
 * @property {string} newPassword - User password
 */
/**
 * @typedef {Object} UpdateProfileRelationInput
 * @property {string} [document] - Document Id related with profile relation
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [type] - Type of profile relation
 */
/**
 * @typedef {Object} UpdateReminderInput
 * @property {Array<ReminderContactInput>} [contacts] - Contact
 * @property {string} [description] - Reminder's description
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Reminder's name
 * @property {DateTime} [notifyAt] - Date when the notification should be sent
 */
/**
 * @typedef {Object} UpdateRuleInput
 * @property {Array<ActionRuleInput>} [actions] - Rule's actions
 * @property {string} [cron] - Cron expression
 * @property {string} [description] - Rule's description
 * @property {Array<Events>} [events] - Rule events
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Rule's name
 * @property {Array<string>} [tags] - Rule's tags
 * @property {JSON} [trigger] - Rule's trigger
 */
/**
 * @typedef {Object} UpdateSignatureInput
 * @property {string} [email] - Signature's email
 * @property {string} [firstName] - Signatory's first name
 * @property {string} [idNumber] - Signature's ID number
 * @property {string} [lastName] - Signatory's last name
 * @property {string} [message] - Custom message to send to the signatory
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {number} [order] - Signature order
 * @property {string} [phone] - Signature's phone
 * @property {SignatureSettingsInput} [settings] - Signature settings
 */
/**
 * @typedef {Object} UpdateSignaturePlaceholderInput
 * @property {string} [message] - Custom message to send to the signatory
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {number} [order] - Signature order
 * @property {SignatureSettingsInput} [settings] - Signature settings
 */
/**
 * @typedef {Object} UpdateTemplateInput
 * @property {string} [category] - The ID of the __Category__ attached to this document. Often useful to organize your documents.
 * @property {Level} [complexity] - The complexity of the document
 * @property {string} [currency] - Currency detail
 * @property {string} [description] - An arbitrary string attached to the object. Often useful for displaying to users.
 * @property {string} [folder] - The ID of the __Folder__ where the document is located on.
 * @property {string} [jurisdiction] - It refers to where a dispute will be resolved
 * @property {string} [language] - The language which has been wrote this document. The value must be an [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) into __lower-case__. It has upper-case/lower-case sensibility.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The document name without extension.
 * @property {Level} [priority] - The priority of the document
 * @property {boolean} [public] - Make document read permission to all your organization
 * @property {boolean} [published] - Has the value __true__ if the template is published or the value __false__ if it is not.
 * @property {DocumentSettingsInput} [settings] - Document settings
 * @property {Array<string>} [tags] - Value of the contract
 * @property {number} [value] - Value of the contract
 */
/**
 * @typedef {Object} UpdateTicketInput
 * @property {string} [assignee] - Assignee of the ticket
 * @property {string} [category] - The ID of the __Category__ attached to this ticket. Often useful to organize your tickets.
 * @property {Level} [complexity] - The complexity of the ticket
 * @property {string} [description] - Description of the ticket
 * @property {DateTime} [dueDateAt] - End date of the ticke
 * @property {string} [language] - The language which has been wrote this ticket. The value must be an [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) into __lower-case__. It has upper-case/lower-case sensibility.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - The ticket name without extension.
 * @property {Level} [priority] - The priority of the ticket
 * @property {string} [ref] - An unique reference number.
 * @property {string} [requester] - Requester of the ticket
 * @property {TicketSettingsInput} [settings] - Settings of the ticket
 * @property {Array<string>} [tags] - A list of __Tag__ IDs attached to the ticket. Often useful to organize your tickets.
 */
/**
 * @typedef {Object} UpdateUserInput
 * @property {string} [avatar] - Avatar's user
 * @property {UserEmailPreferencesInput} [emailPreferences] - User's email preferences
 * @property {string} [firstName] - First name's user
 * @property {string} [language] - Language's user
 * @property {string} [lastName] - Last name's user
 * @property {string} [timezone] - Timezone's user
 */
/**
 * The `Upload` scalar type represents a file upload.
 * @typedef {*} Upload
 */
/**
 * Representsa an user
 * @typedef {Object} User
 * @property {boolean} [active] - User is active
 * @property {string} [avatar] - User avatar
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} email - User email
 * @property {UserEmailPreferences} [emailPreferences] - User email preferences
 * @property {boolean} emailVerified - If email is verified
 * @property {string} firstName - User's first name
 * @property {boolean} [hasPassword] - User has set a password
 * @property {string} id - An unique identifier for the object.
 * @property {boolean} [internal] - User is internal
 * @property {string} [language] - User language
 * @property {string} [lastName] - User's last name
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. Useful for storing additional information in a structured format.
 * @property {string} [name] - User's name
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {string} [phone] - User phone
 * @property {boolean} [phoneVerified] - If phone is verified
 * @property {string} [signatureEmail]
 * @property {string} [timezone] - User timezone
 * @property {boolean} [tos] - Terms of service accepted
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * Represents an user preferences
 * @typedef {Object} UserEmailPreferences
 * @property {boolean} [docSigned] - Document signed notification
 * @property {boolean} [signs] - Single signatures notification
 * @property {boolean} [successApprovals] - Success approvals notification
 * @property {boolean} [tips] - Product tips notification
 */
/**
 * @typedef {Object} UserEmailPreferencesInput
 * @property {boolean} [docSigned] - Document signed notification
 * @property {boolean} [signs] - Single signatures notification
 * @property {boolean} [successApprovals] - Success approvals notification
 * @property {boolean} [tips] - Product tips notification
 */
/**
 * @typedef {Object} UserInviteOrConnectInput
 * @property {string} [email]
 * @property {string} [firstName]
 * @property {string} [id] - An unique identifier for the object.
 * @property {string} [lastName]
 */
/**
 * Represents a valid event
 * @typedef {Object} ValidEvent
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {string} eventType - Event types to react in webhook.
 * @property {string} id - An unique identifier for the object.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {string} title - A unique name to identify the webhook translated to user locale.
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * Represents an public document link
 * @typedef {Object} ValidateAccessDocumentLink
 * @property {string} [accessToken] - Temporal access token to access the document link.
 * @property {string} [refreshToken] - Temporal refresh token to access the document link.
 */
/**
 * Represents a variable
 * @typedef {Object} Variable
 * @property {boolean} [approved] - Variable is approved
 * @property {boolean} [auto] - Variable is auto detected
 * @property {boolean} [deprecated] - Variable deprecated
 * @property {string} [id] - Variable id
 * @property {string} key - Variable key name
 * @property {JSON} [metadata] - Variable metadata
 * @property {string} name - Variable human name
 * @property {JSON} [options] - Variable type extra options
 * @property {boolean} [required] - Variable is required
 * @property {VariableTypes} type - Variable value
 * @property {MIXED} [val] - Variable value
 */
/**
 * @typedef {Object} VariableInput
 * @property {boolean} [approved] - Variable is approved
 * @property {boolean} [auto] - Variable auto detected
 * @property {boolean} [deprecated] - Variable deprecated
 * @property {string} [id] - Variable id
 * @property {string} [key] - Variable key name
 * @property {JSON} [metadata] - Variable metadata
 * @property {string} name - Variable human name
 * @property {JSON} [options] - Variable type extra options
 * @property {boolean} [required] - Variable is required
 * @property {VariableTypes} type - Variable value
 * @property {MIXED} [val] - Variable value
 */
/**
 * @typedef {("address"|"attachment"|"checkbox"|"country"|"currency"|"date"|"dropdown"|"email"|"file"|"geo"|"identity"|"image"|"list"|"lookup"|"matrix"|"number"|"object"|"percentage"|"phone"|"radio"|"text"|"url")} VariableTypes
 */
/**
 * Represents a webhook
 * @typedef {Object} Webhook
 * @property {Account} accountId - Account Id
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {Array<Events>} eventTypes - Event types to react in webhook.
 * @property {JSON} [headers] - Extra headers to use in the request call.
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 * @property {string} url - A unique key name to identify the webhook.
 */
/**
 * Represents a workflow
 * @typedef {Object} Workflow
 * @property {Account} account - Account id
 * @property {boolean} [active] - Workflow active
 * @property {DateTime} [createdAt] - Time at which the object was created.
 * @property {boolean} [description] - Workflow description
 * @property {string} id - An unique identifier for the object.
 * @property {JSON} [metadata] - Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
 * @property {string} [name] - Workflow name
 * @property {string} [object] - Represents the object´s type. Objects with the same type share the same value.
 * @property {Array<StateWorkflow>} [states] - Workflow states
 * @property {Array<string>} [tags] - Workflow tags
 * @property {DateTime} [updatedAt] - Time at which the object was updated.
 */
/**
 * @typedef {("sha256"|"sha512")} algorithm
 */
/**
 * @typedef {*} _FieldSet
 */
